import { Fragment, useEffect, useMemo, useState } from "react";
import { PrimaryButton } from "../../../../../components/primary/PrimaryButton";
import { FaArrowLeft } from "react-icons/fa6";
import { useWindowWidth } from "../../../../../hooks/useWindowWidth";
import ClusterText from "../component/ClusterText";

const Cluster2 = ({ onBack,  onClickHandler}) => {
  const { width } = useWindowWidth();

  const [customWidth, setCustomWidth] = useState(1219);
  const [customHeight, setCustomHeight] = useState(942);

  const responsiveRight = useMemo(() => {
    if (width < 510) {
      return "260px";
    }

    if (width < 650) {
      return "390px";
    }
    if (width < 794) {
      return "290px";
    }
    if (width < 880) {
      return "220px";
    }

    if (width < 995) {
      return "170px";
    }

    if (width < 1126) {
      return "120px";
    }

    return "50px";
  }, [width]);

  useEffect(() => {
    if (window.innerWidth < 1024) {
      setCustomWidth(500);
      setCustomHeight(386);
    }
  }, []);

  return (
    <div className="relative max-md:overflow-x-auto max-md:scrollbar-hide">
      <div
        className="max-md:hidden absolute top-20  md:top-1/4 lg:top-80"
        style={{ zIndex: 1, right: responsiveRight }}
      >
        <PrimaryButton
          className="flex flex-row items-center text-[#0195B2] mt-20 bg-[#E1EAED] text-[13px] py-1 px-2"
          variant="inner"
          style={{
            borderRadius: "3px",
          }}
          onClick={onBack}
        >
          <FaArrowLeft size={20} className="mr-2" />{" "}
          <p className="m-0 p-0">REGRESAR</p>
        </PrimaryButton>
      </div>

      <ClusterText cluster={"02"} onGoBack={onBack} />

      <svg
        width="1221" //{customWidth}//"1221"
        height="921" //{customHeight}//"921"
        viewBox="0 0 1221 921"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <rect
          x="0.818359"
          width="1220.07"
          height="921"
          fill="url(#pattern0_1545_319)"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 1, 1)}
          d="M334.151 41.6881L320.21 25.7959L317.223 70.9894L331.164 81.4187L334.151 41.6881Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 12, 1)}
          d="M719.572 200.661C718.871 201.084 718.079 201.303 717.349 201.415C716.201 201.591 715.057 201.195 714.083 200.562L692.499 186.523C691.295 185.322 691.663 184.355 691.997 184.021L708.552 164.01C710.157 162.409 711.562 163.676 712.064 164.51L720.522 196.843C720.89 198.253 720.82 199.908 719.572 200.661Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 114, 1)}
          d="M846.043 730.838C812.001 687.612 789.139 625.44 781.963 599.758L767.445 603.76C779.46 655.792 818.842 718.164 837.032 742.845L845.542 735.841L846.043 730.838Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 10)}
          d="M820.092 834.744L823.47 824.33L813.819 819.002L809.958 816.58L808.028 812.221L804.891 805.198L801.031 796.721L797.17 788.245L793.55 780.01L789.932 771.535L786.071 763.058L782.209 754.582L778.349 746.348L774.73 737.872L770.628 729.153L767.009 720.677L752.531 727.7L756.633 735.934L760.253 744.41L764.113 753.129L767.732 761.363L771.835 769.839L775.454 778.316L779.073 786.791L782.934 795.268L786.794 803.26L791.137 811.494L795.963 821.666L808.51 828.447L820.092 834.744Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 115, 1)}
          d="M829.437 697.057L849.672 727.529L837.386 693.914L832.087 680.129L828.474 668.763L824.86 658.847L821.728 649.657L819.079 641.193L816.669 632.97L814.26 624.99L811.851 617.493L809.684 609.996L807.756 602.741L806.552 597.904L796.675 596.937C794.346 597.098 789.496 598.388 788.726 602.257C788.485 603.547 788.147 606.562 788.725 608.303L791.135 615.558L793.784 623.055L796.675 630.794L799.806 638.291L803.179 646.513L806.792 654.736L811.129 663.684L815.706 673.358L821.729 683.999L829.437 697.057Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 9)}
          d="M752.099 727.53L766.639 720.527L723.819 625.958L710.613 632.227L752.099 727.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 113, 1)}
          d="M816.216 810.158L834.555 820.033L789.613 730.351L792.636 728.538L839.795 820.033L843.221 815.801C838.061 777.107 812.319 738.816 800.093 724.507C788.646 710.803 773.961 681.446 768.049 668.481C758.577 650.746 749.307 613.262 749.105 610.843C748.944 608.909 747.023 608.962 746.082 609.231C741.985 610.978 733.386 614.632 731.774 615.277C730.161 615.922 730.161 617.695 730.363 618.502L732.983 623.338L816.216 810.158Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 8)}
          d="M722.503 621.523L723.914 625.957L710.412 632.205L706.784 627.166L672.121 592.1L584.857 604.192L581.633 601.37L588.082 588.069L676.957 575.574L722.503 621.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 2)}
          d="M767.646 353.487L782.157 349.456L815.006 469.569L800.698 473.6L767.646 353.487Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 7)}
          d="M551.605 554.413L588.082 588.271L581.633 601.37L542.737 565.699L537.498 560.661L535.281 556.832L511.5 515.518L524.196 507.859L551.605 554.413Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 6)}
          d="M911.54 879.686L925.849 875.857L893.201 755.945L879.094 759.976L911.54 879.686Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 5)}
          d="M879.093 759.976L893.2 755.945L865.59 654.172L851.281 658.001L879.093 759.976Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 4)}
          d="M851.282 658.001L865.591 654.172L837.578 552.398L823.471 556.631L851.282 658.001Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 3)}
          d="M823.47 556.63L837.578 552.398L815.006 469.568L800.697 473.599L823.47 556.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 81, 1)}
          d="M744.671 211.81L782.156 349.658L767.646 353.487C755.486 308.613 731.209 218.622 730.564 216.849C729.919 215.075 730.832 214.229 731.37 214.027L740.036 211.407L744.671 211.81Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 11, 1)}
          d="M729.96 202.74C733.345 200.967 738.222 196.761 740.238 194.88C735.737 178.22 726.614 144.659 726.131 143.691C725.647 142.724 724.451 143.288 723.914 143.691C721.63 146.849 716.739 153.526 715.449 154.977C714.159 156.428 714.24 157.866 714.442 158.403C718.069 171.57 725.486 198.508 726.13 200.926C726.775 203.345 728.952 203.143 729.96 202.74Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 6)}
          d="M479.657 460.097L511.499 515.518L524.196 507.86L487.718 444.78L399.649 447.4L395.014 451.028L403.881 463.12L405.292 462.112L479.657 460.097Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 5)}
          d="M335.562 515.72L403.882 463.12L395.014 451.028L330.927 500.001H330.524L330.121 515.518L335.562 515.72Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 4)}
          d="M291.83 510.48L330.121 515.518L330.524 500C312.144 495.97 275.035 494.156 258.98 493.753L242.857 498.993L248.299 513.1L263.414 508.666L291.83 510.48Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 3)}
          d="M230.565 518.743L248.501 513.1L245.277 505.24L241.649 506.248L225.325 466.143L206.986 436.518L194.088 444.377L213.233 476.824L230.565 518.743Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 111, 1)}
          d="M804.727 593.108C809.242 596.01 814.132 593.242 816.013 591.495C809.403 559.25 790.822 520.019 782.357 504.434C780.544 504.837 775.505 507.658 774.498 508.666C773.692 509.472 770.669 512.629 769.258 514.107L770.669 515.316C775.989 521.282 795.591 569.663 804.727 593.108Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 13, 1)}
          d="M688.444 188.432L709.243 202.171C709.972 202.653 710.411 203.469 710.411 204.343C710.411 204.747 710.317 205.146 710.136 205.507L708.109 209.561C707.422 210.935 706.007 211.795 704.47 211.771L669.024 211.226C668.156 211.212 667.209 210.977 666.816 210.202C666.42 209.42 666.644 208.715 666.88 208.384C672.792 202.338 684.857 190.004 685.824 189.037C686.792 188.069 687.974 188.231 688.444 188.432Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 112, 1)}
          d="M652.371 540.508C651.887 537.928 653.781 537.687 654.789 537.888C702.552 562.072 715.45 598.549 716.256 600.766C716.901 602.539 715.988 602.58 715.45 602.378C709.163 594.962 687.437 573.895 677.361 564.289C672.121 560.325 661.037 551.995 658.618 550.383C655.595 548.368 652.975 543.732 652.371 540.508Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 109, 1)}
          d="M713.636 540.507C705.897 534.703 707.187 525.46 708.799 521.563C748.702 538.492 781.552 577.589 782.762 582.628C783.729 586.658 782.359 589.681 781.552 590.689L773.894 595.727C762.609 577.509 739.5 558.041 729.356 550.584C727.34 549.644 721.375 546.312 713.636 540.507Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 108, 1)}
          d="M772.283 506.651L780.546 501.411L773.694 489.521C767.567 491.616 760.392 497.515 757.571 500.202C742.053 511.689 728.954 510.681 726.132 510.077C723.875 509.593 720.489 508.397 719.078 507.86C715.37 510.762 712.294 515.787 711.219 517.936L724.52 524.99C746.446 529.182 765.498 514.51 772.283 506.651Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 106, 1)}
          d="M596.951 574.769L648.543 550.585L667.083 565.498C667.728 567.111 667.083 568.185 666.68 568.521L597.354 578.396C594.774 577.268 596.01 575.508 596.951 574.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 107, 1)}
          d="M741.245 601.573C726.413 556.591 681.458 525.999 660.834 516.325C658.819 516.325 652.168 520.557 651.564 526.603C651.08 531.44 655.527 533.858 657.811 534.463C691.83 547.845 717.129 588.675 725.526 607.418L741.245 601.573Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 90, 1)}
          d="M758.779 419.589L796.868 477.832L784.575 431.076C771.677 405.441 748.299 390.031 738.222 385.53C712.265 375.695 678.636 379.148 665.066 382.104L678.166 396.413C718.795 382.87 748.836 406.221 758.779 419.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 88, 1)}
          d="M774.499 408.303C776.917 409.915 777.388 407.363 777.321 405.885C775.372 399.1 771.395 385.167 771.073 383.716C770.67 381.902 768.453 381.096 766.236 382.91C764.019 384.724 755.555 385.53 754.346 386.135C753.137 386.739 751.928 388.755 755.555 390.568C758.457 392.019 769.394 402.996 774.499 408.303Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 87, 2)}
          d="M768.654 374.244L765.631 363.765L740.238 366.183L757.662 380.835C757.862 381.003 758.123 381.086 758.383 381.064C766.901 380.321 768.787 376.228 768.654 374.244Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 87, 1)}
          d="M735.2 362.153L764.422 359.734C763.079 354.495 760.271 343.692 759.787 342.403C759.304 341.113 757.705 340.656 756.966 340.589L722.503 343.612C719.118 344.418 719.48 347.441 720.085 348.852L735.2 362.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 89, 2)}
          d="M663.654 377.671L657.004 368.804L728.145 362.354L744.469 376.663C745.436 381.661 741.513 382.239 739.43 381.903C715.891 372.23 679.105 375.051 663.654 377.671Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 89, 1)}
          d="M653.982 364.773L723.309 358.727L706.985 344.821L649.952 349.658C646.727 350.142 646.458 353.487 646.727 355.099L653.982 364.773Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 86, 1)}
          d="M755.355 335.55L639.877 345.828L627.908 334.246C627.569 333.917 627.325 333.473 627.394 333.005C627.553 331.915 628.345 331.43 628.793 331.318C668.427 327.69 748.341 320.395 750.921 320.234C753.501 320.072 754.28 321.107 754.347 321.644C755.153 324.667 756.846 331.157 757.169 332.93C757.491 334.704 756.094 335.416 755.355 335.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 85, 1)}
          d="M749.307 316.001L619.924 327.287L608.321 315.195C608.016 314.877 607.796 314.464 607.855 314.027C608.009 312.887 608.912 312.384 609.418 312.269C653.462 308.615 742.267 301.267 745.133 301.105C748 300.942 748.866 301.984 748.941 302.526C749.836 305.571 751.569 311.797 751.927 313.583C752.286 315.369 750.128 315.866 749.307 316.001Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 84, 1)}
          d="M744.777 297.276L600.171 308.54L589.979 298.154C589.664 297.832 589.451 297.414 589.462 296.964C589.497 295.568 590.134 294.766 590.701 294.635C638.982 290.531 736.289 281.118 739.431 280.935C742.574 280.753 743.582 282.339 743.663 282.947C744.645 286.367 747.256 292.554 747.649 294.56C748.042 296.566 745.677 297.124 744.777 297.276Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 83, 1)}
          d="M581.633 286.376L611.46 273.075C651.229 269.38 731.452 261.91 734.193 261.588C736.934 261.265 738.022 262.662 738.223 263.401C739.097 265.887 740.924 271.422 741.246 273.679C741.569 275.937 740.037 276.635 739.231 276.702L582.036 290.205C579.94 288.754 580.894 287.048 581.633 286.376Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 82, 1)}
          d="M633.226 262.595L661.844 248.488C683.542 246.473 727.463 242.402 729.558 242.241C731.654 242.08 732.581 242.98 732.783 243.45C733.522 246.271 735.121 252.358 735.604 254.131C736.088 255.905 735.134 256.751 734.597 256.953L633.226 266.022C631.614 264.409 632.554 263.066 633.226 262.595Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 80, 1)}
          d="M715.047 221.685C719.078 223.136 722.907 222.289 724.318 221.685C725.607 220.717 726.87 221.819 727.341 222.491C728.348 225.85 730.404 233.051 730.565 234.986C730.726 236.92 729.423 237.673 728.751 237.807L681.996 241.636C680.061 240.508 681.19 238.882 681.996 238.21C691.199 233.239 710.049 223.055 711.823 222.088C713.596 221.12 714.711 221.416 715.047 221.685Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 91, 1)}
          d="M672.727 397.824L652.171 370.617C642.497 381.097 637.055 404.071 637.862 436.115C638.479 460.613 653.85 489.588 661.844 501.008C653.355 478.103 652.385 439.777 652.965 423.139C652.973 422.916 653.004 422.706 653.065 422.492C655.958 412.275 667.342 401.813 672.727 397.824Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 2)}
          d="M155.594 379.685L194.086 444.377L206.984 436.517L167.686 371.02L155.594 379.685Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 46, 1)}
          d="M166.479 367.997L167.688 371.02L155.596 379.888L68.9375 336.558L85.06 326.28L166.479 367.997Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 35, 1)}
          d="M141.689 306.933L107.631 329.908L92.5156 321.846L130.605 296.252L164.664 226.925L178.167 233.374L141.689 306.933Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 35, 2)}
          d="M174.136 208.585L164.664 226.925L178.167 233.374L186.631 217.654L228.55 160.621L223.511 142.685L174.136 208.585Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 35, 3)}
          d="M229.556 159.411L228.548 160.62L223.51 142.684L273.087 154.373L345.638 137.444L348.056 152.761L273.087 170.496L229.556 159.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 2, 1)}
          d="M338.385 45.748L336.168 78.3962C340.037 80.1697 341.677 86.7933 342.012 89.8835L352.694 144.297L371.436 139.259L352.895 62.6767L338.385 45.748Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 110, 1)}
          d="M768.453 521.363L771.275 527.409C774.17 532.891 788.335 565.566 795.056 581.218C795.056 585.41 791.697 584.846 790.017 584.04C774.701 559.856 742.254 535.471 741.448 534.261C740.642 533.052 740.843 528.619 745.076 528.619C749.308 528.619 760.19 522.774 763.213 520.557C765.632 518.784 767.714 520.356 768.453 521.363Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 73, 1)}
          d="M357.328 464.732L366.196 444.579L385.543 443.975C386.994 444.781 386.685 446.46 386.349 447.199L360.15 467.151C357.892 467.473 357.328 465.673 357.328 464.732Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 69, 1)}
          d="M399.247 363.563L403.278 354.091C414.093 350.262 436.168 342.483 437.941 341.999C439.715 341.515 440.696 342.738 440.964 343.41L450.638 362.958C450.638 365.216 449.563 365.78 449.026 365.78C433.978 366.317 403.237 367.392 400.658 367.392C398.078 367.392 398.643 364.839 399.247 363.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 70, 1)}
          d="M462.125 387.546L453.661 370.617L397.252 372.195C396.498 372.216 395.821 372.656 395.502 373.34C393.162 378.348 389.216 387.066 388.768 389.158C388.284 391.415 389.91 392.114 390.783 392.181L460.513 390.166C461.803 389.843 462.125 388.285 462.125 387.546Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 71, 1)}
          d="M387.264 396.615H391.79L463.672 394.635C464.449 394.613 465.168 395.044 465.516 395.74L472.604 409.916C472.766 412.012 471.597 412.536 470.992 412.536C441.77 413.476 382.802 415.317 380.706 415.156C378.61 414.995 378.892 413.073 379.295 412.133L385.426 397.827C385.741 397.092 386.464 396.615 387.264 396.615Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 72, 1)}
          d="M369.018 436.719L375.374 421.39C375.676 420.662 376.377 420.179 377.165 420.157L474.36 417.408C475.134 417.386 475.851 417.813 476.201 418.504L483.689 433.293C484.012 435.389 483.018 436.047 482.48 436.115C446.003 437.257 372.605 439.541 370.832 439.541C369.058 439.541 368.884 437.66 369.018 436.719Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 105, 1)}
          d="M644.913 528.215L645.316 542.524C645.638 545.426 645.114 546.554 643.703 547.159L586.267 574.164L572.764 561.871C572.603 560.742 573.234 559.788 573.57 559.452C595.134 549.04 638.826 527.933 641.083 526.804C643.341 525.676 644.577 527.274 644.913 528.215Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 104, 1)}
          d="M558.053 548.368L566.316 555.22C590.366 543.799 638.828 520.758 640.279 519.951C641.73 519.145 641.689 517.869 641.488 517.332C639.002 513.301 633.789 504.998 632.822 504.031C631.855 503.063 631.075 503.09 630.807 503.224L555.232 538.896C553.942 539.863 553.889 541.18 554.023 541.717L558.053 548.368Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 103, 1)}
          d="M552.21 535.47L557.45 533.051C580.693 522.034 627.422 499.879 628.389 499.396C629.357 498.912 629.33 497.851 629.196 497.38C627.247 492.947 623.19 483.797 622.545 482.668C621.9 481.54 620.664 481.661 620.127 481.862C594.935 493.686 544.27 517.533 543.141 518.34C542.013 519.146 542.133 520.691 542.335 521.363C544.485 525.259 548.945 533.334 549.59 534.462C550.235 535.591 551.605 535.604 552.21 535.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 102, 1)}
          d="M615.692 460.097C615.047 458.807 613.677 459.022 613.072 459.291C586.067 471.987 531.815 497.501 530.847 497.985C529.88 498.469 530.041 500.202 530.243 501.008C532.325 504.77 536.692 512.576 537.498 513.704C538.304 514.833 539.849 514.981 540.521 514.914C566.25 502.687 617.949 478.114 618.917 477.63C619.884 477.147 619.992 475.682 619.924 475.01C618.782 470.577 616.337 461.387 615.692 460.097Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 93, 1)}
          d="M651.425 516.241C656.179 514.491 657.408 507.127 657.408 503.427C617.101 449.618 640.076 381.298 641.286 379.082C642.253 377.308 641.286 376.193 640.681 375.857C637.658 374.648 631.41 372.229 630.604 372.229C629.798 372.229 629.194 373.707 628.992 374.446C603.858 439.508 631.853 495.14 649.639 515.711C650.09 516.233 650.778 516.479 651.425 516.241Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 2, 2)}
          d="M439.956 184.2L443.382 169.085L375.264 153.567L373.249 144.498L356.521 148.327C356.723 148.932 357.449 151.793 358.738 158.404C360.028 165.014 364.113 166.935 365.993 167.07L439.956 184.2Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 2, 3)}
          d="M451.644 186.82L439.955 184.2L459.504 99.1533L475.223 101.37C468.841 128.04 455.997 181.943 455.675 184.2C455.352 186.457 452.853 186.887 451.644 186.82Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 3, 1)}
          d="M535.483 124.949L602.996 129.988V114.671L527.421 108.625L508.074 107.013L479.86 101.975C479.121 104.46 477.522 110.237 477.039 113.462C476.555 116.686 477.643 117.493 478.248 117.493L507.067 122.732H516.136L535.483 124.949Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 3, 2)}
          d="M717.666 129.988H602.994V114.672H716.86L720.084 125.353C720.407 127.771 718.606 129.451 717.666 129.988Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 79, 2)}
          d="M614.685 337.767L605.616 341.999L590.703 310.762C590.864 309.311 591.845 309.754 592.315 310.157L615.895 332.93C616.378 335.348 615.29 337.162 614.685 337.767Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 79, 1)}
          d="M601.786 344.015L580.423 298.67C578.341 296.587 573.934 292.221 572.967 291.415C572 290.609 570.683 291.079 570.146 291.415C567.257 292.624 561.157 295.163 559.867 295.647C558.577 296.131 558.658 297.461 558.86 298.065C566.518 314.591 582.076 348.126 583.043 350.061C584.011 351.995 585.462 351.942 586.066 351.673L601.786 344.015Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 78, 1)}
          d="M554.024 299.476L556.644 304.917C563.832 320.032 578.369 350.665 579.014 352.277C579.659 353.889 578.745 354.695 578.208 354.897C574.11 356.979 565.673 361.225 564.705 361.547C563.738 361.87 562.69 361.144 562.287 360.741C554.36 344.216 538.264 310.56 537.297 308.141C536.33 305.723 537.297 304.984 537.902 304.917C541.126 303.573 548.14 300.604 550.397 299.476C552.654 298.347 553.756 299.005 554.024 299.476Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 77, 1)}
          d="M532.014 308.181L534.657 313.806C541.909 329.431 556.575 361.097 557.226 362.764C557.876 364.431 556.954 365.264 556.412 365.472C552.278 367.625 543.766 372.014 542.79 372.347C541.814 372.681 540.757 371.931 540.35 371.514C532.353 354.431 516.115 319.639 515.139 317.139C514.163 314.639 515.139 313.876 515.749 313.806C519.002 312.417 526.077 309.348 528.354 308.181C530.632 307.015 531.743 307.695 532.014 308.181Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 100, 1)}
          d="M529.999 414.59L532.642 420.215C539.893 435.84 557.403 473.344 558.054 475.01C558.704 476.677 557.783 477.51 557.24 477.719C553.106 479.871 544.594 484.26 543.618 484.594C542.642 484.927 541.585 484.177 541.178 483.76C533.181 466.677 514.099 426.049 513.123 423.549C512.147 421.049 513.123 420.285 513.733 420.215C516.986 418.827 524.062 415.757 526.339 414.59C528.616 413.424 529.727 414.104 529.999 414.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 96, 1)}
          d="M562.647 372.672L565.29 378.297C572.542 393.922 600.255 452.878 600.906 454.545C601.556 456.212 600.634 457.045 600.092 457.253C595.958 459.406 587.446 463.795 586.47 464.128C585.494 464.462 584.437 463.712 584.03 463.295C576.033 446.212 546.747 384.131 545.771 381.631C544.796 379.131 545.771 378.367 546.381 378.297C549.635 376.909 556.71 373.839 558.987 372.672C561.264 371.506 562.376 372.186 562.647 372.672Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 76, 1)}
          d="M510.412 317.064L513.08 322.829C520.4 338.842 535.204 371.295 535.861 373.003C536.518 374.711 535.587 375.565 535.04 375.779C530.867 377.985 522.274 382.483 521.289 382.825C520.304 383.166 519.237 382.398 518.826 381.971C510.754 364.463 494.362 328.807 493.377 326.245C492.392 323.683 493.377 322.9 493.993 322.829C497.276 321.406 504.419 318.26 506.717 317.064C509.016 315.869 510.138 316.566 510.412 317.064Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 75, 1)}
          d="M514.725 382.91L492.96 336.759L489.735 330.31C488.284 328.859 486.847 330.108 486.309 330.914C482.762 335.268 476.77 334.878 474.217 334.139C472.121 334.3 471.866 335.953 472 336.759C480.129 354.023 496.587 388.956 497.393 390.568C498.199 392.18 499.61 392.314 500.215 392.18C504.514 390.232 513.355 386.174 514.322 385.53C515.289 384.885 514.994 383.514 514.725 382.91Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 74, 1)}
          d="M465.953 335.148L468.17 339.581L493.362 392.786C493.845 394.398 493.16 395.473 492.757 395.809C488.726 397.69 480.343 401.613 479.053 402.258C477.763 402.903 476.769 401.989 476.433 401.452C467.364 382.508 449.025 344.096 448.219 342C447.413 339.904 448.555 338.843 449.226 338.574C452.384 337.633 459.384 335.511 462.124 334.543C464.865 333.576 465.819 334.543 465.953 335.148Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 92, 1)}
          d="M625.767 361.347C628.598 358.044 628.719 351.915 628.411 349.06C628.396 348.92 628.364 348.785 628.318 348.652C627.614 346.64 626.144 342.825 625.365 342.201C624.558 341.556 623.282 341.664 622.745 341.798L568.129 367.594C566.517 368.562 566.651 370.147 566.92 370.819C568.398 374.178 571.636 381.419 572.764 383.515C573.893 385.611 575.653 385.463 576.392 385.128L625.767 361.347Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 95, 1)}
          d="M617.505 385.53L621.334 373.035C621.818 369.972 619.923 369.743 618.916 370.012C606.152 375.924 580.181 387.989 578.408 388.956C576.634 389.923 576.594 391.374 576.796 391.979C578.072 394.599 580.746 400.161 581.229 401.451C581.713 402.741 583.177 402.929 583.849 402.862C594.262 397.891 615.288 387.827 616.094 387.344C616.9 386.86 617.371 385.933 617.505 385.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 101, 1)}
          d="M563.092 429.061L565.511 434.704C570.012 443.975 579.174 462.918 579.819 464.531C580.464 466.143 579.551 467.218 579.013 467.554C575.05 469.435 566.8 473.358 565.511 474.003C564.221 474.648 562.958 473.197 562.488 472.39C557.181 461.508 546.406 439.299 545.761 437.525C545.116 435.752 545.895 434.771 546.365 434.502C549.791 432.689 557.208 428.86 559.465 428.054C561.722 427.248 562.824 428.39 563.092 429.061Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 97, 1)}
          d="M541.571 383.388L543.989 389.031C548.49 398.302 557.653 417.246 558.298 418.858C558.943 420.47 558.029 421.545 557.492 421.881C553.528 423.762 545.279 427.685 543.989 428.33C542.699 428.975 541.436 427.524 540.966 426.718C535.659 415.835 524.884 393.626 524.239 391.853C523.594 390.079 524.374 389.098 524.844 388.83C528.27 387.016 535.686 383.187 537.943 382.381C540.2 381.575 541.302 382.717 541.571 383.388Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 98, 1)}
          d="M482.719 407.933L488.191 405.58C497.189 401.186 515.574 392.242 517.137 391.615C518.7 390.989 519.726 391.915 520.044 392.456C521.811 396.441 525.498 404.735 526.105 406.032C526.711 407.329 525.297 408.575 524.513 409.036C513.951 414.218 492.397 424.737 490.678 425.361C488.959 425.986 488.022 425.195 487.769 424.722C486.06 421.275 482.454 413.815 481.703 411.549C480.952 409.283 482.067 408.194 482.719 407.933Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 94, 1)}
          d="M607.735 453.985L613.207 451.171C613.603 450.967 613.817 450.529 613.735 450.091C610.284 431.71 612.786 407.019 614.751 395.125C614.884 394.317 614.048 393.694 613.311 394.052L585.349 407.666C584.854 407.907 584.647 408.503 584.886 408.999L606.377 453.53C606.622 454.037 607.235 454.242 607.735 453.985Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 99, 1)}
          d="M508.074 424.425L510.694 430.068C519.225 447.736 536.409 483.434 536.893 484.885C537.338 486.221 536.792 487.204 536.388 487.614C536.325 487.678 536.248 487.724 536.166 487.762C533.434 488.991 527.971 491.462 527.018 491.939C526.05 492.422 525.003 491.468 524.599 490.931C513.985 472.659 492.475 435.631 491.347 433.696C490.218 431.761 491.28 430.471 491.951 430.068C495.713 428.322 503.64 424.627 505.252 423.821C506.865 423.015 507.805 423.888 508.074 424.425Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 10, 1)}
          d="M715.046 137.243H695.498C684.373 154.011 648.675 188.298 632.217 203.346C632.217 205.119 633.023 205.965 633.426 206.167C638.908 207.94 648.742 208.653 652.975 208.787C678.166 189.238 715.046 141.274 716.054 139.46C716.86 138.009 715.718 137.378 715.046 137.243Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 9, 1)}
          d="M686.43 137.243H664.664C660.472 143.047 637.659 165.726 626.776 176.34C626.132 178.275 627.045 179.162 627.583 179.363L645.317 184.805C658.417 174.123 686.43 141.274 687.034 139.662C687.518 138.372 686.833 137.512 686.43 137.243Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 18, 1)}
          d="M545.962 200.122C548.219 200.122 549.858 198.509 550.396 197.703L571.556 198.711C572.524 199.517 571.959 200.525 571.556 200.928C563.294 204.69 546.526 212.294 545.559 212.616C544.591 212.939 544.35 212.079 544.35 211.609L545.962 200.122Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 14, 1)}
          d="M589.896 250.101L656.603 217.453L687.639 219.065C689.251 220.355 688.848 221.752 688.445 222.29C658.417 237.069 598.078 266.788 596.95 267.433C595.821 268.078 594.867 267.164 594.531 266.627C592.717 262.529 588.929 254.011 588.284 252.721C587.639 251.431 589.09 250.437 589.896 250.101Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 20, 1)}
          d="M485.502 312.778C486.792 313.745 489.6 311.367 490.54 310.158C497.392 302.701 510.895 283.69 516.739 274.487C516.739 272.552 515.261 272.068 514.523 272.068L454.869 300.283C455.541 307.202 456.884 321.605 456.884 323.862C456.884 326.119 458.228 326.415 458.9 326.28L464.745 323.66C464.274 320.033 464.745 313.181 471.798 310.359C479.972 307.09 483.89 311.568 485.502 312.778Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 68, 1)}
          d="M328.911 490.327L347.251 476.824C363.037 438.735 394.772 362.112 395.417 360.339C396.062 358.565 394.611 357.853 393.805 357.719L372.241 366.183C355.581 406.086 322.18 486.296 321.858 487.908C321.535 489.521 322.395 490.192 322.865 490.327H328.911Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 67, 1)}
          d="M361.561 370.416C364.624 369.932 364.449 372.229 363.979 373.438C348.528 410.856 317.466 486.095 316.821 487.707C316.176 489.319 315.477 489.588 315.209 489.521C310.305 489.05 300.174 487.989 298.884 487.505C297.595 487.022 297.541 485.691 297.675 485.087L341.408 379.283L361.561 370.416Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 66, 1)}
          d="M330.517 384.523C333.58 384.039 333.406 386.337 332.936 387.546C317.485 424.964 292.878 483.072 292.233 484.684C291.588 486.296 290.89 486.565 290.621 486.498C285.717 486.028 273.37 485.571 272.08 485.087C270.79 484.603 270.736 483.273 270.871 482.669L306.182 395.879L330.517 384.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 65, 1)}
          d="M269.461 463.927C272.363 463.443 272.417 465.472 272.081 466.547L264.697 483.586C264.404 484.262 263.763 484.723 263.028 484.784L257.167 485.272C257.033 485.283 256.901 485.308 256.773 485.345L247.429 488.071C247.338 488.097 247.243 488.118 247.149 488.129C243.368 488.574 241.726 484.951 241.212 482.277C241.069 481.535 241.454 480.811 242.101 480.42L269.461 463.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 64, 1)}
          d="M240.641 475.816L277.319 453.85L285.784 433.495C285.461 431.56 283.634 431.547 282.761 431.883C267.108 440.951 235.481 459.371 234.192 460.5C232.902 461.629 233.117 462.717 233.385 463.12C234.393 465.874 236.65 471.907 237.618 474.003C238.585 476.099 240.036 476.085 240.641 475.816Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 63, 1)}
          d="M290.823 421.605L297.675 404.273C297.836 401.532 295.727 401.787 294.652 402.258C279.134 409.311 224.922 442.766 223.713 443.773C222.745 444.579 223.041 445.721 223.31 446.192C224.855 448.879 228.106 454.575 228.751 455.865C229.396 457.155 231.035 456.94 231.774 456.671L290.823 421.605Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 62, 1)}
          d="M211.219 422.008L216.862 418.582L261.609 390.268C262.115 389.948 262.737 389.871 263.306 390.059L284.375 397.018C285.181 398.308 284.711 399.302 284.375 399.638C264.02 411.662 222.868 435.994 221.094 437.123C219.321 438.251 218.071 437.593 217.668 437.123C215.72 433.965 211.541 427.207 210.413 425.434C209.284 423.66 210.48 422.411 211.219 422.008Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 61, 1)}
          d="M198.923 402.66L204.163 399.436L234.762 380.213C235.291 379.881 235.945 379.815 236.53 380.035L254.344 386.739C254.828 387.868 254.546 388.822 254.344 389.158C239.834 398.495 210.451 417.332 209 417.977C207.549 418.621 206.111 417.708 205.574 417.17C203.357 413.677 198.802 406.368 198.319 405.079C197.835 403.789 198.52 402.929 198.923 402.66Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 60, 1)}
          d="M227.945 378.88C228.751 377.106 227.609 375.991 226.937 375.655L211.59 368.456C210.98 368.169 210.271 368.207 209.697 368.56C202.116 373.225 188.319 381.78 187.235 382.709C186.107 383.676 186.362 384.859 186.631 385.329C188.444 388.553 192.394 395.446 193.684 397.219C194.974 398.993 196.371 398.764 196.909 398.428L227.945 378.88Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 45, 1)}
          d="M203.761 367.392C204.89 365.78 203.963 364.705 203.358 364.37L181.794 352.882L162.85 341.194C154.252 335.013 136.732 322.491 135.442 321.846C134.152 321.201 132.755 321.578 132.218 321.846L118.916 330.714C117.788 332.165 118.446 333.334 118.916 333.737L173.128 362.757C175.547 366.855 180.665 375.575 181.794 377.671C182.923 379.767 184.548 379.753 185.22 379.484C190.93 376.126 202.632 369.005 203.761 367.392Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 8, 1)}
          d="M632.218 137.041H655.193C655.865 137.041 656.966 137.605 655.999 139.862C654.79 142.684 621.94 174.324 620.731 175.735C619.763 176.864 618.044 176.877 617.305 176.743C613.274 175.614 597.622 173.451 590.3 172.511C586.43 170.898 589.225 168.749 591.106 167.875C602.391 162.716 623.216 145.169 632.218 137.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 19, 1)}
          d="M507.268 297.259L519.36 279.928C538.774 271.665 578.127 254.897 580.223 253.93C582.318 252.963 583.38 253.93 583.649 254.535C585.53 258.229 589.453 266.102 590.098 268.037C590.743 269.972 589.829 270.859 589.291 271.06L510.291 303.708C506.1 302.902 506.53 299.073 507.268 297.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, '19a', 1)}
          d="M525.406 267.625L534.273 247.673C553.687 239.41 568.654 232.93 570.75 231.963C572.846 230.996 573.907 231.963 574.176 232.568C576.057 236.262 579.98 244.136 580.625 246.07C581.27 248.005 580.356 248.892 579.819 249.093L527.495 271.864C524.599 271.864 524.667 269.439 525.406 267.625Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 15, 1)}
          d="M642.157 214.679L618.108 209.793C599.26 219.278 582.548 226.503 580.456 227.479C578.363 228.454 578.416 229.889 578.704 230.485C580.31 234.307 583.787 242.387 584.847 244.129C585.908 245.871 587.175 245.746 587.676 245.466L643.3 219.065C645.171 216.855 644.019 215.286 642.157 214.679Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 16, 1)}
          d="M606.623 209.996C608.235 206.933 606.22 206.369 605.212 205.966L582.842 200.524L543.342 218.461L538.102 237.405C537.941 239.823 539.781 240.159 540.722 240.025L606.623 209.996Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 17, 1)}
          d="M554.225 186.014L575.588 176.341C595.902 175.696 626.239 183.865 638.868 188.03C639.513 189.803 639.137 190.649 638.868 190.851L624.27 203.364C623.705 203.848 622.92 203.979 622.226 203.709C599.207 194.774 569.768 191.509 554.83 190.649C552.734 189.198 553.554 186.955 554.225 186.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 7, 1)}
          d="M543.945 179.363C546.847 179.04 549.723 181.11 550.797 182.184C579.818 173.921 621.132 142.08 621.938 140.064C622.583 138.452 621.669 137.243 621.132 136.84H594.933C584.453 146.191 557.649 158.337 545.558 163.241C544.429 163.724 544.012 164.517 543.945 164.853V179.363Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 6, 1)}
          d="M584.05 138.856C584.856 136.598 583.714 135.631 583.042 135.43C576.755 134.946 554.895 133.078 544.751 132.205C543.945 132.528 543.609 133.28 543.542 133.616C543.475 140.535 543.381 154.857 543.542 156.792C543.703 158.727 545.356 158.942 546.162 158.807C558.455 153.097 583.244 141.113 584.05 138.856Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 5, 1)}
          d="M485.703 125.957L504.849 129.182C513.649 130.055 531.249 131.398 534.675 131.398C537.435 131.398 538.504 132.205 538.504 133.615V158.001C537.698 159.452 536.288 159.411 535.683 159.21L499.206 138.25L483.688 129.182C483.043 126.924 484.763 126.091 485.703 125.957Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 4, 1)}
          d="M533.064 183.998C535.16 181.096 537.699 179.564 538.707 179.161V165.658C519.225 154.507 479.819 131.962 478.046 130.995C476.272 130.028 475.292 131.129 475.023 131.801C473.881 136.033 471.516 144.981 471.194 146.916C470.871 148.851 471.731 150.006 472.201 150.342L533.064 183.998Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 23, 1)}
          d="M540.52 200.524C538.746 200.041 536.69 198.845 535.884 198.308C508.798 198.308 466.423 219.133 448.621 229.545C448.823 233.038 449.226 240.629 449.226 243.048C449.226 245.466 452.047 245.265 453.458 244.861C492.152 221.323 525.606 214.9 537.497 214.632C538.786 214.309 539.109 213.557 539.109 213.221L540.52 200.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 25, 1)}
          d="M472.199 155.583L486.307 164.047C487.314 164.652 487.718 165.861 487.516 167.07C487.314 168.28 481.269 192.867 480.865 194.68C480.543 196.131 479.388 196.494 478.85 196.494C473.879 195.419 463.614 193.189 462.324 192.867C461.034 192.544 461.115 190.717 461.317 189.844C463.601 179.633 468.33 158.727 468.975 156.792C469.62 154.858 471.393 155.18 472.199 155.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 24, 1)}
          d="M526.615 186.416C525.648 186.094 505.925 174.996 496.184 169.488C492.798 167.069 491.549 168.077 491.347 168.883C489.533 176.609 485.785 192.624 485.301 194.881C484.817 197.138 485.503 197.971 485.906 198.105L494.142 199.977C494.552 200.07 494.978 200.032 495.367 199.874C504.921 195.991 520.854 193.651 524.801 192.664C528.832 191.656 527.824 186.82 526.615 186.416Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 21, 1)}
          d="M522.583 263.402L529.839 246.877C530.645 243.813 528.831 243.451 527.823 243.652C521.173 244.257 499.004 252.116 491.145 256.55C483.285 260.984 455.473 274.083 454.264 274.486C453.297 274.809 452.921 275.83 452.854 276.3C453.257 281.07 454.103 291.012 454.264 292.624C454.425 294.237 456.212 294.505 457.086 294.438C464.341 291.415 481.31 283.918 491.145 278.114C503.438 270.859 519.359 265.417 520.77 265.216C521.898 265.055 522.449 263.94 522.583 263.402Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 22, 1)}
          d="M451.04 250.907L455.676 248.69C461.99 245.6 477.804 237.807 490.541 231.358C506.462 223.297 530.444 219.669 534.071 219.065C536.974 218.581 537.565 220.207 537.497 221.08C536.288 225.782 533.789 235.469 533.467 236.598C533.144 237.726 531.989 238.277 531.452 238.412C520.972 239.419 501.02 246.675 497.191 248.69C493.362 250.705 457.086 268.44 454.668 269.246C452.733 269.891 451.981 268.574 451.847 267.835C451.443 263.67 450.597 254.937 450.436 253.325C450.275 251.713 450.772 251.041 451.04 250.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 30, 1)}
          d="M388.163 238.21C388.485 237.082 390.85 235.053 391.992 234.18C393.121 233.857 392.866 232.702 392.597 232.164L378.636 220.918C378.28 220.632 377.825 220.431 377.39 220.568C376.388 220.882 376.594 221.925 376.877 222.491C379.43 227.395 384.656 237.404 385.14 238.21C385.745 239.218 387.76 239.621 388.163 238.21Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 26, 1)}
          d="M402.932 233.454L407.043 236.715C407.584 237.144 408.293 237.27 408.946 237.045C414.868 235.002 439.896 226.515 444.188 223.902C447.85 221.673 469.5 210.876 480.262 205.561C480.533 205.427 480.772 205.242 480.923 204.981C481.474 204.023 481.314 203.105 481.02 202.488C480.837 202.101 480.443 201.886 480.025 201.795C472.176 200.071 457.468 196.807 456.683 196.494C455.877 196.171 455.004 196.628 454.668 196.897C436.933 207.779 406.301 217.655 405.091 218.058C404.262 218.334 403.768 219.025 403.56 219.471C403.499 219.6 403.471 219.742 403.456 219.884L402.186 231.673C402.113 232.356 402.394 233.028 402.932 233.454Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 27, 1)}
          d="M445.468 192.388L411.742 184.804C408.678 184.116 407.509 185.727 407.308 186.618C406.569 193.336 405.051 207.416 404.89 209.996C404.728 212.576 406.435 212.817 407.308 212.616C420.139 207.846 445.962 197.823 446.607 195.889C447.153 194.25 446.581 193.17 446.067 192.674C445.904 192.518 445.688 192.437 445.468 192.388Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 28, 1)}
          d="M397.23 205.965L360.148 176.944C359.678 176.675 358.778 175.775 358.939 174.324C359.1 172.873 360.887 172.913 361.76 173.115L403.478 182.99L400.656 204.755C399.527 207.335 397.902 206.636 397.23 205.965Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 29, 1)}
          d="M366.815 188.401L398.373 213.336C398.916 213.765 399.199 214.442 399.121 215.13C398.552 220.085 397.583 228.394 397.433 229.141C397.327 229.671 396.925 229.881 396.548 229.944C396.207 230.001 395.881 229.833 395.613 229.615L372.049 210.53C371.779 210.312 371.571 210.027 371.444 209.703L363.968 190.533C363.843 190.212 363.791 189.86 363.885 189.529C364.323 187.99 365.554 187.918 366.339 188.14C366.515 188.19 366.672 188.287 366.815 188.401Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 42, 1)}
          d="M207.542 264.452L182.802 248.69C181.079 247.254 179.761 247.63 179.161 248.109C179.026 248.217 178.934 248.366 178.857 248.52L164.439 277.555C164.322 277.791 164.242 278.049 164.26 278.313C164.391 280.307 166.688 280.106 167.889 279.726C177.092 276.077 197.329 270.307 206.741 267.755C207.04 267.674 207.316 267.533 207.522 267.302C208.402 266.313 208.25 265.38 207.96 264.856C207.864 264.683 207.708 264.558 207.542 264.452Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 41, 1)}
          d="M192.251 225.428L197.715 228.94L244.02 257.04C244.558 257.366 244.945 257.93 244.871 258.554C244.792 259.218 244.561 259.667 244.34 259.931C244.184 260.119 243.944 260.199 243.704 260.242L218.616 264.68C218.134 264.766 217.645 264.676 217.228 264.42C206.408 257.777 185.548 244.96 183.809 243.853C182.036 242.725 182.264 240.965 182.6 240.226C184.817 235.994 189.371 227.247 189.855 226.119C190.285 225.116 191.276 225.1 191.869 225.249C192.006 225.284 192.132 225.351 192.251 225.428Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 54, 1)}
          d="M334.717 319.149L330.323 310.561L325.562 302.182C325.39 301.879 325.072 301.687 324.723 301.677L319.096 301.506C318.803 301.497 318.521 301.617 318.324 301.834L309.076 312.046C309 312.13 308.937 312.227 308.897 312.334C308.219 314.157 309.316 315 309.969 315.196L332.402 321.806C332.493 321.833 332.59 321.848 332.686 321.845C334.889 321.778 335.014 320.188 334.781 319.311C334.766 319.255 334.744 319.201 334.717 319.149Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 52, 1)}
          d="M354.305 261.991L364.785 259.774C365.792 260.782 374.256 273.479 374.659 275.091C375.063 276.703 374.256 277.711 372.644 277.711C371.032 277.711 347.856 275.897 345.438 275.091C343.503 274.446 343.96 272.672 344.43 271.866L354.305 261.991Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 53, 1)}
          d="M337.98 279.322L380.302 283.554C384.601 289.063 393.24 300.241 393.401 300.886C393.603 301.692 392.998 303.305 391.386 303.305C389.774 303.305 329.113 297.662 326.695 297.259C324.76 296.936 325.082 294.84 325.485 293.833L337.98 279.322Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 47, 1)}
          d="M173.532 310.56L193.685 303.507C203.963 309.217 224.681 320.879 225.326 321.846C225.97 322.814 225.594 323.996 225.326 324.466C222.437 327.691 216.418 334.502 215.45 335.953C214.483 337.404 212.898 337.364 212.226 337.163C199.932 329.907 174.983 315.115 173.532 313.986C172.081 312.858 172.927 311.232 173.532 310.56Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 43, 1)}
          d="M261.28 283.598L275.567 267.025C275.792 266.764 275.958 266.449 275.981 266.105C276.109 264.14 274.422 263.744 273.491 263.806C234.067 265.402 180.857 282.141 158.481 290.558C158.037 290.725 157.686 291.039 157.46 291.456C156.629 292.988 155.283 295.528 154.588 297.059C153.871 298.635 154.163 299.691 154.473 300.143C154.541 300.242 154.638 300.318 154.738 300.386L165.349 307.705C165.925 308.102 166.655 308.173 167.295 307.892C194.061 296.166 239.674 287.355 260.078 284.268C260.552 284.196 260.967 283.961 261.28 283.598Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 44, 1)}
          d="M141.085 320.638C175.868 350.291 252.44 383.131 293.531 394.206C294.005 394.334 294.491 394.276 294.929 394.055L315.679 383.585C316.029 383.408 316.342 383.138 316.465 382.766C317.091 380.876 314.888 379.932 313.596 379.686C254.116 368.433 182.346 325.856 153.428 305.498C153.255 305.377 153.074 305.285 152.868 305.24C151.129 304.867 150.169 306.081 149.827 306.923C149.77 307.062 149.713 307.201 149.638 307.331L146.971 311.954C146.811 312.231 146.588 312.465 146.32 312.637L141.085 316.002C138.667 317.776 140.078 319.832 141.085 320.638Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 31, 1)}
          d="M420.325 240.749C425.009 239.018 434.53 235.275 440.953 232.727C442.178 232.241 443.528 233.046 443.676 234.356C445.347 249.131 448.119 274.927 447.815 277.509C447.506 280.138 445.69 279.146 444.712 278.231C444.63 278.154 444.553 278.088 444.463 278.021C439.684 274.45 426.504 255.072 419.244 243.894C418.514 242.77 419.068 241.214 420.325 240.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 32, 1)}
          d="M400.366 255.459C407.038 253.613 409.159 248.355 409.481 245.283C409.536 244.755 409.723 244.218 410.187 243.963C410.83 243.609 411.553 243.509 412.16 243.52C412.792 243.533 413.28 243.992 413.559 244.559C417.664 252.89 438.387 277.035 449.003 288.922C449.285 289.238 449.452 289.623 449.494 290.045C450.32 298.392 451.892 314.54 452.049 317.21C452.197 319.728 450.43 319.831 449.308 319.519C449.119 319.466 448.954 319.372 448.798 319.251C433.775 307.603 408.539 274.257 397.387 258.465C397.15 258.129 397.006 257.732 397.1 257.331C397.421 255.953 398.803 255.563 399.735 255.536C399.947 255.53 400.162 255.515 400.366 255.459Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 40, 1)}
          d="M195.498 221.886L255.416 258.037C255.768 258.249 256.178 258.348 256.588 258.319L284.132 256.393C284.551 256.364 284.964 256.216 285.24 255.899C286.381 254.586 285.68 253.336 284.995 252.702C284.856 252.573 284.706 252.493 284.53 252.425C268.627 246.272 208.586 207.974 206.38 206.771C204.607 205.804 203.492 206.368 203.156 206.771C200.603 210.063 195.296 217.05 194.49 218.662C193.684 220.274 194.826 221.483 195.498 221.886Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 39, 1)}
          d="M327.685 255.664L330.052 251.286C330.624 250.228 330.164 248.918 329.057 248.449C302.015 236.998 222.853 188.999 220.89 187.626C219.401 186.583 218.256 186.951 217.772 187.33C217.698 187.389 217.639 187.46 217.582 187.535C215.131 190.805 210.074 197.561 208.799 199.314C207.509 201.088 208.53 202.74 209.202 203.345C216.582 209.923 273.142 240.865 300.9 255.73C301.172 255.875 301.462 255.95 301.77 255.959L325.863 256.712C326.62 256.736 327.325 256.33 327.685 255.664Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 48, 1)}
          d="M206.381 299.476C214.281 296.896 238.425 292.49 249.509 290.609C251.55 289.971 252.464 291.142 252.79 292.224C252.941 292.726 252.742 293.248 252.397 293.643L232.177 316.808C230.652 319.096 229.307 318.618 228.484 318.275C228.393 318.237 228.306 318.193 228.222 318.143L203.915 303.519C203.68 303.378 203.468 303.193 203.338 302.952C202.245 300.919 204.855 299.794 206.381 299.476Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 49, 1)}
          d="M308.392 262.816L285.851 263.38C285.293 263.394 284.779 263.626 284.411 264.044C262.666 288.772 220.118 337.252 219.479 338.371C218.834 339.5 219.479 340.319 219.882 340.588C224.786 343.007 234.795 347.924 235.601 348.246C236.19 348.482 236.672 348.445 236.967 348.355C237.139 348.303 237.268 348.183 237.386 348.047C260.956 320.841 308.034 266.543 309.16 265.417C309.912 264.665 309.871 263.931 309.621 263.405C309.408 262.959 308.887 262.804 308.392 262.816Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 38, 1)}
          d="M244.269 170.496C247.977 171.464 264.49 175.467 272.282 177.348C272.416 177.348 273.37 177.147 276.111 176.341C278.852 175.534 280.209 176.676 280.545 177.348C284.374 190.784 292.234 218.058 293.04 219.67C293.846 221.282 292.704 221.82 292.032 221.887C270.267 209.19 226.373 183.515 224.922 182.386C223.471 181.258 223.646 179.498 223.915 178.759C224.318 177.886 226.011 175.132 229.557 171.101C233.991 166.063 239.634 169.287 244.269 170.496Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 33, 1)}
          d="M387.961 252.721L390.984 257.154C398.239 276.098 450.838 326.078 451.241 327.287C451.564 328.255 451.107 329.034 450.838 329.303L433.507 335.752C406.501 316.808 371.636 261.588 370.427 259.774C369.46 258.323 370.293 257.154 370.83 256.751C374.122 255.609 381.31 253.124 383.728 252.318C386.147 251.512 387.557 252.25 387.961 252.721Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 37, 1)}
          d="M301.504 226.724C300.376 226.24 299.691 224.641 299.489 223.903C296.466 218.864 285.583 179.364 284.777 176.946C284.132 175.011 285.718 174.124 286.591 173.923C290.017 172.915 297.554 170.859 300.295 170.698C303.036 170.537 303.856 172.243 303.923 173.117C305.858 185.208 318.836 219.402 325.084 234.987C325.084 237.083 323.337 237.069 322.464 236.801C315.948 233.643 302.633 227.208 301.504 226.724Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 36, 1)}
          d="M335.72 243.047C334.591 242.563 333.906 240.965 333.704 240.226C326.494 226.925 312.992 197.904 308.462 171.514C308.117 169.504 309.402 168.693 310.276 168.491C313.702 167.483 321.239 165.428 323.98 165.267C326.721 165.105 327.54 166.812 327.607 167.685C334.152 202.539 350.275 232.366 359.299 251.31C359.299 253.406 357.552 253.392 356.679 253.124C350.163 249.966 336.848 243.531 335.72 243.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 34, 1)}
          d="M350.073 161.226L351.283 166.667C353.701 185.208 372.846 225.179 382.117 242.846C382.6 245.104 381.378 246.205 380.706 246.474C376.877 247.885 368.856 250.787 367.405 251.109C365.591 251.512 364.382 248.892 364.18 248.691C349.469 228.135 332.943 169.489 331.935 166.667C331.129 164.41 332.271 163.443 332.943 163.241C336.369 162.368 343.826 160.46 346.244 159.815C348.663 159.17 349.805 160.487 350.073 161.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 56, 1)}
          d="M306.541 319.226C307.992 319.549 327.299 325.003 336.771 327.69C338.478 328.174 339.632 328.967 339.996 329.303L344.631 337.968C344.631 340.185 343.22 340.588 342.011 340.387C340.802 340.185 300.294 328.496 298.682 327.892C297.392 327.408 297.472 326.078 297.674 325.473C299.085 323.66 302.108 319.871 302.914 319.226C303.921 318.42 304.728 318.823 306.541 319.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 58, 1)}
          d="M325.755 355.8L341.247 348.707C341.614 348.539 341.94 348.27 342.083 347.892C342.492 346.806 342.1 345.953 341.685 345.483C341.519 345.295 341.292 345.192 341.05 345.126C326.284 341.061 296.933 332.924 294.854 332.125C292.967 331.399 291.809 332.035 291.352 332.561C291.261 332.667 291.179 332.779 291.082 332.88C289.078 334.961 285.072 339.306 283.971 341.194C282.908 343.016 283.907 344.147 284.644 344.553C284.731 344.601 284.825 344.633 284.921 344.66L324.374 355.905C324.832 356.035 325.322 355.998 325.755 355.8Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 50, 1)}
          d="M300.899 285.57L305.535 280.33L320.246 263.401C327.703 263.2 342.858 262.797 343.825 262.797C344.793 262.797 344.9 263.872 344.833 264.409L316.618 296.05C312.588 295.042 302.109 288.996 300.899 287.988C299.932 287.182 300.496 286.04 300.899 285.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 55, 1)}
          d="M335.765 302.902L378.49 306.933C379.901 306.933 380.303 308.344 379.497 308.747C378.691 309.15 346.043 322.048 344.229 322.652C342.778 323.136 341.609 321.779 341.206 321.04L333.145 305.321C332.823 303.063 334.757 302.768 335.765 302.902Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 59, 1)}
          d="M280.745 348.448L325.082 360.54C340.559 352.479 391.453 333.401 414.965 324.869C418.862 328.564 426.654 335.994 426.654 336.155C426.654 338.09 425.445 338.842 424.84 338.976C405.09 344.216 352.49 366.721 327.5 378.074C306.34 373.841 271.071 362.153 269.459 361.749C268.169 361.427 268.25 359.868 268.451 359.13C271.273 355.838 277.037 349.093 277.52 348.448C278.004 347.803 279.871 348.18 280.745 348.448Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 57, 1)}
          d="M346.847 326.683L352.691 324.667C366.328 319.159 394.005 307.98 395.618 307.336C397.23 306.691 398.305 307.067 398.641 307.336C402.335 311.366 409.725 319.548 409.725 320.032C409.725 320.637 408.919 322.652 406.702 323.055C399.044 324.869 356.52 342.402 354.908 343.007C353.618 343.49 352.221 342.133 351.684 341.394C350.071 338.304 346.605 331.681 345.637 329.907C344.67 328.134 346.04 327.019 346.847 326.683Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          className={"cursor-pointer"}
          onClick={() => onClickHandler(2, 51, 1)}
          d="M245.073 352.277L261.8 358.928L310.974 302.902C311.243 302.365 311.095 301.129 308.354 300.484C304.928 299.678 296.665 293.631 296.061 293.228C295.456 292.825 294.448 293.228 293.642 294.035C292.836 294.841 245.073 349.657 244.267 350.665C243.622 351.471 244.535 352.076 245.073 352.277Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <defs>
          <pattern
            id="pattern0_1545_319"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              href="#image0_1545_319"
              transform="matrix(0.000332601 0 0 0.00044094 -0.285831 -0.000362019)"
            />
          </pattern>
          <image
            id="image0_1545_319"
            width="4096"
            height="2304"
            href="/background-cluster2.png"
          />
        </defs>
      </svg>

      {/* <svg
        width={customWidth} //"1219"
        height={customHeight}
        viewBox="0 0 1772 996"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        xlink="http://www.w3.org/1999/xlink"
      >
        <rect width="1771.79" height="996" fill="url(#pattern0_481_5034)" />
        <Fragment
          className={"cursor-pointer"}
          style={{ backgroundColor: "red" }}
        >
          <path
            d="M1357.39 932.465L1355.39 923.466L1340.39 927.465L1342.89 936.965L1357.39 932.465Z "
            fill="black"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1355.39 923.466L1352.39 913.467L1337.39 917.966L1340.39 927.466L1355.39 923.466Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1334.39 907.467L1349.89 903.468L1352.39 913.467L1337.39 917.967L1334.39 907.467Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1331.89 897.967L1346.89 893.968L1349.89 903.467L1334.39 907.467L1331.89 897.967Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1328.89 887.968L1344.39 883.969L1346.89 893.968L1331.89 897.968L1328.89 887.968Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1326.9 878.469L1341.9 874.47L1344.4 883.969L1328.9 887.969L1326.9 878.469Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1323.89 868.47L1338.89 864.471L1341.89 874.47L1326.89 878.47L1323.89 868.47Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1321.4 858.471L1336.4 854.472L1338.9 864.471L1323.9 868.471L1321.4 858.471Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1318.39 848.972L1333.89 844.473L1336.39 854.472L1321.39 858.472L1318.39 848.972Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1315.9 838.972L1330.9 834.473L1333.9 844.472L1318.4 848.971L1315.9 838.972Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1328.4 824.474L1330.9 834.473L1315.9 838.972L1313.4 828.973L1328.4 824.474Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1325.4 814.975L1328.4 824.474L1313.4 828.973L1310.4 819.474L1325.4 814.975Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
          <path
            d="M1322.9 804.976L1325.4 814.975L1310.4 819.474L1307.9 809.475L1322.9 804.976Z"
            fill="#0096B3"
            fill-opacity="0.64"
            stroke="#6D6859"
            stroke-opacity="0.6"
          />
        </Fragment>
        <path
          d="M1320.39 795.477L1322.89 804.976L1307.89 809.475L1304.89 799.476L1320.39 795.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1317.39 785.478L1320.39 795.477L1304.89 799.476L1302.39 789.977L1317.39 785.478Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1314.89 775.479L1317.39 785.478L1302.39 789.977L1299.89 779.978L1314.89 775.479Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1312.4 765.479L1314.9 775.478L1299.9 779.977L1296.9 769.978L1312.4 765.479Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1309.39 755.979L1312.39 765.479L1296.89 769.978L1294.39 760.479L1309.39 755.979Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1306.9 745.98L1309.4 755.98L1294.4 760.479L1291.4 750.48L1306.9 745.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1303.89 735.981L1306.89 745.981L1291.39 750.48L1288.89 740.481L1303.89 735.981Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1301.4 726.482L1303.9 735.982L1288.9 740.481L1285.9 730.482L1301.4 726.482Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1298.9 716.982L1301.4 726.482L1285.9 730.481L1283.4 720.982L1298.9 716.982Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1295.9 706.483L1298.9 716.983L1283.4 720.982L1280.9 710.983L1295.9 706.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1293.4 696.984L1295.9 706.484L1280.9 710.983L1277.9 700.984L1293.4 696.984Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1290.9 686.985L1293.4 696.985L1277.9 700.984L1275.4 691.485L1290.9 686.985Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1287.9 676.986L1290.9 686.986L1275.4 691.485L1272.9 681.486L1287.9 676.986Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1285.4 667.486L1287.9 676.986L1272.9 681.485L1270.4 671.486L1285.4 667.486Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1282.4 657.487L1285.4 667.486L1270.4 671.486L1267.4 661.487L1282.4 657.487Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1279.9 647.488L1282.4 657.487L1267.4 661.487L1264.9 651.988L1279.9 647.488Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1277.4 637.489L1279.9 647.488L1264.9 651.988L1261.9 641.989L1277.4 637.489Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1274.9 627.99L1277.4 637.489L1261.9 641.989L1259.4 632.49L1274.9 627.99Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1271.9 617.99L1274.9 627.989L1259.4 632.489L1256.4 622.49L1271.9 617.99Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1269.4 607.991L1271.9 617.99L1256.4 622.49L1253.9 612.491L1269.4 607.991Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1266.4 598.492L1269.4 607.991L1253.9 612.491L1251.4 602.492L1266.4 598.492Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1263.9 588.493L1266.4 598.492L1251.4 602.492L1248.9 592.993L1263.9 588.493Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1261.4 578.494L1263.9 588.493L1248.9 592.993L1245.9 582.994L1261.4 578.494Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1258.4 568.995L1261.4 578.494L1245.9 582.994L1243.4 573.495L1258.4 568.995Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1255.9 558.995L1258.4 568.994L1243.4 573.494L1240.4 563.495L1255.9 558.995Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1252.9 549.496L1255.9 558.995L1240.4 563.495L1237.9 553.496L1252.9 549.496Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1250.4 539.497L1252.9 549.496L1237.9 553.496L1235.4 543.497L1250.4 539.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1247.4 529.498L1250.4 539.497L1235.4 543.497L1232.4 533.998L1247.4 529.498Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1244.9 519.498L1247.4 529.497L1232.4 533.997L1229.9 523.998L1244.9 519.498Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1242.4 509.999L1244.9 519.498L1229.9 523.998L1227.4 513.999L1242.4 509.999Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1239.9 500L1242.4 509.999L1227.4 513.999L1224.4 504.5L1239.9 500Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1237.28 490.252L1239.74 500.067L1231.86 502.133L1229.4 492.318L1237.28 490.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1224.24 504.198L1231.99 502.132L1229.4 492.317L1221.65 494.384L1224.24 504.198Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1234.19 479.92L1237.15 490.334L1229.26 492.317L1226.3 481.903L1234.19 479.92Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1222.02 494.384L1229.4 492.4L1226.45 481.986L1219.07 484.466L1222.02 494.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1231.73 470.622L1234.05 479.662L1226.3 481.986L1223.98 472.688L1231.73 470.622Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.94 484.569L1226.3 482.094L1223.85 472.688L1216.49 474.755L1218.94 484.569Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.89 460.55L1231.73 470.623L1223.98 472.689L1221.14 462.616L1228.89 460.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1213.65 464.941L1216.49 474.755L1223.98 472.689L1221.14 462.616L1213.65 464.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.89 460.55L1226.04 450.735L1218.55 452.802L1221.14 462.616L1228.89 460.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1211.06 455.125L1218.55 452.801L1221.14 462.615L1213.65 464.94L1211.06 455.125Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1223.46 440.921L1226.05 450.735L1218.56 452.802L1215.71 443.245L1223.46 440.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1208.22 445.311L1211.07 455.126L1218.56 452.801L1215.71 443.245L1208.22 445.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1220.88 431.105L1223.46 440.92L1215.71 443.245L1213.13 433.172L1220.88 431.105Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1205.38 435.496L1208.22 445.311L1215.71 443.245L1213.13 433.172L1205.38 435.496Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.04 421.291L1220.88 431.106L1213.13 433.172L1210.55 423.357L1218.04 421.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1202.8 425.424L1210.55 423.357L1213.13 433.172L1205.38 435.496L1202.8 425.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1215.46 411.219L1218.04 421.292L1210.55 423.358L1207.71 413.543L1215.46 411.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1200.22 415.609L1207.71 413.543L1210.55 423.358L1202.8 425.424L1200.22 415.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1197.38 405.794L1200.22 415.609L1207.71 413.543L1204.87 403.47L1197.38 405.794Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1212.62 401.404L1204.87 403.471L1207.71 413.543L1215.46 411.219L1212.62 401.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1210.03 391.59L1212.62 401.404L1204.87 403.471L1202.29 393.914L1210.03 391.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1194.79 395.98L1202.28 393.914L1204.87 403.47L1197.38 405.795L1194.79 395.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1191.95 386.165L1194.79 395.98L1202.28 393.914L1199.7 383.841L1191.95 386.165Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1207.19 381.774L1210.03 391.589L1202.28 393.913L1199.7 383.841L1207.19 381.774Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1204.61 371.702L1207.19 381.775L1199.44 383.841L1196.86 374.027L1204.61 371.702Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.37 376.351L1196.86 374.026L1199.44 383.841L1191.95 386.165L1189.37 376.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1194.28 364.212L1196.86 374.027L1204.61 371.702L1202.03 361.888L1194.28 364.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1186.53 366.536L1194.28 364.212L1196.86 374.026L1189.37 376.351L1186.53 366.536Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1191.7 354.398L1194.28 364.212L1202.03 361.888L1199.19 352.073L1191.7 354.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1183.95 356.464L1191.69 354.397L1194.28 364.212L1186.53 366.537L1183.95 356.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1188.85 344.583L1191.69 354.397L1199.18 352.073L1196.34 342.517L1188.85 344.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1183.95 356.464L1191.69 354.398L1188.85 344.583L1181.36 346.908L1183.95 356.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1178.52 336.834L1181.36 346.907L1188.85 344.583L1186.27 334.51L1178.52 336.834Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1193.76 332.443L1196.34 342.516L1188.85 344.582L1186.27 334.51L1193.76 332.443Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1191.18 322.629L1193.76 332.443L1186.27 334.51L1183.43 324.695L1191.18 322.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1175.94 327.02L1178.52 336.834L1186.27 334.51L1183.43 324.695L1175.94 327.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1173.1 317.205L1175.94 327.019L1183.43 324.695L1180.59 315.139L1173.1 317.205Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1188.59 312.814L1191.18 322.629L1183.43 324.695L1180.59 315.139L1188.59 312.814Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1185.75 303L1188.6 312.815L1180.59 315.139L1178.01 305.325L1185.75 303Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1170.52 307.39L1173.1 317.205L1180.59 315.139L1178.01 305.324L1170.52 307.39Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1183.17 293.443L1185.75 303L1178 305.324L1175.42 295.51L1183.17 293.443Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1167.93 297.576L1170.52 307.391L1178.01 305.324L1175.42 295.51L1167.93 297.576Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1180.59 283.112L1183.17 293.443L1175.16 295.51L1172.84 285.437L1180.59 283.112Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1165.09 287.504L1167.93 297.577L1175.16 295.51L1172.84 285.438L1165.09 287.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1177.75 273.298L1180.59 283.112L1172.58 285.437L1170 275.622L1177.75 273.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1162.51 277.689L1165.09 287.504L1172.58 285.438L1170 275.623L1162.51 277.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1175.16 263.742L1177.75 273.298L1170 275.623L1167.42 265.808L1175.16 263.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1159.93 267.874L1162.51 277.688L1170 275.622L1167.42 265.808L1159.93 267.874Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1172.32 253.928L1175.16 263.742L1167.41 265.809L1164.83 255.994L1172.32 253.928Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1157.09 258.059L1159.93 267.874L1167.42 265.808L1164.83 255.993L1157.09 258.059Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1169.74 243.854L1172.32 253.927L1164.83 255.994L1161.99 246.179L1169.74 243.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1154.5 248.245L1157.08 258.059L1164.83 255.993L1161.99 246.179L1154.5 248.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1166.9 234.04L1169.74 243.855L1161.99 246.179L1159.15 236.106L1166.9 234.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1151.66 238.431L1154.5 248.246L1161.99 246.179L1159.15 236.106L1151.66 238.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1164.83 225.775L1166.9 234.04L1159.15 236.106L1156.57 226.292C1157.26 226.033 1159 225.465 1160.44 225.259C1161.89 225.052 1163.97 225.517 1164.83 225.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1149.23 229.813L1151.67 238.436L1159.16 236.111L1156.31 226.292C1155.59 226.434 1154.3 226.739 1152.96 227.323C1151.62 227.908 1149.83 229.141 1149.23 229.813Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1157.86 200.464L1159.93 207.696L1152.69 213.636L1149.85 203.047L1157.86 200.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1147.79 216.477L1152.69 213.636L1150.11 203.821L1143.14 205.888C1143.57 208.47 1144.64 213.946 1145.46 215.186C1146.29 216.425 1147.36 216.563 1147.79 216.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1155.28 191.166L1157.86 200.464L1149.85 203.047L1147.01 193.491L1155.28 191.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.04 195.557L1143.14 205.889L1150.11 203.822L1147.01 193.491L1140.04 195.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1137.2 185.226L1140.04 195.557L1147.01 193.491L1144.43 183.16L1137.2 185.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1152.69 181.868L1155.28 191.166L1147.01 193.491L1144.69 184.193L1152.69 181.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1150.11 172.57L1152.69 181.868L1144.69 184.193L1142.11 174.895L1150.11 172.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1134.36 174.894L1137.2 185.225L1144.43 183.159L1141.59 172.828L1134.36 174.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1147.53 163.272L1150.11 172.57L1142.11 174.895L1139.52 165.597L1147.53 163.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1144.69 152.941L1147.53 163.272L1139.52 165.597L1137.71 159.915C1139.01 158.107 1141.8 154.233 1142.62 153.199C1143.45 152.166 1144.34 152.597 1144.69 152.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1132.29 166.889L1134.36 174.895L1141.59 172.829L1137.71 159.915L1132.29 166.889Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1139.18 210.48L1134.36 192.458L1127.38 200.465L1139.02 210.581C1139.09 210.646 1139.2 210.575 1139.18 210.48Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1133.32 214.153C1138.49 214.153 1139.44 211.828 1139.26 210.795L1129.71 202.53L1124.54 208.471L1133.32 214.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1132.29 184.451L1134.36 192.458L1127.38 200.464L1122.22 196.074L1132.29 184.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1116.02 203.047L1124.54 208.471L1129.71 202.53L1122.22 196.073L1116.02 203.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1129.45 174.12L1132.29 184.451L1129.97 187.034L1121.7 179.802C1122.73 178.425 1125.06 175.36 1126.09 174.12C1127.13 172.88 1128.76 173.604 1129.45 174.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1121.7 179.802L1129.97 187.034L1125.06 192.716L1116.79 185.484L1121.7 179.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1112.15 190.908L1116.8 185.484L1125.06 192.716L1120.15 198.398L1112.15 190.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1107.75 195.815L1112.15 190.908L1120.15 198.398L1116.02 203.047C1113.61 201.498 1108.63 198.243 1108.01 197.623C1107.39 197.004 1107.58 196.16 1107.75 195.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1128.16 216.478L1123.77 213.379L1117.05 222.677L1121.19 225.26C1122.05 225.346 1123.72 225.466 1124.54 225.26C1125.37 225.053 1127.38 220.783 1128.42 218.544L1128.16 216.478Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1117.57 209.246L1123.77 213.379L1117.05 222.677L1111.11 218.802L1117.57 209.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.85 225.26H1120.93L1108.53 217.253L1102.85 225.26Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1104.4 214.153L1110.86 218.802L1117.57 209.246L1112.41 206.146L1104.4 214.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.85 225.259L1108.53 217.253L1104.4 214.153L1093.55 225.259H1102.85Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1082.44 225.259H1093.55L1095.62 223.193L1088.13 215.961L1081.15 222.934C1080.74 224.174 1081.84 225.001 1082.44 225.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1093.55 210.537L1088.13 215.961L1095.62 223.193L1101.04 217.769L1093.55 210.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1106.46 212.087L1101.04 217.769L1093.55 210.538L1098.97 204.855L1106.46 212.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.85 200.981L1098.97 204.855L1106.46 212.087L1112.41 206.146C1110.25 204.683 1105.74 201.601 1104.92 200.981C1104.09 200.361 1103.19 200.723 1102.85 200.981Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1243.87 865.012L1260.66 873.794L1253.94 860.363L1243.87 865.012Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1250.84 854.424L1253.94 860.364L1243.87 865.013C1243.35 864.755 1242.21 864.135 1241.8 863.722C1241.39 863.309 1240.08 860.795 1239.48 859.589L1250.84 854.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1236.89 853.649L1239.48 859.589L1250.84 854.424L1248 848.483L1236.89 853.649Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1244.9 842.284L1248 848.483L1236.89 853.648L1234.05 847.45L1244.9 842.284Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1241.8 836.344L1244.9 842.284L1234.05 847.45L1230.95 841.251L1241.8 836.344Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.11 834.794L1230.95 841.251L1241.8 836.344L1238.44 829.887L1228.11 834.794Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1225.01 827.821L1228.11 834.794L1238.44 829.887L1235.08 823.172L1225.01 827.821Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1221.91 820.847L1225.01 827.82L1235.08 823.171L1231.47 816.456L1221.91 820.847Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.55 813.615L1221.91 820.847L1231.47 816.456L1227.85 809.225L1218.55 813.615Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1215.2 806.126L1218.55 813.616L1227.85 809.225L1224.24 801.993L1215.2 806.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1211.84 798.377L1215.2 806.125L1224.24 801.992L1220.36 794.244L1211.84 798.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1207.96 790.112L1211.84 798.377L1220.36 794.245L1215.97 786.238L1207.96 790.112Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1204.09 781.589L1207.97 790.112L1215.97 786.238L1211.84 777.715L1204.09 781.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1269.69 869.145L1265.3 850.032L1256.26 854.94L1265.3 873.019H1266.59L1269.69 869.145Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1249.55 842.801L1256.26 854.94L1265.3 850.033L1261.43 836.603L1249.55 842.801Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1257.04 825.238L1261.43 836.603L1249.55 842.801L1244.12 831.695L1257.04 825.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1238.96 821.622L1244.12 831.695L1257.04 825.238L1252.13 814.907L1238.96 821.622Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1233.79 811.807L1238.96 821.622L1252.13 814.906L1246.97 805.092L1233.79 811.807Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.63 801.476L1233.79 811.808L1246.96 805.092L1241.02 795.02L1228.63 801.476Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1222.69 790.112L1228.63 801.477L1241.03 795.02L1233.28 784.688L1222.69 790.112Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1215.46 775.907L1222.69 790.112L1233.28 784.688L1223.46 771.774L1215.46 775.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1262.46 791.404L1256 782.623L1268.92 773.583C1269.52 774.358 1270.93 776.269 1271.76 777.715C1272.59 779.162 1271.93 782.795 1271.5 784.431L1262.46 791.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1250.06 774.099L1256 782.622L1268.92 773.583L1263.23 765.06L1250.06 774.099Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1244.12 765.318L1250.06 774.1L1263.24 765.06L1257.81 756.795L1244.12 765.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1239.22 756.795L1244.12 765.318L1257.81 756.795L1252.39 748.271L1239.22 756.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1233.53 747.755L1239.22 756.795L1252.39 748.272L1247.22 739.49L1233.53 747.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.11 738.715L1233.53 747.755L1247.22 739.49L1242.31 730.967L1228.11 738.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1223.2 729.676L1228.11 738.716L1242.32 730.967L1237.67 721.928L1223.2 729.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.81 720.378L1223.2 729.676L1237.66 721.927L1233.02 712.888L1218.81 720.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1214.42 710.822L1218.81 720.378L1233.02 712.888L1228.63 704.106L1214.42 710.822Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1210.03 701.523L1214.42 710.821L1228.63 704.106L1224.49 695.066L1210.03 701.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1205.9 691.967L1210.03 701.524L1224.49 695.067L1220.62 685.769L1205.9 691.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1202.28 682.153L1205.9 691.967L1220.62 685.769L1216.74 676.471L1202.28 682.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1198.41 672.596L1202.28 682.152L1216.75 676.47L1213.13 666.914L1198.41 672.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1195.05 662.782L1198.41 672.596L1213.13 666.914L1210.03 657.616L1195.05 662.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1191.69 652.967L1195.05 662.782L1210.03 657.616L1206.93 647.802L1191.69 652.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1188.85 643.411L1191.69 652.967L1206.93 647.801L1204.09 638.762L1188.85 643.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1254.71 743.363L1276.41 775.906L1263.24 740.006L1254.71 743.363Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1246.45 729.417L1254.71 743.364L1263.24 740.006L1257.55 725.284L1246.45 729.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1239.99 718.052L1246.45 729.416L1257.56 725.284L1253.68 713.145L1239.99 718.052Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1235.08 707.721L1239.99 718.052L1253.68 713.145L1249.81 702.556L1235.08 707.721Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1230.44 698.165L1235.08 707.721L1249.81 702.556L1246.45 692.741L1230.44 698.165Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1226.56 689.383L1230.43 698.165L1246.45 692.741L1243.61 683.701L1226.56 689.383Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1222.95 680.602L1226.56 689.383L1243.61 683.701L1241.02 674.92L1222.95 680.602Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1219.59 672.595L1222.95 680.602L1241.02 674.92L1238.44 666.396L1219.59 672.595Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1216.49 664.331L1219.59 672.596L1238.44 666.397L1235.86 658.391L1216.49 664.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1213.65 656.324L1216.49 664.331L1235.86 658.39L1233.54 650.384L1213.65 656.324Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1211.06 648.575L1213.65 656.323L1233.53 650.383L1231.47 642.635L1211.06 648.575Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1230.18 637.47L1231.47 642.635L1211.06 648.576C1210.45 646.716 1210.81 643.496 1211.06 642.119C1211.89 637.986 1217.09 636.609 1219.59 636.437L1230.18 637.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1195.83 634.37L1189.63 626.106L1202.28 616.291C1202.97 616.894 1204.61 618.77 1205.64 621.457C1206.68 624.143 1204.87 627.741 1203.83 629.205L1195.83 634.37Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1183.69 618.616L1189.63 626.106L1202.29 616.291L1195.83 608.026L1183.69 618.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1176.97 611.384L1183.69 618.616L1195.83 608.026L1189.11 600.02L1176.97 611.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1170 604.669L1176.97 611.384L1189.11 600.02L1181.62 592.788L1170 604.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1163.03 597.954L1170 604.669L1181.62 592.788L1173.62 585.814L1163.03 597.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1155.79 591.754L1163.03 597.953L1173.62 585.814L1165.61 579.099L1155.79 591.754Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.05 586.33L1155.8 591.754L1165.61 579.099L1157.09 573.158L1148.05 586.33Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1139.78 580.907L1148.05 586.331L1157.09 573.159L1148.3 567.219L1139.78 580.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1131.78 575.483L1139.78 580.907L1148.31 567.218L1139.27 561.794L1131.78 575.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1126.35 555.596C1122.43 565.927 1128.33 573.159 1131.77 575.483L1139.27 561.794L1126.35 555.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.04 618.357L1214.94 610.351L1207.45 614.483C1210.55 618.874 1212.1 622.296 1214.94 623.006C1218.25 623.833 1218.38 620.251 1218.04 618.357Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1202.03 608.026L1207.45 614.483L1214.94 610.35L1211.58 602.344L1202.03 608.026Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1209 596.146L1211.58 602.344L1202.03 608.026L1197.63 602.344L1209 596.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.89 594.078L1197.64 602.343L1203.06 599.244L1197.64 589.688L1189.89 594.078Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1209 596.145L1203.06 599.244L1197.63 589.688L1204.35 585.813L1209 596.145Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1183.17 587.622L1189.89 594.079L1197.64 589.688L1192.99 581.939L1183.17 587.622Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1177.49 582.714L1183.17 587.622L1192.99 581.939L1189.89 575.999L1177.49 582.714Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1200.73 577.549L1204.35 585.814L1197.64 589.688L1192.99 581.94L1200.73 577.549Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1188.85 574.192L1192.99 581.94L1200.73 577.55L1196.86 569.543L1188.85 574.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1193.24 561.794L1196.86 569.542L1188.85 574.191L1184.72 566.96L1193.24 561.794Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1173.1 578.841L1177.49 582.715L1189.89 576L1186.79 570.834L1173.1 578.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1166.9 573.675L1173.1 578.841L1186.79 570.576L1184.72 566.96L1166.9 573.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.89 555.337L1193.25 561.794L1186.53 565.668L1181.37 556.887L1184.72 554.562C1186.79 553.116 1189.03 554.476 1189.89 555.337Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1175.17 559.728L1179.04 569.026L1184.72 566.96L1186.53 565.668L1181.36 556.887L1175.17 559.728Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1168.45 562.052L1171.29 571.867L1179.04 569.026L1175.16 559.728L1168.45 562.052Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1160.7 568.51L1166.9 573.675L1171.29 571.867L1168.45 562.053L1162.77 563.602C1160.5 564.429 1160.44 567.218 1160.7 568.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1197.38 541.65L1204.87 537.259L1210.29 547.332L1195.83 554.563L1192.21 547.59L1197.38 541.65Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1200.22 563.603L1195.83 554.563L1210.29 547.331L1214.68 556.371L1200.22 563.603Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1218.81 565.669L1214.68 556.371L1200.22 563.603L1204.61 572.901L1218.81 565.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1222.95 574.967L1218.81 565.669L1204.61 572.901L1208.74 581.682L1222.95 574.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1212.61 591.498L1208.74 581.683L1222.95 574.968L1226.82 585.041L1212.61 591.498Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1216.75 600.795L1212.61 591.497L1226.82 585.04L1230.69 595.113L1216.75 600.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1220.88 611.127L1216.75 600.795L1230.7 595.113L1234.05 606.219L1220.88 611.127Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1225.53 622.232L1220.88 611.126L1234.05 606.219L1237.67 617.325L1225.53 622.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.89 632.047L1225.53 622.232L1237.67 617.325L1241.03 629.981C1236.48 634.113 1231.04 633.08 1228.89 632.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1204.09 781.589L1223.2 771.775L1218.81 765.576L1201.25 773.841L1204.09 781.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1197.63 765.835L1201.25 773.841L1218.81 765.577L1214.16 758.345L1197.63 765.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1209 750.338L1214.16 758.345L1197.63 765.835L1193.76 757.311L1209 750.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.63 748.271L1193.76 757.311L1209 750.338L1204.09 741.814L1189.63 748.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1185.24 738.715L1189.63 748.272L1204.09 741.815L1198.93 732.517L1185.24 738.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1180.59 728.643L1185.24 738.716L1198.93 732.517L1194.02 722.444L1180.59 728.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1175.94 718.312L1180.59 728.643L1194.02 722.444L1189.11 712.113L1175.94 718.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1171.29 707.981L1175.94 718.312L1189.11 712.113L1184.98 701.782L1171.29 707.981Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1166.9 698.166L1171.29 707.98L1184.98 701.782L1180.85 691.709L1166.9 698.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1162.51 688.61L1166.9 698.166L1180.85 691.709L1177.49 681.895L1162.51 688.61Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1158.63 679.828L1162.51 688.61L1177.49 681.895L1174.65 672.597L1158.63 679.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1155.02 671.564L1158.63 679.829L1174.65 672.597L1172.06 663.815L1155.02 671.564Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1151.66 664.073L1155.02 671.563L1172.06 663.815L1170 655.55L1151.66 664.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.82 657.875L1151.66 664.073L1170 655.55L1169.22 650.385C1168.81 648.732 1167.33 648.663 1166.64 648.835C1161.65 650.901 1151.35 655.188 1150.11 655.808C1148.87 656.428 1148.73 657.444 1148.82 657.875Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1194.02 539.584L1202.8 533.902L1195.31 521.246C1192.42 522.073 1187.39 525.379 1185.24 526.928L1194.02 539.584Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1178.52 532.61C1180.17 530.337 1183.6 527.961 1185.24 526.928L1194.02 539.583C1192.37 542.063 1187.65 545.782 1185.49 547.332L1178.52 532.61Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1176.2 553.531C1179.3 552.291 1183.69 548.882 1185.49 547.332L1178.52 532.61C1176.04 534.883 1172.67 537.173 1171.29 538.034L1176.2 553.531Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1165.35 557.663C1169.07 557.043 1174.13 554.65 1176.2 553.531L1171.29 538.034L1163.03 541.65L1165.35 557.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1153.99 543.458C1157.09 543.252 1161.3 542.167 1163.03 541.65L1165.35 557.664C1160.6 559.11 1155.79 559.558 1153.99 559.472V543.458Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1144.95 543.2C1148.66 543.407 1152.52 543.458 1153.99 543.458V559.472C1147.99 559.885 1143.91 559.3 1142.62 558.955L1144.95 543.2Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1137.2 541.134C1140.3 542.167 1143.65 542.942 1144.95 543.2L1142.62 558.955C1138.9 557.509 1131.77 553.359 1128.67 551.465C1130.53 547.952 1135.13 543.114 1137.2 541.134Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1245.16 889.549L1248.78 878.443L1238.45 872.761L1232.76 882.834L1245.16 889.549Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1234.31 870.178L1238.44 872.761L1232.76 882.834L1219.33 875.602L1232.25 865.529L1234.31 870.178Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1228.89 858.039L1232.25 865.529L1219.33 875.602L1214.17 864.754L1228.89 858.039Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1209.52 855.974L1214.17 864.755L1228.89 858.04L1224.76 849L1209.52 855.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1205.38 847.45L1209.52 855.973L1224.76 849L1220.62 839.96L1205.38 847.45Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1201.25 838.41L1205.38 847.45L1220.62 839.96L1216.75 831.179L1201.25 838.41Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1197.38 829.37L1201.25 838.41L1216.75 831.178L1212.88 822.139L1197.38 829.37Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1193.5 820.33L1197.38 829.37L1212.87 822.138L1208.74 813.099L1193.5 820.33Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.11 811.291L1193.5 820.331L1208.74 813.099L1204.61 804.06L1189.11 811.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1185.24 802.509L1189.11 811.291L1204.61 804.059L1200.48 795.277L1185.24 802.509Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1181.11 793.212L1185.24 802.51L1200.48 795.278L1196.6 786.238L1181.11 793.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1177.23 784.172L1181.11 793.212L1196.6 786.238L1192.21 776.94L1177.23 784.172Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1172.84 775.39L1177.23 784.172L1192.21 776.94L1188.34 767.9L1172.84 775.39Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1168.71 766.351L1172.84 775.391L1188.34 767.901L1184.2 758.861L1168.71 766.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1164.83 757.311L1168.71 766.351L1184.2 758.861L1180.07 749.821L1164.83 757.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1160.44 748.013L1164.83 757.311L1180.07 749.821L1176.2 740.781L1160.44 748.013Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1156.57 738.973L1160.44 748.013L1176.2 740.781L1172.07 731.483L1156.57 738.973Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1152.7 729.675L1156.57 738.973L1172.07 731.483L1167.93 722.443L1152.7 729.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.56 720.377L1152.69 729.675L1167.93 722.444L1163.54 713.146L1148.56 720.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1144.43 711.338L1148.56 720.378L1163.54 713.146L1159.41 704.106L1144.43 711.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.3 702.039L1144.43 711.337L1159.41 704.106L1155.28 694.808L1140.3 702.039Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1136.42 692.483L1140.3 702.298L1155.28 694.808L1151.14 685.51L1136.42 692.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1132.29 683.185L1136.42 692.483L1151.14 685.51L1147.01 676.212L1132.29 683.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1128.42 673.629L1132.29 683.186L1147.01 676.212L1142.88 666.914L1128.42 673.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.81 662.007L1142.88 666.915L1128.42 673.63L1124.03 667.689L1135.39 656.842L1140.81 662.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1116.54 660.458L1124.03 667.689L1135.39 656.842L1127.9 649.352L1116.54 660.458Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1109.56 652.967L1116.54 660.457L1127.9 649.351L1120.93 641.861L1109.56 652.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.07 645.736L1109.56 652.968L1120.93 641.862L1113.69 634.63L1102.07 645.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1094.84 638.504L1102.07 645.736L1113.69 634.63L1106.72 627.14L1094.84 638.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1089.16 632.304L1094.84 638.503L1106.72 627.139L1098.2 618.357L1089.16 632.304Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1086.32 630.497L1089.16 632.305L1098.2 618.358L1092.51 613.192L1084.25 614.484L1086.32 630.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1076.24 631.788L1086.32 630.755L1084.25 614.483L1073.92 616.033L1076.24 631.788Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1065.91 633.08L1076.24 631.788L1073.92 616.033L1063.85 617.325L1065.91 633.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1055.84 634.63L1065.91 633.08L1063.85 617.325L1053.77 618.617L1055.84 634.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1043.7 620.166L1053.77 618.616L1055.84 634.629L1045.77 636.179L1043.7 620.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1035.69 637.729L1045.77 636.179L1043.7 620.166L1033.63 621.457L1035.69 637.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1025.62 639.02L1035.69 637.729L1033.63 621.457L1023.3 623.007L1025.62 639.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1015.55 640.311L1025.62 639.02L1023.3 623.007L1013.48 624.557L1015.55 640.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.47 641.861L1015.55 640.312L1013.48 624.557L1003.41 626.106L1005.47 641.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.111 643.669L1005.48 641.861L1003.41 626.106L997.985 626.365L991.012 640.57L994.111 643.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.457 632.046L991.013 640.57L997.987 626.364L991.788 620.424L981.457 632.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.451 624.557L981.458 632.047L991.789 620.424L984.041 613.192L973.451 624.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M965.701 617.583L973.45 624.557L984.039 613.193L976.032 605.961L965.701 617.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M957.695 610.093L965.702 617.583L976.033 605.96L968.026 598.729L957.695 610.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M949.43 602.861L957.695 610.093L968.026 598.729L959.761 591.497L949.43 602.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.424 593.305C943.748 597.437 946.073 600.02 949.43 602.861L959.762 591.497L955.371 585.04L941.424 593.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M935.998 584.782L941.422 593.305L955.369 585.04L950.203 576.259L935.998 584.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.834 575.742L936 584.782L950.205 576.258L945.039 567.219L930.834 575.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.926 566.702L930.833 575.742L945.038 567.219L939.873 558.438L925.926 566.702Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M920.762 557.921L925.927 566.703L939.874 558.438L934.967 549.656L920.762 557.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M915.596 549.398L920.761 557.921L934.967 549.656L929.543 540.616L915.596 549.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.172 540.616L915.596 549.398L929.543 540.616L924.377 531.835L910.172 540.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M905.266 531.577L910.173 540.617L924.378 531.835L919.213 523.054L905.266 531.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M900.1 522.537L905.265 531.577L919.212 523.054L914.305 514.272L900.1 522.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M894.934 514.013L900.099 522.537L914.304 514.272L909.139 505.49L894.934 514.013Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M889.768 505.232L894.933 514.014L909.138 505.49L903.973 496.709L889.768 505.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.119 495.935L889.768 505.233L903.973 496.71L899.066 487.67L885.119 495.935Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M883.053 492.577L885.119 495.935L899.066 487.67L890.801 474.239L883.053 492.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M881.76 490.252L883.051 492.318L890.541 473.98L877.369 474.239L877.627 490.252H881.76Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M867.297 490.511L877.628 490.252L877.37 474.239L867.039 474.498L867.297 490.511Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M857.225 490.51H867.298L867.04 474.497L856.967 474.755L857.225 490.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M846.893 490.769L857.224 490.511L856.966 474.756L846.635 475.014L846.893 490.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M836.821 491.027L846.894 490.769L846.635 475.014L836.562 475.272L836.821 491.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M826.489 491.544L836.82 491.027L836.562 475.272L826.23 475.789L826.489 491.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.416 492.061L826.489 491.544L826.231 475.789L816.158 476.047L816.416 492.061Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M806.086 492.06H816.418L816.159 476.047L805.828 476.305L806.086 492.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M802.986 492.06H806.086L805.827 476.305L797.046 476.563L792.139 480.695L801.695 493.351L802.986 492.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M793.43 499.55L801.695 493.351L792.138 480.695L783.615 486.894L793.43 499.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M785.424 505.749L793.431 499.55L783.616 486.895L775.609 493.093L785.424 505.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M777.416 511.947L785.423 505.748L775.608 493.093L767.602 499.291L777.416 511.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M769.15 518.145L777.415 511.947L767.601 499.291L759.336 505.49L769.15 518.145Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.145 524.345L769.151 518.146L759.337 505.49L751.33 511.689L761.145 524.345Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.879 530.543L761.143 524.344L751.329 511.688L743.322 517.629L752.879 530.543Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M744.873 536.741L752.88 530.543L743.323 517.629L735.059 524.086L744.873 536.741Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M736.609 543.198L744.874 536.742L735.059 524.086L727.053 530.026L736.609 543.198Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M728.344 549.397L736.609 543.199L727.052 530.026L723.178 532.609L722.92 548.881L728.344 549.397Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.074 547.589L722.922 548.881L723.18 532.609L713.882 531.576L712.074 547.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.002 546.299L712.075 547.59L713.883 531.577L703.81 530.544L702.002 546.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M691.928 545.265L702.001 546.298L703.809 530.543L693.477 529.252L691.928 545.265Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M681.598 543.974L691.929 545.266L693.478 529.252L683.406 527.961L681.598 543.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M672.041 542.94L681.597 543.974L683.405 527.96L672.558 526.669L672.041 542.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M662.227 542.682L672.041 542.94L672.558 526.669L662.485 526.152L662.227 542.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M651.896 542.166L662.228 542.683L662.486 526.153L652.155 525.895L651.896 542.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M646.729 525.895H652.153L651.895 542.166L644.663 543.457L639.756 528.219L646.729 525.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M635.624 546.556L644.664 543.457L639.756 528.219L629.684 531.576L635.624 546.556Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M618.059 552.497L635.622 546.556L632.264 538.033L613.41 545.782L615.476 551.464L618.059 552.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.277 536.483L613.41 545.781L628.39 539.583L624.516 530.026L609.277 536.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.402 526.927L609.277 536.483L624.515 530.026L620.641 520.47L605.402 526.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M617.026 511.172L620.642 520.47L605.403 526.927L601.529 517.371L617.026 511.172Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M597.914 507.815L601.53 517.371L617.027 511.172L613.152 501.616L597.914 507.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M593.781 500.067L597.914 507.815L613.152 501.616L607.987 491.285L593.781 500.067Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M602.821 482.762L607.986 491.285L593.781 500.066L588.615 491.285L602.821 482.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M583.191 482.504L588.615 491.285L602.821 482.762L597.397 473.98L583.191 482.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M577.768 473.722L583.191 482.503L597.397 473.98L591.973 464.94L577.768 473.722Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M572.602 464.941L577.767 473.723L591.972 464.941L586.807 456.418L572.602 464.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M567.178 456.418L572.602 464.941L586.807 456.418L581.641 447.637L567.178 456.418Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M562.014 447.895L567.179 456.418L581.643 447.637L576.219 438.855L562.014 447.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M556.332 438.855L562.014 447.894L576.219 438.855L571.054 430.073L556.332 438.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M551.424 430.332L556.331 438.855L571.053 430.074L565.887 421.551L551.424 430.332Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M546.516 421.292L551.423 430.331L565.886 421.55L560.463 412.769L546.516 421.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M541.352 412.51L546.517 421.292L560.464 412.769L555.299 403.987L541.352 412.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M536.186 404.504L541.351 412.511L555.298 403.987L549.616 394.689L536.186 404.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M530.762 401.663L536.186 404.504L549.616 394.69L547.55 391.849L538.252 386.941L530.762 401.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M521.723 396.756L530.762 401.663L538.252 386.941L528.954 382.292L521.723 396.756Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M512.424 392.107L521.722 396.756L528.954 382.292L519.914 377.385L512.424 392.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M503.383 387.458L512.423 392.107L519.913 377.385L510.873 372.994L503.383 387.458Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M494.344 382.808L503.383 387.457L510.874 372.994L501.834 368.345L494.344 382.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M485.305 378.16L494.344 382.809L501.834 368.345L492.795 363.696L485.305 378.16Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M476.264 373.51L485.303 378.159L492.793 363.695L483.754 358.788L476.264 373.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M466.967 369.12L476.265 373.51L483.755 358.789L474.715 354.14L466.967 369.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M457.928 364.729L466.967 369.12L474.716 354.14L465.934 349.749L457.928 364.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M444.238 358.789C448.801 360.683 457.927 364.522 457.927 364.729L465.934 349.749L461.801 347.166L444.238 358.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1144.17 647.285L1160.96 640.312L1157.08 632.047L1140.3 639.795L1144.17 647.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1152.95 623.782L1157.08 632.047L1140.3 639.795L1136.42 632.305L1152.95 623.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.56 615.518L1152.95 623.782L1136.42 632.306L1132.29 625.074L1148.56 615.518Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1127.9 618.1L1132.29 625.074L1148.56 615.517L1143.14 607.511L1127.9 618.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1122.99 611.384L1127.9 618.099L1143.14 607.51L1137.71 599.762L1122.99 611.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1117.83 604.669L1122.99 611.385L1137.71 599.762L1131.77 592.53L1117.83 604.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1125.58 585.815L1131.77 592.531L1117.83 604.67L1111.89 598.471L1125.58 585.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1118.86 579.358L1125.58 585.815L1111.89 598.471L1106.21 592.789L1118.86 579.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1100.01 587.107L1106.2 592.789L1118.86 579.358L1111.89 572.901L1100.01 587.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1093.29 581.941L1100 587.106L1111.89 572.901L1104.4 567.219L1093.29 581.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1086.32 577.293L1093.29 581.942L1104.4 567.22L1096.65 561.796L1086.32 577.293Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.09 573.16L1086.32 577.293L1096.65 561.796L1088.64 556.889L1079.09 573.16Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.85 569.027L1079.09 573.16L1088.64 556.888L1080.38 552.239L1071.85 569.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1074.95 549.656L1080.38 552.239L1071.85 569.027L1065.91 564.895C1065.4 564.12 1064.88 561.434 1066.95 556.888C1069.01 552.342 1073.15 550.087 1074.95 549.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1092.78 600.537L1099.23 606.736L1106.21 599.504L1099.23 593.306L1092.78 600.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1134.62 639.795L1124.8 623.266L1119.38 627.398C1124.2 632.219 1134 641.913 1134.62 642.12C1135.24 642.327 1134.88 640.656 1134.62 639.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1118.86 614.226L1124.8 623.265L1119.38 627.398L1111.89 619.391L1118.86 614.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1105.17 612.934L1111.89 619.391L1118.86 614.226L1112.66 605.961L1105.17 612.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1099.23 606.736L1105.17 612.934L1112.66 605.961L1106.21 599.504L1099.23 606.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1086.06 595.63L1092.78 600.537L1099.23 593.306L1092.26 587.882L1086.06 595.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.6 590.98L1086.06 595.629L1092.26 587.881L1085.03 582.457L1079.6 590.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1072.63 585.815L1079.6 590.981L1085.03 582.458L1077.54 577.809L1072.63 585.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1067.47 580.391C1068.08 581.631 1071.17 584.524 1072.63 585.815L1077.54 577.809L1068.79 572.974C1068.11 572.596 1067.2 572.425 1066.73 573.048C1065.41 574.795 1066.81 579.078 1067.47 580.391Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1220.11 509.881L1211.58 477.08L1201.77 481.213L1220.11 509.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1207.71 463.649L1211.58 477.08L1201.77 481.212L1195.31 470.623L1207.71 463.649Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1206.67 458.484L1207.71 463.65L1195.31 470.623L1189.89 462.1L1203.58 453.577L1206.67 458.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1198.67 445.054L1203.58 453.577L1189.89 462.1L1184.46 453.835L1198.67 445.054Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1191.7 436.271C1193.97 438.131 1197.29 442.901 1198.67 445.053L1184.46 453.834L1179.3 446.603L1191.7 436.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1173.1 440.146L1179.3 446.603L1191.7 436.272L1184.21 428.523L1173.1 440.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1175.94 421.551L1184.2 428.524L1173.1 440.147L1165.87 433.69L1175.94 421.551Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1158.38 428.781L1165.87 433.689L1175.94 421.55L1166.38 415.093L1158.38 428.781Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1150.11 424.649L1158.38 428.782L1166.38 415.093C1162.87 412.82 1158.03 410.874 1156.05 410.186L1150.11 424.649Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.3 421.292L1150.11 424.649L1156.05 410.186L1144.69 407.345L1140.3 421.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1129.71 418.968L1140.3 421.292L1144.69 407.345L1132.03 405.537L1129.71 418.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1108.27 418.451L1119.12 417.934L1118.86 404.246L1106.46 403.987L1108.27 418.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1098.71 420.259L1108.27 418.451L1106.46 403.987L1094.58 404.504L1098.71 420.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1093.29 422.067L1098.72 420.259L1094.58 404.504L1080.12 406.312L1093.29 422.067Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1119.12 417.935L1129.71 418.968L1132.03 405.537L1118.86 404.246L1119.12 417.935Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1076.5 533.902C1072.78 521.504 1069.79 506.524 1068.75 500.584L1059.71 502.392C1062.61 512.516 1072.11 527.617 1076.5 533.902Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1066.95 486.12L1068.75 500.584L1059.71 502.392L1054.55 487.928L1066.95 486.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1066.17 473.98L1066.94 486.12L1054.55 487.927L1051.96 475.53L1066.17 473.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.42 464.425L1051.97 475.531L1066.17 473.981V463.392L1050.42 464.425Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.16 452.802L1050.42 464.424L1066.17 463.391L1066.43 453.835L1050.16 452.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.42 442.213L1050.16 452.802L1066.43 453.835C1066.43 451.356 1068.32 446.948 1069.27 445.054L1050.42 442.213Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1073.4 438.338L1069.27 445.054L1050.42 442.213L1051.45 433.689L1073.4 438.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.34 431.107L1073.4 438.339L1061.78 435.756L1068.24 420.001L1079.34 431.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1088.13 423.617L1079.34 431.107L1068.24 420.001L1077.28 411.22L1088.13 423.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1065.91 394.689L1077.28 411.219L1072.11 416.127L1059.2 405.795C1061.26 400.01 1064.54 395.981 1065.91 394.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1054.55 419.742C1056 413.13 1058.25 407.689 1059.2 405.795L1072.11 416.126L1068.24 420L1066.95 422.841L1054.55 419.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1051.45 433.689L1054.55 419.742L1066.95 422.842L1061.78 435.755L1051.45 433.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1081.93 602.343L1070.05 593.304L1068.5 594.079L1073.92 606.218L1080.89 605.443C1082.96 604.823 1082.44 603.118 1081.93 602.343Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1066.69 607.251L1073.92 606.218L1068.5 594.079L1062.04 596.92L1066.69 607.251Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.42 608.542L1066.69 607.251L1062.04 596.92L1054.55 600.278L1058.42 608.542Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1045.25 610.608L1058.42 608.542L1054.55 600.277L1042.93 605.443L1045.25 610.608Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1062.04 586.331L1070.05 593.304L1059.72 597.953L1055.58 588.914C1056.44 588.483 1058.43 587.467 1059.46 586.847C1060.49 586.227 1061.61 586.245 1062.04 586.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1047.32 593.046L1055.58 588.913L1059.71 597.953L1051.45 601.569L1047.32 593.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1039.05 597.178L1047.32 593.046L1051.45 601.569L1042.93 605.443L1039.05 597.178Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1039.05 611.383L1045.25 610.608L1039.05 597.178L1033.37 599.761L1039.05 611.383Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.3 612.675L1039.05 611.383L1033.37 599.761L1026.91 602.86L1031.3 612.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1022.01 613.966L1031.3 612.675L1026.91 602.86L1018.65 606.735L1022.01 613.966Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1008.32 616.032L1022.01 613.966L1018.65 606.734L1008 611.734C1006.72 612.333 1005.38 613.579 1006.03 614.834C1006.49 615.753 1007.6 616.032 1008.32 616.032Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1059.46 581.166L1058.42 571.093L1049.38 575.483L1053.77 584.265L1059.46 581.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1046.03 587.881L1053.77 584.265L1049.38 575.483L1041.63 579.099L1046.03 587.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1038.53 591.497L1046.02 587.881L1041.63 579.1L1034.4 582.457L1038.53 591.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.91 586.073L1034.4 582.457L1038.53 591.497L1031.04 595.113L1026.91 586.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.42 562.312V570.835L1052.74 573.676L1048.35 564.378L1054.81 561.02C1056.87 560.194 1058.08 561.537 1058.42 562.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.12 567.994L1048.35 564.378L1052.74 573.676L1045.51 577.292L1041.12 567.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1033.37 571.609L1041.12 567.993L1045.51 577.291L1037.76 580.907L1033.37 571.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1025.88 575.225L1033.37 571.609L1037.76 580.907L1030.27 584.523L1025.88 575.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.04 587.881L1030.27 584.524L1025.88 575.226L1018.65 578.583L1023.04 587.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1015.55 591.497L1023.04 587.881L1018.65 578.583L1011.16 582.199L1015.55 591.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.55 598.729L1031.04 595.113L1026.91 586.073L1019.16 589.689L1023.55 598.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1016.32 602.345L1023.55 598.729L1019.16 589.689L1011.93 593.047L1016.32 602.345Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.67 585.815L1011.16 582.199L1015.55 591.497L1008.06 594.855L1003.67 585.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1000.83 598.47L1008.06 594.854L1003.67 585.814L996.436 589.172L1000.83 598.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1008.83 605.961L1016.32 602.345L1011.93 593.047L1004.44 596.663L1008.83 605.961Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.34 609.576L1008.83 605.96L1004.44 596.662L996.953 600.278L1001.34 609.576Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M996.177 612.159L1001.34 609.576L996.952 600.278L987.654 604.411L996.177 612.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.945 592.789L996.435 589.173L1000.83 598.471L993.336 601.828L988.945 592.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M982.274 595.902L988.946 592.788L993.337 601.828L987.655 604.411C985.847 602.861 982.076 599.555 981.456 598.728C981.183 598.364 981.067 597.954 981.037 597.571C980.978 596.811 981.582 596.224 982.274 595.902Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.709 591.238L965.961 584.265L975.001 579.874L979.391 588.914L973.709 591.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M986.881 585.299L979.391 588.914L975 579.875L982.49 576.259L986.881 585.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.371 581.682L986.881 585.298L982.49 576.258L989.98 572.643L994.371 581.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.86 578.066L994.371 581.682L989.98 572.642L997.729 569.026L1001.86 578.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1009.61 574.45L1001.86 578.066L997.729 569.026L1005.22 565.41L1009.61 574.45Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1017.1 570.835L1009.61 574.451L1005.22 565.411L1012.71 561.795L1017.1 570.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1024.59 567.219L1017.1 570.835L1012.71 561.795L1020.2 558.438L1024.59 567.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1032.08 563.603L1024.59 567.219L1020.2 558.438L1027.95 554.563L1032.08 563.603Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1039.83 559.987L1032.08 563.603L1027.95 554.563L1035.44 550.947L1039.83 559.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1047.58 556.113L1039.83 559.987L1035.44 550.947L1042.93 547.331L1047.58 556.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1052.39 553.616L1047.57 556.113L1042.93 547.331L1049.9 543.974C1051.02 545.609 1053.41 549.139 1054.03 550.172C1054.83 551.498 1053.76 552.905 1052.39 553.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1044.74 536.225L1049.9 543.974L1041.64 547.848L1037.25 538.808C1037.85 538.464 1039.47 537.568 1041.12 536.742C1042.77 535.915 1044.22 536.053 1044.74 536.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1029.75 542.682L1037.24 538.808L1041.63 547.847L1034.14 551.463L1029.75 542.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1022.26 546.298L1029.75 542.682L1034.14 551.463L1026.4 555.337L1022.26 546.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1014.52 549.914L1022.27 546.298L1026.4 555.338L1018.91 558.953L1014.52 549.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1006.77 553.53L1014.52 549.914L1018.91 558.954L1011.16 562.57L1006.77 553.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M999.02 557.146L1006.77 553.53L1011.16 562.57L1003.41 566.186L999.02 557.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M991.271 560.761L999.02 557.146L1003.41 566.185L995.662 570.059L991.271 560.761Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M983.781 564.378L991.271 560.762L995.662 570.06L988.172 573.417L983.781 564.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.033 567.994L983.782 564.378L988.172 573.418L980.424 577.292L976.033 567.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M968.285 571.609L976.033 567.993L980.424 577.291L972.676 580.907L968.285 571.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.345 574.45L968.285 571.609L972.676 580.907L965.96 584.265L961.57 577.55C960.743 576.103 961.742 574.881 962.345 574.45Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1199.44 433.431L1196.34 422.325L1187.04 424.908L1196.34 435.239C1198.82 436.685 1199.44 434.636 1199.44 433.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1180.33 419.484L1187.05 424.907L1196.34 422.325L1194.54 415.609L1180.33 419.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1174.13 414.318L1180.33 419.484L1186.01 417.934L1183.69 409.411C1181 410.444 1176.54 411.047 1174.65 411.219C1173.2 412.046 1173.7 413.63 1174.13 414.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.89 407.087C1188.85 407.706 1185.32 408.895 1183.69 409.411L1186.01 417.934L1194.54 415.61C1193.85 413.113 1192.42 408.016 1192.21 407.603C1191.95 407.087 1191.18 406.312 1189.89 407.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1187.05 387.457L1188.85 394.431L1175.94 395.722L1175.42 388.49L1187.05 387.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1189.89 398.305L1188.85 394.431L1180.33 395.464L1181.1 405.537C1183.17 404.934 1187.61 403.522 1188.85 402.696C1190.09 401.869 1190.06 399.424 1189.89 398.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1180.68 405.63L1181.11 405.537L1180.33 395.464L1167.16 396.497L1177.28 404.815C1178.23 405.597 1179.48 405.897 1180.68 405.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1159.67 390.04L1167.16 396.497L1175.94 395.722L1175.42 388.49L1159.67 390.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1176.45 384.1L1185.75 383.325L1183.17 374.027L1175.42 374.544L1176.45 384.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1180.85 365.246C1181.05 365.866 1182.48 371.272 1183.17 374.027L1175.42 374.544L1174.13 362.921L1177.75 362.663C1179.55 362.921 1180.59 364.471 1180.85 365.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1167.68 384.875L1176.46 384.1L1175.42 374.544L1166.9 375.319L1167.68 384.875Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1158.89 385.65L1167.67 384.876L1166.9 375.319L1158.12 376.352L1158.89 385.65Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1154.5 385.908L1158.89 385.65L1158.12 376.352L1144.69 377.385L1154.5 385.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1167.16 363.437L1174.13 362.921L1175.42 374.543L1168.19 375.06L1167.16 363.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1160.18 363.954L1167.16 363.438L1168.19 375.06L1160.96 375.835L1160.18 363.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1158.12 376.351L1160.96 375.835L1160.18 363.954L1153.47 364.471L1153.73 376.61L1158.12 376.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1146.49 365.246L1153.47 364.471L1153.73 376.61L1147.27 377.126L1146.49 365.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.56 366.021L1146.5 365.246L1147.27 377.127L1144.69 377.385L1138.75 371.703C1137.71 368.397 1139.35 366.451 1140.56 366.021Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.38 528.735L1038.02 522.536L1030.53 525.894L1034.66 534.675L1040.86 531.834C1041.89 531.214 1041.63 529.51 1041.38 528.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.91 538.292L1034.66 534.676L1030.53 525.895L1022.78 529.51L1026.91 538.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1019.16 541.907L1026.91 538.291L1022.78 529.51L1014.77 533.384L1019.16 541.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.42 545.523L1019.17 541.907L1014.78 533.384L1007.29 537L1011.42 545.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.67 549.397L1011.42 545.523L1007.28 537L999.535 540.616L1003.67 549.397Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1034.66 514.53L1038.02 522.537L1031.05 525.636L1026.4 515.821L1031.56 513.497C1033.22 512.877 1034.32 513.927 1034.66 514.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1019.42 519.437L1026.4 515.821L1031.04 525.636L1023.81 528.993L1019.42 519.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.19 522.795L1019.42 519.438L1023.81 528.994L1016.84 532.351L1012.19 522.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.22 526.153L1012.19 522.795L1016.84 532.351L1009.61 535.967L1005.22 526.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.984 529.51L1005.22 526.152L1009.61 535.967L1002.63 539.066L997.984 529.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.754 532.867L997.986 529.51L1002.63 539.066L995.145 542.682L990.754 532.867Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M995.92 553.014L1003.67 549.398L999.535 540.616L991.787 544.232L995.92 553.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.43 556.63L995.92 553.014L991.787 544.232L984.039 547.848L988.43 556.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M983.521 536.225L990.753 532.867L995.144 542.682L988.17 545.781L983.521 536.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.549 539.583L983.522 536.226L988.171 545.782L981.198 549.139L976.549 539.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.316 542.941L976.548 539.583L981.197 549.139L973.965 552.497L969.316 542.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M980.68 560.245L988.428 556.629L984.037 547.848L976.289 551.464L980.68 560.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M972.931 563.861L980.68 560.245L976.289 551.464L968.799 555.08L972.931 563.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M965.185 567.476L972.934 563.861L968.801 555.079L961.053 558.695L965.185 567.476Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M959.502 570.318L965.184 567.477L961.052 558.695L952.787 562.569L956.661 569.285C957.281 570.731 958.814 570.576 959.502 570.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M948.396 555.337L952.787 562.569L959.761 559.212L955.112 549.655L949.429 552.496C948.396 553.116 948.31 554.649 948.396 555.337Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.343 546.298L955.111 549.655L959.76 559.212L966.992 555.854L962.343 546.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.317 542.94L962.344 546.298L966.993 555.854L973.966 552.497L969.317 542.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1164.32 401.145L1156.83 394.688L1154.5 405.278L1160.44 407.086C1165.4 407.086 1165.09 403.126 1164.32 401.145Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1146.24 403.47L1154.5 405.278L1156.83 394.688L1148.05 395.205L1146.24 403.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1147.27 385.907L1156.83 394.689L1143.4 395.464L1142.62 386.166L1147.27 385.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1134.87 401.404L1146.24 403.47L1148.05 395.205L1134.87 395.98V401.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1133.84 386.94L1142.62 386.165L1143.4 395.463L1134.87 395.98L1133.84 386.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1121.44 387.974L1133.84 386.94L1134.62 393.656L1121.96 394.689L1121.44 387.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1122.48 400.113L1134.87 401.405V395.981L1134.61 393.656L1121.96 394.689L1122.48 400.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1115.24 399.596L1122.48 400.113L1121.44 387.974L1114.47 388.748L1115.24 399.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1107.5 399.596H1115.24L1114.47 388.748L1106.72 389.523L1107.5 399.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1099.49 399.855L1107.5 399.596L1106.72 389.523L1098.71 390.04L1099.49 399.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1090.97 400.371L1099.49 399.855L1098.71 390.04L1090.19 391.073L1090.97 400.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1082.7 401.403L1090.97 400.37L1090.19 391.072L1081.93 391.589L1082.7 401.403Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1078.05 402.178L1082.7 401.403L1081.93 391.589L1070.82 392.88L1078.05 402.178Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M936.258 531.059L942.974 527.96L947.106 536.741L939.874 540.099C938.927 538.463 936.878 534.882 936.258 533.642C935.638 532.402 936 531.404 936.258 531.059Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M950.463 524.344L942.973 527.96L947.105 536.741L954.337 533.125L950.463 524.344Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.211 520.728L950.463 524.343L954.337 533.125L962.085 529.509L958.211 520.728Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M965.443 517.37L958.211 520.728L962.085 529.509L969.575 526.152L965.443 517.37Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.192 513.496L965.443 517.37L969.576 526.152L977.324 522.536L973.192 513.496Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M943.749 547.073L939.875 540.099L947.623 536.483L952.014 545.781L946.849 548.364C945.196 549.191 944.094 547.848 943.749 547.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M959.502 542.165L952.012 545.781L947.621 536.483L955.111 532.867L959.502 542.165Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M966.734 538.549L959.502 542.165L955.111 532.867L962.343 529.51L966.734 538.549Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M974.225 535.191L966.734 538.549L962.344 529.509L969.576 526.151L974.225 535.191Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.457 531.834L974.225 535.192L969.576 526.152L977.325 522.536L981.457 531.834Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M980.681 509.881L973.191 513.497L977.324 522.536L985.072 519.179L980.681 509.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.172 506.522L980.682 509.88L985.072 519.178L992.304 515.562L988.172 506.522Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M995.662 502.906L988.172 506.522L992.304 515.562L1000.05 511.946L995.662 502.906Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.947 528.218L984.556 519.437L977.324 522.536L981.457 531.834L988.947 528.218Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M996.179 524.86L988.947 528.218L984.557 519.436L991.788 515.82L996.179 524.86Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.41 521.503L996.178 524.86L991.787 515.821L999.277 512.463L1003.41 521.503Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1010.9 517.887L1003.41 521.503L999.277 512.464L1006.51 508.848L1010.9 517.887Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1018.39 514.271L1010.9 517.887L1006.51 508.847L1014 505.231L1018.39 514.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1025.62 510.913L1018.39 514.271L1014 505.231L1021.23 501.615L1025.62 510.913Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.79 508.589L1025.62 510.913L1021.23 501.615L1029.24 497.741C1029.93 499.721 1031.41 504.095 1031.82 505.748C1032.23 507.401 1031.3 508.331 1030.79 508.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1027.69 490.252L1029.24 497.742L1022.52 500.841L1018.39 492.059C1019.25 491.543 1021.54 490.252 1023.81 489.218C1026.09 488.185 1027.34 489.477 1027.69 490.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1010.9 495.675L1018.39 492.06L1022.52 501.099L1015.03 504.715L1010.9 495.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.41 499.291L1010.9 495.675L1015.03 504.715L1007.54 508.33L1003.41 499.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M995.662 502.907L1003.41 499.291L1007.54 508.331L1000.05 511.947L995.662 502.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.86 248.115L1148.05 245.146L1138.23 245.921L1139.01 253.928L1147.53 253.411C1147.87 253.411 1148.15 253.341 1148.39 253.221C1150.06 252.387 1149.35 249.916 1148.86 248.115Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1128.42 254.961L1139.01 253.928L1138.23 245.921L1127.9 246.954L1128.42 254.961Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1117.83 255.736L1128.42 254.961L1127.9 246.954L1117.31 247.729L1117.83 255.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1110.08 256.253L1117.83 255.736L1117.05 243.855L1109.3 247.73L1110.08 256.253Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1097.42 257.286L1110.08 256.253L1109.3 247.729L1098.86 253.27C1097.45 254.022 1095.79 255.587 1096.76 256.862C1096.96 257.126 1097.22 257.252 1097.42 257.286Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1128.42 237.398L1117.05 243.855L1117.31 247.73L1129.19 246.696L1128.42 237.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1131 235.848L1128.42 237.398L1129.19 246.696L1137.46 245.921L1136.94 237.14C1136.16 237.14 1133.32 236.365 1132.81 235.848C1132.39 235.435 1131.43 235.676 1131 235.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1145.98 237.14L1148.05 245.147L1137.46 245.922L1136.94 237.14C1139.01 237.399 1141.59 236.624 1143.4 235.849C1144.84 235.229 1145.72 236.451 1145.98 237.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M912.755 452.027L915.338 458.226L907.073 462.358L903.457 454.61C904.49 454.007 907.073 452.544 909.139 451.51C911.205 450.477 912.411 451.424 912.755 452.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M895.709 458.225L903.458 454.609L906.299 461.066L897.001 465.974C896.312 464.768 894.831 462.048 894.418 460.808C894.004 459.568 895.193 458.57 895.709 458.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M900.876 472.947L897.002 465.974L906.3 461.066L909.916 468.556L900.876 472.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M919.213 465.974L915.339 458.226L907.074 462.358L910.948 470.365L919.213 465.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M905.266 480.437L900.875 472.947L909.915 468.557L913.531 476.047L905.266 480.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M923.087 473.98L919.213 465.974L910.689 470.364L914.564 478.113L923.087 473.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M926.704 481.987L923.088 473.98L914.564 478.113L918.439 486.12L926.704 481.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.318 489.736L926.702 481.987L918.438 486.12L922.053 493.868L930.318 489.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M934.968 499.55L930.319 489.735L923.604 493.093L927.994 502.908L934.968 499.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.173 488.444L905.266 480.438L913.531 476.047L917.663 484.57L910.173 488.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M915.079 497.226L910.172 488.444L917.662 484.57L922.053 493.868L915.079 497.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M919.987 505.748L915.08 497.225L923.603 493.093L927.477 501.874L919.987 505.748Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.154 514.789L919.988 505.749L927.478 501.875L931.869 511.431L925.154 514.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M939.617 509.106L934.968 499.55L927.994 502.907L932.643 512.722L939.617 509.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.32 523.311L925.154 514.788L931.87 511.431L937.293 522.02C936.088 522.709 933.471 524.138 932.644 524.345C931.818 524.551 930.75 523.742 930.32 523.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M943.49 517.63L939.616 509.106L932.643 512.722L937.292 522.02C938.411 521.59 940.959 520.574 942.199 519.954C943.439 519.334 943.576 518.146 943.49 517.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M935.743 441.437L938.326 447.378L929.028 451.51L925.67 444.02C926.445 443.59 928.666 442.367 931.352 440.921C934.038 439.474 935.398 440.662 935.743 441.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M918.179 447.378L925.669 444.021L929.027 451.511L919.987 455.901C919.385 454.61 918.024 451.666 917.405 450.219C916.785 448.773 917.663 447.722 918.179 447.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M923.602 463.649L919.986 455.9L929.026 451.51L932.642 459L923.602 463.649Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.681 454.61L938.323 447.378L929.025 451.51L932.641 459L941.681 454.61Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.298 462.358L941.682 454.609L932.643 459L936.258 466.748L945.298 462.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M927.219 471.139L923.604 463.649L932.643 459L936.259 466.748L927.219 471.139Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.576 478.63L927.219 471.14L936.258 466.749L939.874 474.239L930.576 478.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M948.913 469.847L945.298 462.357L936.258 466.748L939.874 474.238L948.913 469.847Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M952.531 477.596L948.915 469.848L939.875 474.238L943.491 481.987L952.531 477.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M934.192 486.377L930.576 478.629L939.874 474.238L943.49 481.987L934.192 486.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M937.807 493.868L934.191 486.378L943.489 481.987L947.105 489.477L937.807 493.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M956.146 485.087L952.53 477.597L943.49 481.987L947.106 489.477L956.146 485.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M959.761 492.576L956.145 485.086L947.105 489.477L950.721 497.225L959.761 492.576Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.683 501.358L950.722 497.226L947.107 489.478L937.809 493.868L941.683 501.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.298 509.106L941.682 501.358L950.721 497.226L954.337 504.716L945.298 509.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M963.378 500.325L959.762 492.576L950.723 497.225L954.339 504.715L963.378 500.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M965.96 506.006L963.378 500.324L954.338 504.715L957.954 512.205L965.186 508.847C966.632 508.228 966.305 506.695 965.96 506.006Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M947.882 514.789L945.299 509.107L954.339 504.716L957.954 512.206L950.206 516.08C949.173 516.493 948.226 515.391 947.882 514.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1025.37 480.178L1024.33 472.172L1014.26 476.821L1017.62 484.053L1025.37 480.178Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.3 459.259L1024.33 472.173L1020.2 473.981L1015.04 463.133L1023.3 459.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1008.84 466.232L1014.26 476.822L1020.2 473.98L1015.03 463.133L1008.84 466.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.3 449.186V459.258L1017.1 462.099L1013.23 454.093L1023.3 449.186Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1004.96 457.967L1008.84 466.232L1017.1 462.099L1013.23 454.093L1004.96 457.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.6 451.252L1004.96 457.967L1015.29 453.06L1011.93 446.345L1001.6 451.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.82 440.662L1023.3 449.185L1015.29 453.059L1011.94 446.344L1023.82 440.662Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1024.33 433.689L1023.82 440.663L1014 445.312L1011.16 439.888L1024.33 433.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M998.764 445.57L1001.6 451.252L1014 445.312L1011.16 439.888L998.764 445.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.114 435.497C995.75 438.768 998.506 445.053 998.765 445.57L1004.96 442.728L999.539 431.364C998.592 431.795 996.389 432.811 995.149 433.43C993.909 434.05 994.028 435.152 994.114 435.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.48 428.523L999.537 431.364L1004.96 442.729L1010.9 439.888L1005.48 428.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.42 425.683L1005.48 428.524L1010.9 439.888L1016.84 437.047L1011.42 425.683Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1017.36 422.841L1011.42 425.682L1016.84 437.046L1022.53 434.463L1017.36 422.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.66 419.742L1024.33 433.689L1022.52 434.464L1017.36 422.841C1019.17 421.894 1023.14 419.845 1024.59 419.225C1026.04 418.606 1026.57 419.312 1026.66 419.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M989.206 495.417L985.848 488.702L977.842 493.093L981.716 501.099C983.352 500.325 986.933 498.62 988.173 498C989.413 497.38 989.378 496.02 989.206 495.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.711 504.974L981.718 501.1L978.102 493.868L968.287 498.775C969.062 500.583 970.043 502.96 970.87 504.199C971.696 505.439 973.022 505.146 973.711 504.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M964.928 491.544L968.285 498.775L978.1 493.868L974.742 486.895L964.928 491.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.974 480.18L985.848 488.703L977.841 493.094L973.709 484.312L981.974 480.18Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.843 471.656L981.975 480.179L973.71 484.312L969.836 475.789L977.843 471.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.968 463.391L977.842 471.656L969.835 475.788L965.961 467.523L973.968 463.391Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M961.57 484.57L964.928 491.543L974.742 486.894L971.643 479.921L961.57 484.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.471 477.596L961.57 484.57L971.643 479.921L968.544 472.947L958.471 477.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M955.113 470.881L958.471 477.596L968.544 472.947L965.186 465.974L955.113 470.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.868 456.418L973.968 463.391L965.961 467.524L961.57 459C962.345 458.57 964.463 457.399 966.736 456.159C969.009 454.92 970.438 455.815 970.868 456.418Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M955.114 470.881L965.187 465.974L961.57 459C959.246 460.033 954.339 462.254 953.306 462.874C952.273 463.494 952.359 465.026 952.531 465.715L955.114 470.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M966.063 446.451L962.706 439.735L954.699 444.126L958.573 452.133C960.209 451.358 963.791 449.653 965.03 449.033C966.27 448.413 966.236 447.053 966.063 446.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M950.568 456.007L958.575 452.133L954.959 444.901L945.145 449.809C945.919 451.617 946.901 453.993 947.727 455.232C948.554 456.472 949.88 456.18 950.568 456.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.785 442.577L945.143 449.809L954.957 444.901L951.6 437.928L941.785 442.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.831 431.213L962.705 439.736L954.699 444.127L950.566 435.345L958.831 431.213Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M954.7 422.689L958.832 431.213L950.568 435.345L946.693 426.822L954.7 422.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M950.825 414.424L954.699 422.689L946.693 426.821L942.818 418.556L950.825 414.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M938.428 435.603L941.785 442.577L951.6 437.928L948.501 430.954L938.428 435.603Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M935.328 428.629L938.427 435.603L948.5 430.954L945.401 423.98L935.328 428.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M931.971 421.914L935.328 428.629L945.401 423.98L942.044 417.007L931.971 421.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M947.726 407.451L950.825 414.424L942.818 418.557L938.428 410.034C939.203 409.603 941.32 408.432 943.593 407.193C945.866 405.953 947.295 406.848 947.726 407.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M931.971 421.914L942.044 417.007L938.428 410.033C936.103 411.066 931.196 413.288 930.163 413.907C929.13 414.527 929.216 416.06 929.388 416.748L931.971 421.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.6 536.483L1067.21 530.026L1061.52 534.159L1069.27 545.781C1071.54 543.922 1071.77 538.808 1071.6 536.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1064.62 550.172C1065.86 549.759 1068.24 547.073 1069.27 545.781L1063.33 537L1057.13 541.391C1059.11 544.49 1063.38 550.585 1064.62 550.172Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.93 531.318L1057.13 541.39L1063.33 537L1057.39 527.443L1050.93 531.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1061.52 520.212L1067.21 530.026L1061.52 534.159L1055.33 523.57L1061.52 520.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1056.87 510.139L1061.52 520.212L1055.33 523.569L1050.42 512.98L1056.87 510.139Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1045.77 520.987L1050.94 531.318L1057.65 527.443L1052.48 517.629L1045.77 520.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.12 510.139L1045.77 520.987L1052.48 517.629L1048.09 507.298L1041.12 510.139Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1053 499.55L1056.87 510.139L1050.42 512.98L1046.29 502.133L1053 499.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1037.25 499.033L1041.12 510.139L1048.09 507.298L1044.48 496.709L1037.25 499.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1042.93 491.027L1044.48 496.709L1046.29 502.133L1053 499.55L1049.64 488.702L1042.93 491.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1047.58 478.112L1049.64 488.702L1042.93 491.026L1040.35 479.145L1047.58 478.112Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1034.4 487.668L1037.25 499.033L1044.48 496.708L1042.93 491.026L1041.89 485.86L1034.4 487.668Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1032.34 476.047L1034.4 487.669L1041.89 485.861L1040.34 479.146L1039.83 475.014L1032.34 476.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.3 464.424L1032.34 476.047L1039.83 475.014L1038.79 464.166L1031.3 464.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.05 452.802L1031.31 464.424L1038.8 464.166L1038.28 452.802H1031.05Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1046.03 466.748L1047.58 478.112L1040.34 479.145L1039.83 475.013L1039.05 467.523L1046.03 466.748Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1045.51 455.643L1046.03 466.749L1039.05 467.523L1038.8 464.166L1038.54 455.643H1045.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.31 441.179L1031.05 452.801H1038.28L1038.8 441.437L1031.31 441.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1045.77 444.278L1045.51 455.643H1038.54L1038.28 452.801L1038.8 444.278H1045.77Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1046.8 432.914L1045.77 444.278H1038.79V441.437L1039.57 432.914H1046.8Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1032.6 429.298L1031.3 441.179L1038.79 441.437L1039.57 432.397L1039.83 430.331L1032.6 429.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1034.92 417.676L1032.6 429.298L1039.83 430.331L1042.15 419.484L1034.92 417.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1048.87 422.325L1041.89 420.517L1039.83 430.331L1039.57 432.914H1046.8L1048.87 422.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1051.71 411.735L1048.87 422.324L1041.89 420.516L1042.15 419.483L1044.99 409.41L1051.71 411.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1038.02 406.569L1034.92 417.675L1042.15 419.483L1044.99 409.41L1038.02 406.569Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1040.6 398.046L1038.02 406.57L1044.99 409.411L1048.61 398.305C1046.54 397.53 1044.84 396.445 1043.19 396.238C1041.53 396.032 1040.86 397.358 1040.6 398.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1054.81 402.954L1051.71 411.735L1044.99 409.411L1048.61 398.305C1049.47 398.563 1051.61 399.286 1053.26 400.113C1054.91 400.939 1054.98 402.351 1054.81 402.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1128.16 383.325L1142.1 382.034L1133.84 374.802L1127.64 375.318L1128.16 383.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1126.35 368.345L1133.84 374.802L1119.89 376.093L1119.38 367.829L1124.03 367.57L1126.35 368.345Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1117.57 384.1L1128.16 383.325L1127.64 375.318L1117.05 376.351L1117.57 384.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1109.56 368.603L1119.38 367.828L1119.89 376.093L1110.08 376.868L1109.56 368.603Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1106.98 385.133L1117.57 384.1L1117.05 376.352L1106.46 377.385L1106.98 385.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1096.65 385.908L1106.98 385.133L1106.46 377.385L1096.13 378.16L1096.65 385.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1086.06 386.941L1096.65 385.908L1096.13 378.159L1085.54 378.934L1086.06 386.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1075.73 387.974L1086.06 386.941L1085.54 378.935L1074.95 379.968L1075.73 387.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1067.21 388.491L1075.73 387.974L1074.95 379.968L1061.78 381.259L1067.21 388.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1106.46 377.385L1110.08 376.868L1109.56 368.604L1099.49 369.637L1100.26 377.902L1106.46 377.385Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1090.19 378.676L1100.26 377.902L1099.49 369.637L1089.42 370.412L1090.19 378.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1080.38 379.451L1090.19 378.676L1089.42 370.411L1079.86 371.444L1080.38 379.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1070.56 380.226L1080.38 379.451L1079.86 371.444L1070.04 372.219L1070.56 380.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1063.07 372.736L1070.05 372.22L1070.56 380.485L1061.78 381.259L1059.97 378.16C1059.35 374.854 1061.78 373.167 1063.07 372.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.19 485.086L1009.09 478.629L1000.05 483.02L1003.67 490.51C1005.73 489.563 1010.13 487.565 1011.16 487.152C1012.19 486.739 1012.28 485.602 1012.19 485.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M996.438 494.126L1003.67 490.511L1000.05 483.021L990.756 487.411C991.359 488.617 992.719 491.389 993.339 492.835C993.959 494.281 995.663 494.299 996.438 494.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.48 471.14L1009.09 478.63L1000.05 483.02L996.438 475.53L1005.48 471.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M987.139 479.921L990.755 487.411L1000.05 483.02L996.437 475.53L987.139 479.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M983.523 472.173L987.139 479.921L996.437 475.531L992.821 467.782L983.523 472.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1002.12 463.649L993.078 468.04L996.436 475.53L1005.48 471.139L1002.12 463.649Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M998.503 456.159L1002.12 463.649L993.079 468.04L989.463 460.55L998.503 456.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M980.166 464.682L983.524 472.172L992.822 467.782L989.464 460.55L980.166 464.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.549 456.934L980.165 464.682L989.463 460.55L985.589 452.543L976.549 456.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.887 448.669L998.503 456.159L989.464 460.55L985.848 453.06L994.887 448.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M991.272 441.18L994.888 448.67L985.848 453.06L982.232 445.829L991.272 441.18Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M972.934 449.444L976.549 456.934L985.589 452.544L981.715 445.054L972.934 449.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.318 441.695L972.934 449.444L981.716 445.053L978.358 437.305L969.318 441.695Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M987.656 433.689L978.875 438.08V438.338L982.233 445.829L991.272 441.18L987.656 433.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M984.039 426.199L987.655 433.689L978.615 438.08L975.258 430.59L984.039 426.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M965.703 433.947L969.319 441.695L978.359 437.305L974.743 429.814L965.703 433.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.086 426.457L965.702 433.947L974.742 429.815L971.126 422.066L962.086 426.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M980.682 418.709L971.643 423.1L975.258 430.59L984.04 426.199L980.682 418.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.065 411.219L980.681 418.709L971.641 423.1L968.025 415.609L977.065 411.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.471 418.967L962.087 426.457L971.126 422.066L967.51 414.576L958.471 418.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M973.451 403.729L977.067 411.219L968.028 415.609L964.67 408.119L973.451 403.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M954.854 411.219L958.469 418.967L967.509 414.576L963.893 406.828L954.854 411.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.352 396.756L973.451 403.729L964.67 408.12L960.537 399.596C961.828 398.908 964.876 397.272 966.736 396.239C968.595 395.206 969.921 396.153 970.352 396.756Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M953.047 402.954L960.537 399.597L963.894 406.828L954.854 411.219C954.252 410.014 952.892 407.242 952.272 405.795C951.652 404.349 952.53 403.299 953.047 402.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.754 428.781L988.43 423.099L998.503 418.191L1001.6 424.907L993.595 429.039C992.356 429.659 991.185 429.125 990.754 428.781Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.42 420.258L1001.6 424.907L998.502 418.192L1008.32 413.543L1011.42 420.258Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1021.23 415.351L1011.42 420.258L1008.32 413.543L1018.13 408.636L1021.23 415.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1028.46 411.993L1021.23 415.35L1018.13 408.635L1031.3 402.437L1028.46 411.993Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M985.847 417.675L988.43 423.099L997.728 418.708L994.37 411.218L986.364 415.092C985.537 415.918 985.675 417.158 985.847 417.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.41 407.086L994.369 411.218L997.727 418.708L1006.77 414.318L1003.41 407.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.71 402.695L1003.41 407.086L1006.77 414.318L1016.07 409.669L1012.71 402.695Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1022.01 398.305L1012.71 402.695L1016.07 409.669L1025.11 405.278L1022.01 398.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.01 394.43L1022.01 398.304L1025.11 405.278L1031.3 402.437L1032.38 399.316C1033.2 396.962 1033.08 393.635 1030.66 394.221C1030.42 394.28 1030.2 394.353 1030.01 394.43Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.289 392.364L981.968 389.781L985.842 398.304L978.094 401.92L975.256 395.463C974.636 393.81 975.686 392.708 976.289 392.364Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.714 410.185L978.098 401.921L985.846 398.305L990.237 407.861L984.555 410.444C983.315 411.27 982.144 410.616 981.714 410.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.726 404.245L990.236 407.861L985.846 398.304L993.336 394.688L997.726 404.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1004.96 400.629L997.727 404.245L993.336 394.689L1000.57 391.331L1004.96 400.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.19 397.271L1004.96 400.628L1000.57 391.33L1007.54 387.973L1012.19 397.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1015.29 384.357L1007.54 387.973L1012.19 397.271L1019.68 393.655L1015.29 384.357Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1022.52 381L1015.29 384.358L1019.68 393.656L1026.91 390.04L1022.52 381Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.01 377.384L1022.52 381L1026.91 390.039L1034.14 386.424L1030.01 377.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1040.6 372.219C1041.08 375.794 1040.49 378.826 1039.66 381.065C1038.73 383.561 1036.53 385.233 1034.14 386.424L1030.01 377.384L1040.6 372.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1037.5 364.47C1039.36 367.363 1040.34 370.841 1040.6 372.218L1033.37 375.834L1029.24 367.053C1030.18 366.536 1032.49 365.297 1034.14 364.47C1035.8 363.644 1037.07 364.126 1037.5 364.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1021.49 370.927L1029.24 367.053L1033.37 375.834L1025.62 379.45L1021.49 370.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1013.48 374.801L1021.49 370.927L1025.62 379.45L1017.61 383.324L1013.48 374.801Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.73 378.417L1013.48 374.801L1017.61 383.324L1009.86 386.94L1005.73 378.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.984 382.033L1005.73 378.417L1009.87 386.94L1001.86 390.556L997.984 382.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.236 385.907L997.985 382.033L1001.86 390.556L993.852 394.431L990.236 385.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.238 385.907L981.973 389.781L985.847 398.305L993.853 394.43L990.238 385.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M887.441 446.086L895.448 442.212L899.58 450.735L893.124 453.834C891.677 454.454 890.627 453.232 890.282 452.543L887.441 446.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M907.586 446.602L899.58 450.735L895.447 442.212L903.712 438.079L907.586 446.602Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M915.852 442.728L907.587 446.602L903.713 438.079L911.978 434.205L915.852 442.728Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M920.243 430.331L911.979 434.205L915.853 442.728L924.118 438.854L920.243 430.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M928.507 426.457L920.242 430.331L924.116 438.854L930.573 435.755C931.813 435.135 931.606 433.258 931.348 432.397L928.507 426.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M924.635 418.192L928.509 426.457L921.536 429.556L916.887 420L921.019 417.934C923.085 416.694 924.291 417.589 924.635 418.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.17 423.358L916.885 420L921.534 429.556L914.561 432.914L910.17 423.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M903.197 426.715L910.171 423.357L914.561 432.914L907.588 436.271L903.197 426.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M896.223 430.072L903.196 426.715L907.587 436.271L900.613 439.629L896.223 430.072Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M889.508 433.172L896.223 430.072L900.614 439.629L893.899 442.986L889.508 433.172Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M884.602 435.496L889.509 433.172L893.9 442.986L887.443 446.086L883.826 438.854C883 437.201 883.913 435.841 884.602 435.496Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1016.32 364.471L1010.9 353.107L1016.58 350.266L1022 361.63L1016.32 364.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.14 359.821L1022.01 361.629L1016.58 350.265L1020.71 347.94L1027.43 354.656C1028.26 357.342 1026.91 359.219 1026.14 359.821Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1014.26 341.742L1020.72 347.941L1015.81 350.524L1010.9 353.106L1007.29 345.358L1014.26 341.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1002.12 330.378L1014.26 341.742L1007.28 345.358L1000.57 331.152C1000.57 329.913 1001.6 330.119 1002.12 330.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1040.78 352.349L1050.93 351.815L1051.19 359.305L1043.96 359.822L1039.48 355.281C1038.86 353.575 1040.09 352.615 1040.78 352.349Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1061.52 351.04L1050.94 351.815V352.073L1051.19 359.305L1061.52 358.788V351.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.86 350.266L1061.53 351.04V358.789L1071.86 358.014V350.266Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1081.93 349.232L1071.86 350.266V357.756L1082.44 356.981L1081.93 349.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1092.52 348.458L1081.93 349.233L1082.44 356.981L1092.78 355.948L1092.52 348.458Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.85 355.173L1092.78 355.948L1092.52 348.458L1102.85 347.425V355.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1113.18 354.398L1102.85 355.173V347.424L1112.92 346.649L1113.18 354.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1123.77 353.366L1113.18 354.399L1112.92 346.65L1123.51 345.617L1123.77 353.366Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1133.84 344.842L1123.51 345.617L1123.77 353.365L1134.1 352.332L1133.84 344.842Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1144.69 351.299L1134.1 352.332L1133.84 344.842L1144.17 343.809L1144.69 351.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1154.76 350.524L1144.69 351.299L1144.17 343.809L1154.5 342.775L1154.76 350.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1165.35 349.749L1154.76 350.524L1154.5 342.775L1164.84 341.742L1165.35 349.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1172.07 341.226L1164.84 341.743L1165.35 349.749L1176.2 348.716L1174.91 343.034C1174.7 341.381 1172.93 341.14 1172.07 341.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1178.01 355.173L1176.2 348.716L1167.94 349.491L1168.45 358.53L1176.2 357.756C1178.06 357.549 1178.18 355.948 1178.01 355.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1159.41 359.306L1168.45 358.531L1167.93 349.491L1159.15 350.266L1159.41 359.306Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1150.11 360.08L1159.41 359.305L1159.15 350.523L1149.6 351.04L1150.11 360.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1141.07 360.855L1150.11 360.08L1149.6 351.04L1140.56 351.815L1141.07 360.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1131.52 361.63L1141.07 360.855L1140.56 351.815L1131.26 352.59L1131.52 361.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1122.48 362.663L1131.52 361.63L1131.26 352.849L1122.22 353.623L1122.48 362.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1113.44 363.439L1122.48 362.664L1122.22 353.624L1113.44 354.399V363.439Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1103.88 364.213L1113.44 363.438L1113.18 354.656L1103.62 355.173L1103.88 364.213Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1094.84 364.987L1103.88 364.213L1103.62 355.173L1094.58 355.948L1094.84 364.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1085.54 365.763L1094.58 364.988L1094.33 355.948L1085.54 356.723V365.763Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1076.25 366.538L1085.54 365.763V356.981L1075.99 357.756L1076.25 366.538Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1067.21 367.312L1076.25 366.537L1075.99 357.756L1066.69 358.531L1067.21 367.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.17 368.087L1067.21 367.312L1066.69 358.53L1057.65 359.047L1058.17 368.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1052.74 368.345L1058.17 368.087L1057.65 359.047L1043.96 359.822L1052.74 368.345Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1077.86 272.007L1058.45 273.815L1076.57 264.517L1077.86 264.259V272.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1088.22 263.742L1077.86 264.259V272.007L1088.48 270.974L1088.22 263.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1099.09 270.2L1088.47 270.974L1088.21 263.743L1098.83 262.968L1099.09 270.2Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1109.44 261.935L1098.83 262.968L1099.09 270.199L1109.96 269.166L1109.44 261.935Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1120.83 268.133L1109.96 269.166L1109.44 261.934L1120.31 260.901L1120.83 268.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1131.7 267.1L1120.83 268.133L1120.31 260.901L1131.44 259.868L1131.7 267.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1142.05 259.093L1131.44 259.868L1131.7 267.099L1142.31 266.325L1142.05 259.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1149.19 258.465L1142.05 259.093L1142.31 266.325L1153.44 265.808C1153.18 264.517 1152.61 261.624 1152.4 260.385C1152.34 260.014 1152.22 259.695 1152.06 259.426C1151.51 258.479 1150.28 258.368 1149.19 258.465Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1154.99 271.491L1153.44 265.809L1145.16 266.325L1145.67 274.848L1153.96 274.073C1154.99 273.867 1155.08 272.266 1154.99 271.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1135.84 275.623L1145.68 274.848L1145.16 266.325L1135.32 266.842L1135.84 275.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1126 276.398L1135.84 275.623L1135.32 266.842L1125.75 267.617L1126 276.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1116.43 277.172L1126 276.398L1125.75 267.616L1115.91 268.649L1116.43 277.172Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1107.11 277.947L1116.43 277.173L1115.91 268.649L1106.59 269.424L1107.11 277.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1097.02 278.98L1107.11 278.205L1106.59 269.424L1096.5 270.457L1097.02 278.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1087.44 279.755L1097.02 278.98L1096.5 270.457L1086.92 271.232L1087.44 279.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1077.6 280.53L1087.44 279.756L1086.92 271.232L1077.35 272.007L1077.6 280.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1068.03 281.563L1077.6 280.53L1077.35 272.007L1067.77 273.04L1068.03 281.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.45 282.338L1068.03 281.563L1067.77 273.04L1058.45 273.815V282.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1045.77 283.371L1058.45 282.338V273.814L1046.36 279.735C1045.32 280.24 1044.35 281.194 1044.6 282.315C1044.78 283.126 1045.37 283.371 1045.77 283.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M992.675 304.04L1002.38 300.159V308.424L994.245 308.802C992.305 308.893 989.295 308.125 989.839 306.261C990.221 304.951 991.409 304.547 992.675 304.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1010.13 296.543L1002.38 300.159V308.424L1010.39 307.907L1010.13 296.543Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1020.72 307.133L1010.39 307.908L1010.13 299.643L1020.46 298.868L1020.72 307.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.53 306.358L1020.72 307.132L1020.46 298.868L1030.27 298.093L1030.53 306.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.56 290.604L1024.07 298.61L1010.13 299.643V296.544L1022.78 290.604H1023.56Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1033.89 289.57L1023.56 290.603L1024.07 298.61L1034.4 297.577L1033.89 289.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1040.34 297.06L1030.27 298.093L1030.53 306.358L1040.6 305.583L1040.34 297.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.68 304.808L1040.6 305.583L1040.35 297.06L1050.42 296.285L1050.68 304.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1044.48 288.795V296.802L1034.41 297.576L1033.89 289.57L1044.48 288.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1054.81 288.021L1044.48 288.795V296.802L1055.07 296.027L1054.81 288.021Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1064.88 287.245L1054.81 288.02L1055.07 296.027L1065.14 295.252L1064.88 287.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1060.75 304.033L1050.68 304.808L1050.42 296.543L1060.23 295.769L1060.75 304.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1070.56 303L1060.75 304.033L1060.23 295.768L1070.31 294.735L1070.56 303Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1075.73 293.961L1065.14 294.994V287.246L1075.73 286.213V293.961Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1085.8 285.438L1075.73 286.212V293.961L1086.06 293.186L1085.8 285.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1096.13 284.404L1085.8 285.437L1086.06 293.186L1096.13 292.411V284.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1080.89 302.225L1070.56 303L1070.3 294.477L1080.64 293.702L1080.89 302.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1090.97 301.451L1080.89 302.226L1080.64 293.703L1090.71 292.928L1090.97 301.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1090.97 301.451L1100.53 300.676V291.895L1090.71 292.928L1090.97 301.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1110.6 299.901L1100.52 300.675V291.894L1110.34 291.119L1110.6 299.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1120.67 298.868L1110.6 299.901L1110.34 291.12L1120.41 290.345L1120.67 298.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1130.48 298.093L1120.67 298.868L1120.41 290.345L1130.23 289.312L1130.48 298.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.82 297.06L1130.48 298.093L1130.23 289.311L1140.56 288.278L1140.82 297.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1140.81 297.06L1150.63 296.285L1150.37 287.504L1140.56 288.279L1140.81 297.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1158.89 295.51L1150.63 296.285L1150.37 287.503L1159.67 286.729L1160.96 292.152C1161.37 294.425 1159.67 295.338 1158.89 295.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1148.31 287.762L1147.79 279.497L1152.95 279.239C1158.12 278.981 1157.95 280.358 1158.38 281.305L1159.67 286.729L1148.31 287.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1137.46 280.272L1147.79 279.497L1148.3 287.762L1137.97 288.537L1137.46 280.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1127.13 281.305L1137.46 280.271L1137.97 288.536L1127.64 289.569L1127.13 281.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1117.31 290.604L1127.64 289.571L1127.13 281.306L1116.8 282.339L1117.31 290.604Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1106.72 291.378L1117.31 290.603L1116.79 282.338L1106.46 283.371L1106.72 291.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1096.13 284.404L1106.46 283.371L1106.72 291.378L1096.13 292.411V284.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.92 492.059V489.477H754.173L751.848 494.9C751.641 497.793 753.828 497.655 754.947 497.225L761.92 492.059Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.922 480.953V489.476H754.174L757.531 480.953H761.922Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M776.642 480.694L761.92 491.8V480.953L776.642 480.694Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M760.631 473.463L757.531 480.953H770.187V473.463H760.631Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M781.55 473.463H770.186V480.953H776.384L782.841 475.787C783.461 474.341 782.239 473.635 781.55 473.463Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M838.629 364.47L831.914 366.537V372.735H844.053C843.192 370.669 841.315 366.278 840.696 365.245C840.076 364.212 839.06 364.298 838.629 364.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M831.914 379.192V372.735H844.053L847.152 379.192H831.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.026 386.941L847.151 379.192H842.244V390.04L849.476 389.782C851.129 389.575 851.198 387.802 851.026 386.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M834.498 390.04H842.246V379.192H834.498V390.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M827.008 390.04H834.498V379.192H827.008V390.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M819.516 390.298L827.006 390.04V379.192H819.516V390.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M812.025 379.451L819.515 379.192V390.298L812.025 390.557V379.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M804.537 379.708L812.027 379.45V390.556L804.537 390.814V379.708Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M798.542 390.815H804.537L804.537 379.709H799.629L796.014 387.716C795.871 388.361 795.868 388.891 795.944 389.321C796.142 390.439 797.407 390.815 798.542 390.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M802.728 376.351C800.869 377.178 799.887 378.934 799.629 379.709L815.9 379.45V371.702C812.285 372.907 804.588 375.525 802.728 376.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M824.942 368.861L815.902 371.702V379.451L824.942 379.192V368.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M831.915 366.536L824.941 368.861V379.192H831.915V366.536Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M792.913 396.238H797.562V407.344H788.264L792.913 396.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M805.051 395.98L797.561 396.239V407.345H805.051V395.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M812.541 395.98H805.051V407.086H812.541V395.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M785.164 414.577L788.263 407.345H794.72V416.901L786.197 417.159C784.544 416.953 784.819 415.437 785.164 414.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M803.244 416.901H794.721V407.345H803.244V416.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M811.509 416.901H803.244V407.345H811.509V416.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M820.031 395.722L812.541 395.98V407.086L820.031 406.828V395.722Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M827.521 395.464L820.031 395.722V406.828L827.521 406.57V395.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M835.012 395.205L827.521 395.463V406.311L835.012 406.053V395.205Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M842.243 394.947L835.012 395.206V406.053L842.243 405.795V394.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M849.732 394.947H842.242V405.678H849.732V394.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M854.64 394.947H849.732V405.537H859.547L854.64 394.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M863.164 412.768L859.548 405.536H853.35V416.126H861.356C863.216 415.919 863.336 413.629 863.164 412.768Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M845.084 416.126H853.349V405.536L845.084 405.794V416.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M836.561 416.126H845.084V405.795L836.561 406.053V416.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M828.297 416.126H836.562V406.053L828.297 406.569V416.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M819.773 416.384L828.297 416.126V406.569L819.773 406.828V416.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M811.508 416.901L819.773 416.384V406.828L811.508 407.086V416.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.455 310.232L988.17 316.947L979.389 321.08L974.998 311.782L978.356 310.232C979.389 309.612 980.852 309.974 981.455 310.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M967.767 314.881L974.998 311.781L978.356 319.013L969.058 323.404L966.475 317.463C966.062 316.224 967.164 315.225 967.767 314.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M972.416 330.894L969.059 323.404L978.357 319.014L981.714 326.245L972.416 330.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M989.203 317.722L988.17 316.947L979.389 321.08L983.005 328.311L992.044 323.662L989.203 317.722Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.032 338.126L972.416 330.894L981.972 326.245L985.33 333.735L976.032 338.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M986.105 335.285L983.006 328.311L992.046 323.662L995.661 330.636L986.105 335.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M979.647 345.874L976.031 338.126L985.329 333.735L988.945 341.484L979.647 345.874Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M999.019 337.868L995.662 330.636L986.105 335.285L989.463 342.517L999.019 337.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M983.006 352.848L979.648 345.874L988.946 341.483L992.304 348.457L983.006 352.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1002.38 345.099L999.019 337.867L989.463 342.516L993.079 349.748L1002.38 345.099Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M995.92 355.947L992.304 348.457L983.006 352.848L986.622 360.338L995.92 355.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.48 352.073L1002.38 345.1L993.078 349.749L996.436 356.722L1005.48 352.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1009.09 359.305L1005.48 352.073L996.436 356.722L999.793 363.954L1009.09 359.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.237 368.086L986.621 360.338L995.919 355.947L999.535 363.437L990.237 368.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M992.563 373.51L990.238 368.087L999.536 363.438L1002.89 370.928C1001 371.875 996.85 373.975 995.404 374.802C993.957 375.628 992.993 374.285 992.563 373.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.19 366.02L1009.09 359.305L999.793 363.954L1002.89 370.927L1012.19 366.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M961.829 319.013L964.411 324.954L955.372 329.344L951.756 321.854L957.955 318.755C959.814 317.515 961.312 318.411 961.829 319.013Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M944.007 325.47L951.754 321.854L955.37 329.345L946.33 333.735C945.556 332.1 944.11 329.293 943.49 328.053C942.87 326.813 943.576 325.815 944.007 325.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M967.768 332.185L964.411 324.953L955.371 329.344L958.987 336.834L967.768 332.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M949.948 341.483L958.988 336.834L955.372 329.344L946.332 333.734L949.948 341.483Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M953.305 348.973L949.947 341.483L958.987 336.834L962.603 344.324L953.305 348.973Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M971.384 339.934L967.768 332.186L958.986 336.835L962.602 344.325L971.384 339.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M956.662 356.463L953.305 348.973L962.603 344.324L965.96 351.814L956.662 356.463Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M974.999 347.424L965.959 351.814L962.602 344.324L971.383 339.934L974.999 347.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M978.358 354.656L975.001 347.424L965.961 351.815L969.577 359.305L978.358 354.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M960.278 363.954L969.576 359.305L965.96 351.814L956.662 356.463L960.278 363.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M963.637 371.444L960.279 363.954L969.577 359.305L972.935 366.795L963.637 371.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M981.974 362.145L978.358 354.655L969.576 359.304L972.934 366.794L981.974 362.145Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M985.589 369.894L981.973 362.146L972.934 366.795L976.549 374.285L985.589 369.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M967.509 378.934L963.635 371.444L972.933 366.795L976.549 374.285L967.509 378.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.093 384.357L967.51 378.933L976.549 374.284L980.165 381.774C978.53 382.635 974.793 384.564 972.934 385.39C971.074 386.217 970.437 385.046 970.093 384.357Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M987.655 378.158L980.165 381.774L976.549 374.284L985.589 369.894L988.43 375.576C988.843 377.022 988.085 377.9 987.655 378.158Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M938.53 328.389L941.166 334.137L931.942 338.385L928.252 331.138L934.577 328.139C936.475 326.94 938.003 327.806 938.53 328.389Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M920.248 334.769L928.171 331.153L931.868 338.643L922.625 343.034C921.832 341.398 920.354 338.592 919.72 337.352C919.086 336.112 919.808 335.114 920.248 334.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M944.356 341.529L940.949 334.062L931.775 338.596L935.445 346.329L944.356 341.529Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M926.271 351.129L935.444 346.329L931.775 338.596L922.602 343.129L926.271 351.129Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M929.679 358.862L926.271 351.129L935.445 346.329L939.114 354.062L929.679 358.862Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M948.026 349.529L944.357 341.529L935.445 346.329L939.115 354.062L948.026 349.529Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M933.085 366.596L929.678 358.862L939.113 354.062L942.52 361.796L933.085 366.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M951.694 357.263L942.521 361.796L939.113 354.063L948.025 349.529L951.694 357.263Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M955.102 364.729L951.695 357.263L942.521 361.796L946.191 369.529L955.102 364.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M936.755 374.329L946.191 369.529L942.521 361.796L933.086 366.596L936.755 374.329Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M940.161 382.062L936.754 374.329L946.189 369.529L949.597 377.263L940.161 382.062Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.772 372.463L955.103 364.729L946.191 369.529L949.599 377.263L958.772 372.463Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.44 380.462L958.771 372.462L949.598 377.262L953.267 384.995L962.44 380.462Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M944.094 389.796L940.162 382.063L949.598 377.263L953.267 384.996L944.094 389.796Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M946.715 395.395L944.094 389.795L953.267 384.995L956.936 392.728C955.276 393.617 951.485 395.608 949.598 396.462C947.711 397.315 947.064 396.106 946.715 395.395Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M964.536 388.996L956.935 392.729L953.266 384.996L962.439 380.463L965.322 386.329C965.741 387.823 964.973 388.729 964.536 388.996Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M914.767 337.687L917.919 344.842L909.137 349.491L904.488 340.436L910.813 337.437C912.711 336.238 914.24 337.104 914.767 337.687Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M896.485 344.067L904.407 340.451L907.846 347.166L898.548 351.299C897.756 349.663 896.59 347.89 895.957 346.65C895.323 345.41 896.045 344.411 896.485 344.067Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M921.625 352.377L918.218 344.91L909.045 349.443L912.714 357.177L921.625 352.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M902.164 358.53L910.946 354.14L907.588 347.166L898.807 351.298L902.164 358.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M905.263 365.504L902.164 358.273L911.204 353.882L914.561 361.114L905.263 365.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.295 360.377L921.626 352.377L912.715 357.177L916.384 364.91L925.295 360.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M908.879 372.643L905.521 365.504L914.561 361.113L917.661 368.345L908.879 372.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M928.963 368.11L919.79 372.643L916.383 364.91L925.294 360.377L928.963 368.11Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M932.372 375.577L928.964 368.11L919.791 372.644L923.46 380.377L932.372 375.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M912.237 379.709L921.018 375.06L917.66 368.087L908.879 372.478L912.237 379.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M915.594 386.941L912.236 379.451L921.018 375.061L924.117 382.292L915.594 386.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M936.041 383.31L932.372 375.577L923.461 380.377L926.868 388.11L936.041 383.31Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M939.71 391.309L936.041 383.31L926.867 388.11L930.537 395.843L939.71 391.309Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M918.693 393.656L915.594 386.941L924.375 382.292L927.475 389.265L918.693 393.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M923.983 406.243L921.793 400.888L930.833 396.497L934.205 403.576C932.545 404.465 928.753 406.456 926.866 407.31C924.979 408.163 924.333 406.954 923.983 406.243Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M921.793 400.888L930.832 396.497L927.475 389.266L918.693 393.656L921.793 400.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.805 399.843L934.204 403.576L930.535 395.843L939.708 391.31L942.592 397.176C943.011 398.669 942.242 399.576 941.805 399.843Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M868.071 358.272L869.879 362.146L860.581 366.279L856.965 359.032L863.938 356.723C866.779 356.206 867.544 357.689 868.071 358.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.875 360.516L856.883 359.047L860.323 365.762L851.025 369.895C850.232 368.259 849.334 365.452 848.7 364.212C847.786 362.424 849.948 361.081 851.875 360.516Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M873.238 369.378L869.88 362.146L860.582 366.279L864.456 373.769L873.238 369.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M876.852 376.868L873.237 369.378L864.455 373.769L867.554 381L876.852 376.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M858.256 384.617L867.296 380.226L863.938 372.994L854.898 377.385L858.256 384.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M854.9 377.384L863.939 372.993L860.323 365.762L851.025 369.894L854.9 377.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M880.21 384.358L876.852 376.868L867.812 381.001L871.17 388.491L880.21 384.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M861.872 392.106L858.256 384.616L867.296 380.226L870.653 387.716L861.872 392.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M883.827 391.59L874.788 396.239L871.172 388.491L880.212 384.358L883.827 391.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M887.184 399.08L883.827 391.59L874.787 395.981L878.145 403.212L887.184 399.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M865.231 399.597L874.012 395.206L870.654 387.716L861.873 392.107L865.231 399.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M868.846 407.087L865.23 399.597L874.27 395.206L877.628 402.438L868.846 407.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M890.542 406.054L887.184 399.08L878.145 403.213L881.502 410.444L890.542 406.054Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M893.737 413.005L890.542 406.054L881.244 410.444L884.563 417.539L893.737 413.005Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M872.462 414.577L868.846 407.087L877.627 402.438L881.243 410.186L872.462 414.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M878.009 427.938L875.818 422.583L884.858 418.192L888.23 425.272C886.57 426.16 882.779 428.152 880.892 429.005C879.004 429.858 878.358 428.649 878.009 427.938Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M875.819 422.583L884.858 418.193L880.984 410.444L872.461 414.577L875.819 422.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M895.833 421.539L888.232 425.272L884.562 417.539L893.736 413.006L896.619 418.872C897.038 420.366 896.269 421.272 895.833 421.539Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M772.511 236.881C771.891 235.022 773.458 234.901 774.319 235.073L784.391 243.855L778.451 248.245C776.729 245.232 773.13 238.741 772.511 236.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M789.815 248.245L784.392 243.854L778.451 248.245C779.226 249.881 780.931 253.359 781.551 254.186C782.325 255.219 784.392 254.702 784.65 253.669C784.908 252.636 786.2 251.086 787.749 250.57C788.989 250.156 789.643 248.848 789.815 248.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M919.728 408.636L916.887 402.438L907.848 406.828L911.464 414.318L918.954 410.702C919.987 410.289 919.901 409.153 919.728 408.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M903.972 417.934L911.462 414.318L907.846 406.828L898.807 411.219L901.389 416.643C902.009 418.089 903.37 418.106 903.972 417.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M913.528 395.206L916.886 402.438L907.846 406.829L904.488 399.597L913.528 395.206Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M898.807 411.219L907.847 406.828L904.489 399.597L895.449 403.987L898.807 411.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M891.834 396.238L895.45 403.987L904.231 399.596L900.874 391.848L891.834 396.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.171 387.974L901.131 392.364L904.23 399.596L913.528 395.205L910.171 387.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M906.814 380.742L910.171 387.974L901.132 392.365L897.516 384.875L906.814 380.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.219 388.749L891.835 396.239L900.874 391.848L897.258 384.358L888.219 388.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M884.859 381.259L888.217 388.749L897.257 384.358L893.641 376.868L884.859 381.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M903.198 373.252L894.158 377.901L897.516 384.874L906.814 380.742L903.198 373.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M899.841 366.021L903.199 373.252L894.159 377.901L890.543 370.411L899.841 366.021Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M881.244 373.769L884.86 381.259L893.641 376.868L890.026 369.378L881.244 373.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M896.225 358.53L899.841 366.02L890.543 370.411L887.186 362.921L896.225 358.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M877.629 366.278L881.245 373.768L890.026 369.378L886.669 361.888L877.629 366.278Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M875.235 361.492L877.628 366.278L886.668 361.888L883.827 355.947C881.545 356.484 879.503 356.469 878.069 356.298C876.904 356.159 875.239 355.801 874.506 356.717C873.373 358.131 874.424 359.871 875.235 361.492Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M893.592 353.266L896.224 358.53L887.184 362.921L883.826 355.948C886.173 355.322 887.877 353.966 888.829 352.933C889.323 352.396 889.733 351.744 890.391 351.428C890.748 351.256 891.09 351.193 891.404 351.201C892.478 351.226 893.111 352.305 893.592 353.266Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M782.066 422.583L788.523 422.325V431.881H778.191L782.066 422.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M774.834 439.63L778.191 431.882H783.874V441.955H776.384C774.731 441.748 774.662 440.319 774.834 439.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M792.138 441.696L783.873 441.955V431.882H791.88L792.138 441.696Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M800.146 441.438L792.139 441.696L791.881 431.881L800.146 431.623V441.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M797.563 422.066L788.523 422.325V431.623H797.563V422.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M806.344 421.809L797.562 422.067V431.365H806.344V421.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M808.153 441.179L800.146 441.438V431.623H808.153V441.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.417 441.179H808.152V431.623H816.417V441.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M815.383 421.55L806.344 421.808V431.364H815.383V421.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M824.164 421.55H815.383V431.106H824.164V421.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M832.947 421.292L824.166 421.55V430.848H832.947V421.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M824.164 441.179V431.106H816.416V441.179H824.164Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M832.689 440.92L824.166 441.179V430.848H832.947L832.689 440.92Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M840.954 440.662L832.689 440.92L832.948 430.589L840.954 430.331V440.662Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M842.243 430.331L832.945 430.589V421.291L842.243 421.033V430.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M848.96 440.404L840.953 440.663V430.332L848.96 430.073V440.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.966 440.146L848.959 440.404V430.073L856.966 429.814V440.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M865.232 440.146H856.967V429.815L865.232 429.557V440.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M870.154 440.146H865.23V429.557H871.171C872.032 431.278 873.702 434.722 874.528 436.788C874.668 437.137 874.746 437.457 874.775 437.748C874.977 439.78 872.196 440.146 870.154 440.146Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M866.524 420.259L871.173 429.557H860.067L859.809 420.259H866.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.025 420.517L859.807 420.259L860.065 429.557L851.284 429.815L851.025 420.517Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M842.244 421.033L851.026 420.517L851.284 430.073L842.244 430.331V421.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M771.478 447.636H776.902V457.967H767.346L771.478 447.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M764.247 465.199L767.346 457.967H773.545V467.781H765.022C763.782 467.575 763.988 465.973 764.247 465.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M782.068 467.782H773.545V457.967L782.068 457.709V467.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M790.85 467.523L782.068 467.781V457.708L790.85 457.45V467.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M785.167 447.378L776.902 447.636V457.967L785.167 457.709V447.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.373 467.265L790.85 467.523V457.451L799.373 457.192V467.265Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M807.896 467.007L799.373 467.266V457.193L807.896 456.935V467.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.676 466.749L807.895 467.007V456.934L816.676 456.676V466.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M793.173 447.119L785.166 447.377V457.709L793.173 457.45V447.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M800.922 446.861L793.174 447.12V457.451L800.922 457.192V446.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M808.928 446.422L800.922 446.861V457.192L808.928 456.934V446.422Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.934 456.676V446.216L813.06 446.345L808.928 446.443V456.934L816.934 456.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M824.942 445.828L816.936 446.175V456.676L824.942 456.418V445.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M832.948 445.569L824.941 445.828V456.417L832.948 456.159V445.569Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M825.201 466.491L816.678 466.749V456.676L825.201 456.418V466.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M833.983 466.49H825.201V456.417L833.724 456.159L833.983 466.49Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M842.504 466.232L833.981 466.491L833.723 456.16L842.246 455.901L842.504 466.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.028 465.974L842.504 466.232L842.246 455.901L850.769 455.643L851.028 465.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M840.954 445.395L832.947 445.57V456.159L840.954 455.901V445.395Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M848.703 445.167L840.955 445.311V455.901L848.703 455.643V445.167Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.71 445.053L848.703 445.132V455.642L856.71 455.384V445.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M864.718 444.795L856.711 445.053V455.384L864.718 455.276V444.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M859.809 465.715L851.028 465.973L850.77 455.642L859.809 455.384V465.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M868.075 465.457L859.811 465.715V455.384L868.075 455.126V465.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M876.597 465.338L868.074 465.457V455.126L876.597 454.977V465.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.379 464.94L876.598 465.336V454.976L883.055 454.867L886.67 462.099C887.29 463.752 886.068 464.682 885.379 464.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M878.663 445.311L883.054 454.868H872.723V444.278H876.597C877.837 444.278 878.491 444.967 878.663 445.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M864.717 444.795L872.723 444.278V455.126H864.717V444.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1166.64 320.305L1159.41 321.079L1160.18 329.086L1170.51 328.311C1170.17 326.761 1169.38 323.301 1168.96 321.854C1168.55 320.408 1167.24 320.218 1166.64 320.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1172.06 333.477L1170.51 328.312L1161.22 329.086L1161.73 337.351L1170.77 336.576C1172.22 336.163 1172.24 334.252 1172.06 333.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1151.4 338.384L1161.73 337.351L1161.22 329.086L1150.88 329.861L1151.4 338.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1141.07 339.158L1151.4 338.384L1150.89 329.86L1140.81 330.893L1141.07 339.158Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1131 340.192L1141.07 339.158L1140.81 330.894L1130.48 331.927L1131 340.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1120.67 341.225L1131 340.192L1130.48 331.927L1120.41 332.702L1120.67 341.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1110.59 342L1120.67 341.225L1120.41 332.702L1110.59 333.219V342Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1100 342.775L1110.59 342V333.735L1100 334.51V342.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1149.34 321.854L1159.41 321.079L1160.18 329.086L1149.85 329.861L1149.34 321.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1139.52 322.888L1149.34 321.854L1149.85 329.861L1140.04 330.894L1139.52 322.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1129.71 323.663L1139.52 322.888L1140.04 330.894L1130.22 331.927L1129.71 323.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1119.63 324.437L1129.71 323.662L1130.22 331.927L1120.15 332.702L1119.63 324.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1110.08 325.212L1119.63 324.438L1120.15 332.702L1110.08 333.219V325.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1100 325.987L1110.08 325.212V333.477L1100 334.252V325.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1089.42 344.066L1100.01 342.775V334.51L1089.42 335.543V344.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.6 344.841C1082.87 344.583 1089.21 344.066 1089.41 344.066V335.543L1079.34 336.576L1079.6 344.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1069.01 345.616L1079.6 344.841L1079.34 336.576L1068.75 337.609L1069.01 345.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.94 346.391L1069.01 345.616L1068.75 337.609L1058.94 338.384V346.391Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1048.61 347.424L1058.94 346.39V338.384L1048.35 339.159L1048.61 347.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1038.28 348.198L1048.61 347.423L1048.35 339.158L1038.02 339.933L1038.28 348.198Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.3 348.457L1038.28 348.198L1038.02 339.934L1023.81 340.967L1031.3 348.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1020.09 337.242L1023.81 340.967L1030.53 340.45V332.443L1020.97 332.96C1020.08 333.123 1019.5 333.477 1019.14 333.895C1018.27 334.903 1019.15 336.301 1020.09 337.242Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1040.6 331.669L1030.53 332.444V340.45L1040.86 339.676L1040.6 331.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.41 330.636L1040.6 331.669L1040.86 339.675L1050.67 338.901L1050.41 330.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1060.23 329.86L1050.42 330.635L1050.67 338.9L1060.75 338.125L1060.23 329.86Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1070.3 328.828L1060.23 329.861L1060.75 338.126L1070.56 337.351L1070.3 328.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1080.12 328.053L1070.3 328.828L1070.56 337.351L1080.63 336.318L1080.12 328.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1089.93 327.02L1080.12 328.053L1080.63 336.318L1090.45 335.543L1089.93 327.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1089.93 327.019L1100 325.986V334.509L1090.45 335.284L1089.93 327.019Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M763.213 214.411L769.67 206.921L763.13 201.607C761.994 200.684 760.327 199.513 759.323 200.578C759.028 200.89 758.877 201.317 758.815 201.746C758.717 202.434 758.947 203.117 759.192 203.767L763.213 214.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M766.829 223.967L763.213 214.411L765.537 211.828L775.094 219.576L769.67 226.292L766.829 223.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.226 214.411L775.093 219.577L765.537 211.828L769.67 206.921L779.226 214.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M788.524 221.643L779.226 214.411L775.094 219.577L784.392 226.808L788.524 221.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M796.273 227.841L788.525 221.643L784.393 226.808L795.757 235.59L796.273 227.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M795.33 242.839L795.756 235.589L790.333 231.457L784.65 238.431L792.822 244.92C793.227 245.242 793.738 245.627 794.217 245.432C795.155 245.05 795.27 243.85 795.33 242.839Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M777.16 232.233L784.65 238.431L790.332 231.458L782.584 225.518L777.16 232.233Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M769.67 226.291L777.16 232.232L782.584 225.517L775.094 219.576L769.67 226.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M798.081 218.286L798.598 212.087L788.008 209.246L786.717 214.153L791.606 217.82C793.828 219.487 797.624 221.026 798.081 218.286Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.63 204.08L798.597 212.087L788.008 209.246L790.074 201.756L799.63 204.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M801.18 195.299L799.63 204.081L790.332 201.756L792.657 192.975L801.18 195.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M780.002 208.73L786.717 214.154L790.075 201.756L782.068 199.948L780.002 208.73Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M783.876 190.908L782.068 199.948L790.333 201.756L792.658 192.974L783.876 190.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M773.802 188.584L783.875 190.908L782.325 198.399L771.994 195.816L773.802 188.584Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M770.445 201.239L780.002 208.729L782.326 198.398L771.995 195.815L770.445 201.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M763.988 196.074L770.445 201.239L773.803 188.584L766.571 187.034L763.988 196.074Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M757.333 190.528L763.988 196.074L766.571 187.034L756.274 184.694C755.576 184.535 754.654 184.532 754.276 185.141C753.075 187.074 755.585 189.071 757.333 190.528Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1166.64 312.557L1164.83 307.392L1155.28 308.425L1155.79 316.173L1164.58 315.398C1166.43 315.192 1166.73 313.418 1166.64 312.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1163.54 301.451L1164.83 307.391L1153.99 308.425L1153.73 300.418L1160.19 299.901C1162.77 299.901 1163.28 300.934 1163.54 301.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1145.2 317.206L1155.79 316.173L1155.28 308.425L1144.95 309.458L1145.2 317.206Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1143.4 301.451L1153.73 300.418L1153.99 308.425L1143.65 309.458L1143.4 301.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1133.07 302.226L1143.4 301.451L1143.66 309.458L1133.58 310.233L1133.07 302.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1134.62 317.98L1145.21 317.205L1144.95 309.457L1134.36 310.232L1134.62 317.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1124.03 319.014L1134.62 317.981L1134.36 310.232L1123.51 311.007L1124.03 319.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1122.99 303L1133.07 302.226L1133.58 310.232L1123.51 311.007L1122.99 303Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1113.44 320.047L1124.03 319.013L1123.51 311.007L1113.18 312.04L1113.44 320.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.85 321.081L1113.44 320.048L1113.18 312.041L1102.59 313.074L1102.85 321.081Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1112.66 303.776L1122.99 303.001L1123.51 311.008L1113.18 312.041L1112.66 303.776Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.33 304.809L1112.66 303.775L1113.18 312.04L1102.85 313.073L1102.33 304.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1092.26 305.583L1102.33 304.809L1102.85 313.073L1092.52 313.848L1092.26 305.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1092.52 321.855L1102.85 321.08L1102.59 313.073L1092 313.848L1092.52 321.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1081.93 322.63L1092.52 321.855L1092 313.849L1081.67 314.882L1081.93 322.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1082.18 306.616L1092.26 305.583L1092.51 313.848L1082.18 314.881V306.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.34 323.663L1081.93 322.63L1081.67 314.882L1071.08 315.915L1071.34 323.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.6 307.391L1082.19 306.616V314.881L1071.85 315.914L1071.6 307.391Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1061.78 308.425L1071.6 307.392L1071.85 315.915L1062.04 316.69L1061.78 308.425Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1060.75 324.696L1071.34 323.663L1071.08 315.915L1060.23 316.948L1060.75 324.696Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.16 325.73L1060.75 324.697L1060.23 316.948L1049.64 317.723L1050.16 325.73Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1039.31 326.504L1050.16 325.729L1049.64 317.723L1039.05 318.756L1039.31 326.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1028.98 327.537L1039.31 326.504L1039.05 318.756L1028.72 319.531L1028.98 327.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1018.39 328.312L1028.98 327.537L1028.72 319.53L1017.87 320.563L1018.39 328.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.16 329.087L1018.39 328.312L1017.87 320.563L1003.93 321.597L1011.16 329.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1051.45 309.2L1061.78 308.425L1062.04 316.69L1051.71 317.465L1051.45 309.2Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.12 309.974L1051.45 309.199L1051.71 317.464L1041.38 318.497L1041.12 309.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1031.04 310.748L1041.12 309.974L1041.38 318.497L1031.3 319.272L1031.04 310.748Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1020.71 311.782L1031.05 310.749L1031.3 319.272L1021.23 320.305L1020.71 311.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1010.38 312.815L1020.71 311.782L1021.23 320.305L1010.9 321.08L1010.38 312.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.09 313.59L1010.38 312.815L1010.9 321.08L1003.93 321.597L1001.54 319.214C1000.07 317.74 998.457 315.297 1000.1 314.011C1000.43 313.746 1000.8 313.622 1001.09 313.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M724.729 520.212L739.709 508.848L730.927 504.974L724.729 520.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M721.63 522.537L724.729 520.213L726.02 516.855L716.722 512.723L713.623 520.471C714.863 522.95 719.477 522.882 721.63 522.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M719.822 505.232L716.723 512.722L726.021 516.855L729.12 509.365L719.822 505.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.922 497.742L719.822 505.232L729.12 509.365L732.22 501.875L722.922 497.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M741.001 507.815L739.709 508.848L730.928 504.973L734.027 497.483L743.583 501.874L741.001 507.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M746.681 494.384L743.582 501.874L734.025 497.484L737.125 490.252L746.681 494.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.021 490.252L722.922 497.742L732.22 501.874L735.319 494.384L726.021 490.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M729.119 483.021L726.02 490.252L735.318 494.385L738.417 487.153L729.119 483.021Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M749.781 487.153L746.681 494.385L737.125 490.252L740.224 483.021L749.781 487.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M732.218 475.271L729.119 483.02L738.417 487.152L741.516 479.404L732.218 475.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.88 479.921L749.781 487.153L740.225 483.02L743.066 475.53L752.88 479.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M755.722 472.69L752.881 479.921L743.066 475.531L746.166 468.299L755.722 472.69Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M758.822 464.941L755.722 472.689L746.166 468.299L749.265 460.809L758.822 464.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.663 457.709L758.822 464.94L749.266 460.808L752.107 453.576L761.663 457.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M735.318 467.782L732.219 475.272L741.517 479.405L744.616 471.656L735.318 467.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M738.418 460.292L735.318 467.782L744.616 471.656L747.716 464.424L738.418 460.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M741.517 452.802L738.418 460.292L747.716 464.424L750.815 456.676L741.517 452.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M744.617 445.312L741.518 452.802L750.816 456.676L753.915 449.186L744.617 445.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M747.715 437.821L744.615 445.311L753.913 449.186L757.013 441.695L747.715 437.821Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M764.761 450.477L761.662 457.709L752.105 453.577L755.205 446.345L764.761 450.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M767.861 442.987L764.761 450.477L755.205 446.345L758.304 438.854L767.861 442.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M770.96 435.755L767.861 442.987L758.305 438.855L761.404 431.623L770.96 435.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M751.072 430.073L747.715 437.822L757.013 441.696L760.37 433.947L751.072 430.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M753.913 422.842L751.072 430.074L760.37 433.948L763.211 426.716L753.913 422.842Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M774.06 428.524L770.961 435.756L761.404 431.623L764.245 424.392L774.06 428.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M777.16 421.292L774.06 428.523L764.504 424.391L767.345 417.159L777.16 421.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.999 414.06L777.158 421.291L767.344 417.159L770.443 409.669L779.999 414.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M783.101 406.57L780.002 414.06L770.445 409.67L773.286 402.18L783.101 406.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M757.013 415.352L753.914 422.842L763.47 426.716L766.311 419.226L757.013 415.352Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M760.371 407.861L757.014 415.351L766.312 419.484L769.669 411.735L760.371 407.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M763.47 400.371L760.371 407.861L769.669 411.735L772.51 404.245L763.47 400.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M776.384 394.947L773.285 402.179L783.1 406.57L785.941 399.338L776.384 394.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M789.04 391.848L785.941 399.338L776.385 394.948L779.484 387.716L789.04 391.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M792.398 384.358L789.041 391.848L779.484 387.716L780.776 384.617L789.299 381.259C792.398 380.846 792.657 383.153 792.398 384.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M766.57 392.623L763.471 400.371L772.51 404.246L775.61 396.755L766.57 392.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M767.603 390.04L766.57 392.623L775.61 396.755L780.776 384.616L767.603 390.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.873 512.205L633.813 508.589L639.754 518.662C638.462 519.178 635.57 520.16 634.33 519.953C633.09 519.746 632.092 519.35 631.747 519.178C628.648 517.732 627.873 513.927 627.873 512.205Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M646.728 516.854C644.662 516.854 641.218 518.059 639.754 518.662L634.072 508.589L639.754 505.231L646.728 516.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M651.376 516.595C649.805 516.595 647.933 516.681 646.727 516.854L639.754 505.231L644.919 502.132L652.926 515.821C652.754 516.165 652.41 516.595 651.376 516.595Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M656.026 509.363L652.927 515.82L644.92 502.132L650.344 499.032L656.026 509.363Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M661.189 496.967L656.024 509.622L650.342 499.033L656.904 494.931C658.017 494.236 659.477 493.594 660.498 494.417C661.35 495.103 661.364 496.27 661.189 496.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M659.383 514.014L661.965 508.073L671.005 511.689L668.681 517.371L661.191 517.113C659.125 516.493 659.125 514.788 659.383 514.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M679.786 517.887L668.68 517.371L672.296 509.364L683.66 514.272L683.403 514.888C682.726 516.514 681.547 517.887 679.786 517.887Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M686.244 508.073L683.661 514.272L672.297 509.365L674.88 503.166L686.244 508.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M688.826 501.616L686.243 508.073L674.879 503.166L677.462 496.709L688.826 501.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M691.41 495.417L688.827 501.616L677.463 496.708L680.046 490.51L691.41 495.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M665.322 500.066L661.965 508.073L671.263 511.689L674.362 504.199L665.322 500.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M668.165 492.576L665.324 500.066L674.364 504.199L677.463 496.45L668.165 492.576Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M693.992 489.219L691.409 495.417L680.045 490.51L682.628 484.312L693.992 489.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M696.574 483.02L693.991 489.219L682.627 484.311L685.21 477.854L696.574 483.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M699.158 476.563L696.575 483.019L685.211 477.854L687.794 471.655L699.158 476.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M671.263 484.828L668.164 492.576L677.462 496.451L680.561 488.961L671.263 484.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.621 477.338L671.264 484.828L680.562 488.96L683.661 481.47L674.621 477.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M677.72 469.848L674.621 477.338L683.661 481.47L686.76 473.722L677.72 469.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M701.74 470.364L699.157 476.563L687.793 471.656L690.376 465.457L701.74 470.364Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M704.324 464.166L701.741 470.365L690.377 465.457L692.96 459.259L704.324 464.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M680.82 462.1L677.721 469.848L686.76 473.722L690.118 465.974L680.82 462.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M683.92 454.609L680.82 462.099L690.118 465.974L693.218 458.484L683.92 454.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M706.906 457.709L704.323 464.166L692.959 459.259L695.542 452.802L706.906 457.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M709.49 451.768L706.907 457.708L695.543 452.801L698.384 446.603L709.49 451.768Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.072 445.569L709.489 451.768L698.383 446.603L700.966 440.662L712.072 445.569Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M714.912 439.113L712.071 445.57L700.965 440.663L703.548 434.206L714.912 439.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M717.496 432.914L714.913 439.113L703.549 434.206L705.873 428.007L717.496 432.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M720.078 426.457L717.496 432.914L705.873 428.007L708.456 421.55L720.078 426.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.66 420.259L720.078 426.458L708.455 421.55L711.038 415.352L722.66 420.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M725.761 413.027L722.662 420.259L711.039 415.351L720.486 410.738C721.585 410.201 722.772 409.716 723.987 409.864C726.261 410.14 726.185 411.967 725.761 413.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M697.607 421.809L711.038 415.352L705.614 428.265L696.574 424.391L697.607 421.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M687.019 446.861L683.92 454.61L693.218 458.484L696.317 450.994L687.019 446.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.119 439.371L687.02 446.861L696.318 450.994L699.675 443.504L690.119 439.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M693.475 431.881L690.117 439.371L699.673 443.503L702.773 436.013L693.475 431.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M696.576 424.391L693.477 431.881L702.775 436.013L705.616 428.265L696.576 424.391Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M759.079 398.046L755.721 405.537L746.682 401.404L747.973 398.305L755.721 394.947C759.027 394.327 759.337 396.755 759.079 398.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.622 413.543L755.722 405.537L746.682 401.404L743.324 409.669L752.622 413.543Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M734.801 403.987L747.973 398.305L742.807 410.702L733.768 406.57L734.801 403.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M749.523 421.291L752.622 413.543L743.324 409.669L740.225 417.159L749.523 421.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M730.41 414.059L733.768 406.569L742.807 410.702L739.708 418.45L730.41 414.059Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M746.165 429.298L749.522 421.292L740.224 417.159L737.125 425.166L746.165 429.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M727.568 421.291L730.409 414.06L739.707 418.45L736.866 425.424L727.568 421.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M724.469 428.781L727.568 421.291L736.866 425.423L733.767 432.914L724.469 428.781Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M742.807 437.046L733.768 432.913L737.125 425.165L746.165 429.297L742.807 437.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M739.45 445.053L742.807 437.047L733.768 432.914L730.41 440.921L739.45 445.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M736.351 452.802L739.45 445.053L730.41 440.921L727.053 448.669L736.351 452.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M721.371 436.013L724.47 428.781L733.768 432.914L730.669 440.404L721.371 436.013Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M718.271 443.504L721.371 436.014L730.669 440.404L727.311 447.894L718.271 443.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M733.251 460.55L736.35 452.801L727.052 448.669L723.953 456.159L733.251 460.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M729.894 468.557L733.251 460.55L723.953 456.159L720.596 464.166L729.894 468.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M715.172 450.735L718.271 443.503L727.311 447.894L724.212 455.125L715.172 450.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.072 458.225L715.172 450.735L724.47 455.126L721.37 462.358L712.072 458.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.794 476.305L729.893 468.557L720.595 464.166L717.496 471.914L726.794 476.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M723.437 484.053L726.794 476.305L717.496 471.914L714.139 479.921L723.437 484.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M708.973 465.716L712.072 458.226L721.37 462.358L718.271 470.106L708.973 465.716Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M705.873 473.205L708.972 465.715L718.27 470.106L715.171 477.337L705.873 473.205Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M720.079 491.801L723.436 484.052L714.138 479.92L711.039 487.668L720.079 491.801Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M703.033 480.437L705.874 473.205L715.172 477.338L712.073 484.828L703.033 480.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M716.98 499.55L720.079 491.801L711.039 487.669L707.682 495.417L716.98 499.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M699.934 487.927L703.033 480.437L712.073 484.827L708.973 492.059L699.934 487.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M696.576 495.675L699.934 487.927L708.974 492.059L705.874 499.549L696.576 495.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M713.622 507.556L716.979 499.549L707.681 495.417L704.582 503.424L713.622 507.556Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M710.264 515.046L713.622 507.556L704.582 503.424L701.225 511.172L710.264 515.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M693.736 502.908L696.577 495.676L705.875 499.808L703.034 506.782L693.736 502.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.377 510.397L693.735 502.907L703.033 507.04L699.675 514.53L690.377 510.397Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M688.052 516.596L690.377 510.397L699.675 514.53L697.609 520.212L689.602 519.437C687.536 519.024 687.708 517.371 688.052 516.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M706.133 521.503L697.609 520.212L701.225 511.172L710.265 515.046L708.457 519.953C707.837 521.193 706.649 521.503 706.133 521.503Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M666.875 483.278L672.557 469.331L659.127 476.821L664.293 485.086L666.875 483.278Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M675.396 462.358L672.555 469.331L667.132 472.172L663.516 465.457L672.297 460.033C674.983 459.413 675.482 461.325 675.396 462.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M654.219 470.881L663.517 465.457L667.133 472.172L658.093 477.338L654.219 470.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M656.544 489.735L664.292 485.086L659.127 476.821L651.637 481.47L656.544 489.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M648.795 494.125L656.544 489.735L651.637 481.47L644.146 485.86L648.795 494.125Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.304 498.775L648.794 494.126L644.145 485.861L636.396 490.51L641.304 498.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M633.556 503.165L641.304 498.775L636.397 490.51L628.648 495.159L633.556 503.165Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.874 506.523L633.557 503.166L628.649 495.159L621.676 499.033C622.192 500.411 623.432 503.579 624.259 505.232C625.085 506.885 627.014 506.782 627.874 506.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.351 493.351L621.676 499.034L631.232 493.61L627.357 486.895C625.205 488.014 620.694 490.407 619.868 491.027C619.041 491.647 619.179 492.835 619.351 493.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M636.139 481.47L627.357 486.894L631.232 493.609L640.271 488.185L636.139 481.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M645.18 476.046L636.141 481.47L640.273 488.185L649.313 482.761L645.18 476.046Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M654.219 470.881L645.18 476.046L649.312 482.762L658.094 477.338L654.219 470.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M681.336 448.668L685.985 436.529L671.779 444.794L676.17 452.026L681.336 448.668Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M688.567 430.589L685.984 436.53L680.044 439.887L676.17 433.172L685.726 428.006C688.206 427.593 688.653 429.556 688.567 430.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M667.131 438.079L676.171 433.172L680.045 439.887L671.005 445.311L667.131 438.079Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M658.607 442.986L667.131 438.079L671.005 445.311L662.482 450.218L658.607 442.986Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M667.647 457.192L676.17 452.027L671.779 444.795L663.256 449.702L667.647 457.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M659.124 462.358L667.647 457.192L663.256 449.702L654.475 454.868L659.124 462.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M650.084 447.894L658.607 442.986L662.481 450.218L653.958 455.125L650.084 447.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.82 452.801L650.085 447.894L653.959 455.125L645.953 460.033L641.82 452.801Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M650.342 467.523L659.123 462.357L654.474 454.867L645.951 460.033L650.342 467.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.561 472.689L650.342 467.523L645.951 460.033L637.17 465.199L641.561 472.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M633.555 457.966L641.82 452.801L645.952 460.033L637.429 464.94L633.555 457.966Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M633.037 477.596L641.56 472.688L637.169 465.198L628.904 470.106L633.037 477.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M625.031 463.132L633.554 457.967L637.429 464.94L629.164 470.106L625.031 463.132Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M624.774 482.761L633.039 477.596L628.906 470.105L620.125 475.271L624.774 482.761Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M616.508 468.298L625.031 463.133L629.163 469.848L620.382 475.014L616.508 468.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.535 472.689L616.508 468.298L620.382 475.271L611.859 480.695C611.084 479.49 609.38 476.769 608.76 475.53C608.14 474.29 609.018 473.119 609.535 472.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M618.316 486.377L624.773 482.761L620.124 475.529L611.859 480.695C612.548 481.986 614.132 484.827 614.959 485.86C615.785 486.894 617.541 486.635 618.316 486.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M515.265 342.775L518.622 345.358L513.715 353.107L504.934 347.683L511.391 343.292C513.198 342.259 514.404 342.431 515.265 342.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M497.186 352.59L504.934 347.683L509.325 350.524L503.901 359.305L497.186 355.431C495.947 354.398 496.67 353.106 497.186 352.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M511.39 363.179L503.9 359.305L509.324 350.523L516.298 354.914L511.39 363.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M526.631 351.041L518.624 345.358L513.717 353.107L521.982 358.272L526.631 351.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M535.153 356.98L526.629 351.04L521.98 358.272L531.02 363.696L535.153 356.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M519.397 367.311L511.391 363.179L516.298 354.914L524.305 359.563L519.397 367.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M527.661 371.703L519.396 367.312L524.304 359.563L532.052 364.471L527.661 371.703Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M536.702 376.61L527.662 371.702L532.053 364.471L541.093 369.636L536.702 376.61Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M544.708 363.179L535.152 356.98L531.02 363.696L541.092 369.636L544.708 363.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M554.782 369.637L544.71 363.18L541.094 369.637L551.167 375.835L554.782 369.637Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M546.518 381.776L536.703 376.61L541.094 369.637L550.392 375.319L546.518 381.776Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M553.747 385.133L546.516 381.775L550.39 375.318L562.012 381.775L555.555 387.199L553.747 385.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M565.113 375.835L554.781 369.637L551.424 375.835L561.755 381.776L565.113 375.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M559.689 393.914L555.557 387.199L562.014 381.775L567.179 385.133L568.729 387.199L559.689 393.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M574.928 381.259L565.113 375.835L562.014 381.775L567.179 385.133L568.729 387.199L570.537 389.265L574.928 381.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M581.643 385.133L574.928 381.259L570.537 389.265L575.703 395.722L581.643 385.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M563.305 400.113L559.689 393.914L568.729 387.199L573.12 392.623L563.305 400.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M565.371 403.729L563.305 400.113L573.119 392.623L575.702 395.722L577.51 398.563L567.954 404.762C566.507 404.969 565.629 404.159 565.371 403.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M588.615 391.848L577.509 398.563L575.701 395.722L581.642 385.133L589.132 389.007C589.545 390.247 588.959 391.418 588.615 391.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M570.02 407.861L575.702 404.245L580.868 412.252L573.636 416.901C572.689 415.265 570.588 411.735 569.762 410.702C568.935 409.669 569.59 408.378 570.02 407.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M577.509 423.357L573.635 416.9L580.608 412.51L585.516 421.291C584.482 421.98 582.055 423.564 580.608 424.391C579.162 425.217 577.939 424.046 577.509 423.357Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M592.49 416.901L585.517 421.291L580.609 412.51L587.583 408.119L592.49 416.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M599.721 412.51L592.489 416.901L587.582 408.119L594.297 403.729L599.721 412.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M606.696 408.12L599.723 412.511L594.299 403.729L601.272 399.597L606.696 408.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M583.191 399.597L575.701 404.246L580.867 412.252L588.357 407.603L583.191 399.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M590.423 394.947L583.191 399.596L588.357 407.603L595.589 402.954L590.423 394.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M594.04 392.623L590.424 394.947L595.589 402.954L605.662 397.014C603.166 395.808 597.656 393.036 596.622 392.623C595.589 392.209 594.47 392.451 594.04 392.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M613.927 403.729L606.695 408.12L601.271 399.596L605.662 397.014L612.879 400.294C613.738 400.684 614.694 401.24 614.755 402.181C614.792 402.75 614.523 403.282 613.927 403.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M582.675 429.04L588.357 425.424L593.522 433.43L586.29 438.079C585.343 436.616 583.243 433.327 582.416 431.881C581.59 430.434 582.244 429.384 582.675 429.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M590.422 444.795L586.289 438.08L593.263 433.689L598.686 442.213L593.521 445.57C591.868 445.983 590.766 445.226 590.422 444.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.661 437.821L598.688 442.212L593.264 433.689L600.495 429.04L605.661 437.821Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M612.893 433.173L605.662 437.822L600.496 429.04L607.728 424.649L612.893 433.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M595.846 420.775L588.355 425.424L593.521 433.431L600.753 428.782L595.846 420.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M603.077 416.126L595.846 420.775L600.753 428.782L607.985 424.391L603.077 416.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.866 428.782L612.892 433.173L607.727 424.65L614.7 420.259L619.866 428.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M610.568 411.478L603.078 416.127L607.985 424.391L615.475 419.742L610.568 411.478Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M617.8 407.087L610.568 411.478L615.476 419.743L622.707 415.094L617.8 407.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.099 424.133L619.867 428.782L614.701 420.258L621.933 415.609L627.099 424.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M634.329 419.484L627.097 424.133L621.932 415.609L628.905 411.219L634.329 419.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.82 414.835L634.33 419.484L628.906 411.219L632.78 408.637L641.82 411.994C642.44 413.234 642.078 414.405 641.82 414.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M621.415 404.762L617.799 407.086L622.706 415.093L632.779 408.636C630.024 407.345 624.101 404.71 623.481 404.504C622.861 404.297 621.845 404.59 621.415 404.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.113 449.49L602.086 445.869L606.501 453.111L598.45 458.283C597.758 457.163 596.113 454.507 595.074 452.852C594.035 451.197 595.334 449.921 596.113 449.49Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M602.606 465.266L598.451 458.283L605.203 453.887L610.657 463.197L605.982 466.301C604.528 466.922 603.126 465.87 602.606 465.266Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M610.137 440.955L602.086 445.869L606.501 453.111L614.552 448.455L610.137 440.955Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M617.409 459.06L610.657 463.198L605.203 453.887L612.215 449.749L617.409 459.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M624.419 454.921L617.407 459.059L612.213 449.749L619.225 445.869L624.419 454.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M631.432 450.783L624.421 454.921L619.227 445.869L626.238 441.473L631.432 450.783Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M638.702 446.386L631.43 450.783L626.236 441.472L632.989 437.334L638.702 446.386Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M617.928 436.041L610.137 440.955L614.552 448.455L622.602 443.541L617.928 436.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M625.459 431.387L617.928 436.042L622.602 443.801L630.393 438.887L625.459 431.387Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M632.99 426.731L625.459 431.387L630.393 438.887L637.925 434.49L632.99 426.731Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M645.975 441.99L638.704 446.387L632.99 437.335L640.522 432.938L645.975 441.99Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M640.262 422.076L632.99 426.731L637.925 434.49L645.196 430.094L640.262 422.076Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M652.727 437.852L645.975 441.99L640.521 432.938L647.274 428.8L652.727 437.852Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M659.479 433.714L652.727 437.852L647.273 428.8L654.026 424.662L659.479 433.714Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M647.533 417.42L640.262 422.075L645.196 430.093L652.468 425.696L647.533 417.42Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M650.13 415.869L647.533 417.421L652.468 425.697L663.115 418.972C660.345 418.024 654.441 416.024 652.987 415.61C651.533 415.196 650.476 415.61 650.13 415.869Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M666.751 429.575L659.479 433.713L654.025 424.661L660.778 420.523L666.751 429.575Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.284 425.179L666.752 429.575L660.779 420.523L662.857 418.972L673.764 422.334C675.011 423.575 674.63 424.748 674.284 425.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1103.36 233.523L1089.93 233.007L1094.58 242.305L1104.66 236.881C1105.48 234.608 1104.14 233.696 1103.36 233.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1087.35 246.179L1094.58 242.305L1089.93 233.007L1082.44 236.881L1087.35 246.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.34 231.457L1089.93 233.007L1074.95 240.755L1070.3 231.974L1071.34 231.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.86 250.053L1087.35 246.179L1082.44 236.881L1075.21 240.755L1079.86 250.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1072.63 253.669L1079.86 250.053L1075.21 240.755L1067.98 244.629L1072.63 253.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1063.07 235.848L1070.3 231.974L1074.95 240.755L1067.46 244.888L1063.07 235.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1064.88 257.543L1072.63 253.669L1067.98 244.629L1060.49 248.245L1064.88 257.543Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1057.65 261.159L1064.88 257.543L1060.49 248.245L1053 252.119L1057.65 261.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1055.84 239.464L1063.07 235.848L1067.46 244.887L1060.23 248.503L1055.84 239.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1048.61 243.08L1055.84 239.464L1060.23 248.504L1053 252.119L1048.61 243.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.38 246.695L1048.61 243.079L1053 252.119L1045.51 255.735L1041.38 246.695Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1050.42 264.775L1057.65 261.159L1053 252.119L1046.03 255.477L1050.42 264.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1042.93 268.39L1050.42 264.775L1046.03 255.477L1038.28 259.092L1042.93 268.39Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1035.44 272.007L1042.93 268.391L1038.28 259.093L1031.05 262.709L1035.44 272.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1033.89 250.311L1041.38 246.695L1045.51 255.735L1038.02 259.351L1033.89 250.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.4 253.927L1033.89 250.312L1038.02 259.351L1030.53 262.967L1026.4 253.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1027.95 275.622L1035.44 272.006L1031.05 262.708L1023.56 266.324L1027.95 275.622Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1019.17 257.284L1026.4 253.927L1030.53 262.966L1023.3 266.324L1019.17 257.284Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1020.46 279.238L1027.95 275.622L1023.56 266.324L1016.07 269.682L1020.46 279.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.93 260.642L1019.17 257.284L1023.3 266.324L1016.07 269.682L1011.93 260.642Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.97 282.597L1020.46 279.239L1016.07 269.683L1008.58 273.299L1012.97 282.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1004.44 264L1011.93 260.643L1016.07 269.682L1008.32 273.298L1004.44 264Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.09 276.655L1008.58 273.298L1012.97 282.596L1007.03 285.695C1005.79 286.315 1004.79 285.265 1004.44 284.662L1001.09 276.655Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1000.92 265.552L1004.44 264L1008.32 273.298L1001.09 276.656C1000.31 275.02 998.607 271.387 997.987 269.94C997.166 268.026 999.011 266.391 1000.92 265.552Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M803.244 217.253L819.774 210.279L804.536 206.405L803.244 217.253Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M805.312 198.657L804.537 206.405L812.027 208.213L814.352 197.624C813.405 197.365 810.942 196.746 808.67 196.332C806.397 195.919 805.484 197.71 805.312 198.657Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M822.358 199.69L814.352 197.624L812.027 208.213L819.776 210.28L822.358 199.69Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M802.47 224.484L803.245 217.253L809.702 214.67L813.318 223.71L804.278 226.809C802.625 226.809 802.384 225.259 802.47 224.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M821.584 220.352L813.319 223.71L809.703 214.67L817.71 211.312L821.584 220.352Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M829.331 216.995L821.583 220.352L817.709 211.313L825.716 207.955L829.331 216.995Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M837.081 213.378L829.333 216.994L825.717 207.954L833.465 204.597L837.081 213.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M846.635 208.73L837.079 213.379L833.463 204.598L836.562 203.048L845.602 204.856C847.668 206.096 847.152 207.955 846.635 208.73Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M822.358 199.689L836.563 203.047L819.775 210.279L822.358 199.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1056.45 229.133L1046.38 227.325L1044.57 228.358L1048.96 237.14L1057.48 232.749C1058.52 230.683 1057.23 229.478 1056.45 229.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1041.47 241.014L1048.96 237.14L1044.57 228.358L1037.08 232.233L1041.47 241.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.01 223.451L1046.03 227.325L1033.11 233.782L1028.72 224.226L1030.01 223.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1033.98 244.63L1041.47 241.014L1037.08 231.975L1029.59 235.849L1033.98 244.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1021.75 227.583L1028.72 224.226L1033.11 233.782L1026.4 237.139L1021.75 227.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1026.49 248.246L1033.98 244.63L1029.59 235.849L1022.1 239.465L1026.49 248.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1014.78 230.942L1021.75 227.584L1026.4 237.14L1019.17 240.498L1014.78 230.942Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1018.74 252.12L1026.49 248.246L1022.1 239.465L1014.35 243.081L1018.74 252.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1007.8 234.041L1014.78 230.941L1019.17 240.756L1012.19 243.855L1007.8 234.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1011.25 255.736L1018.74 252.12L1014.35 243.08L1006.86 246.438L1011.25 255.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.18 237.398L1008.15 234.04L1012.54 243.855L1005.57 246.954L1001.18 237.398Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.207 240.756L1001.18 237.398L1005.57 246.955L998.598 250.312L994.207 240.756Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.5 259.093L1011.25 255.736L1006.86 246.438L999.371 250.053L1003.5 259.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.822 261.676L1003.5 259.093L999.372 250.054L991.365 253.67L994.465 260.643C995.291 262.296 997.047 262.021 997.822 261.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.523 243.339L994.206 240.756L998.597 250.312L991.365 253.67L988.007 246.438C987.18 244.785 988.007 243.683 988.523 243.339Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1133.06 145.968H1124.02L1121.44 149.842L1128.93 155.782L1134.36 148.809C1134.98 146.743 1133.75 146.054 1133.06 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1112.14 145.968H1124.02L1116.79 155.782L1109.3 149.584L1112.14 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1123.77 162.497L1128.93 155.782L1121.18 149.842L1116.28 156.557L1123.77 162.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1118.34 169.212L1123.77 162.497L1116.28 156.557L1111.11 163.014L1118.34 169.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1104.14 156.041L1109.3 149.584L1116.79 155.783L1111.63 162.24L1104.14 156.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1112.92 175.67L1118.34 169.213L1111.11 163.015L1105.69 169.472L1112.92 175.67Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1098.71 162.497L1104.14 156.04L1111.63 162.239L1105.94 168.954L1098.71 162.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1093.03 168.955L1098.71 162.498L1105.95 168.955L1100 175.412L1093.03 168.955Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1107.24 182.385L1112.92 175.669L1105.43 169.471L1099.75 175.669L1107.24 182.385Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1101.55 188.842L1107.24 182.385L1099.75 175.67L1094.32 182.127L1101.55 188.842Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1087.35 175.411L1093.03 168.954L1100.01 175.411L1094.32 181.868L1087.35 175.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1095.61 195.041L1101.55 188.842L1094.32 182.127L1088.38 188.584L1095.61 195.041Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1089.41 201.24L1095.61 195.041L1088.38 188.584L1082.44 194.783L1089.41 201.24Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1083.48 207.438L1089.42 201.239L1082.44 194.782L1076.5 200.464L1083.48 207.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1081.93 181.352L1087.35 175.411L1094.32 182.126L1088.64 188.067L1081.93 181.352Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1075.73 187.55L1081.93 181.352L1088.64 188.325L1082.7 194.524L1075.73 187.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1070.04 193.491L1075.73 187.551L1082.7 194.524L1076.5 200.465L1070.04 193.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1063.85 199.432L1070.04 193.491L1076.5 200.465L1070.3 206.405L1063.85 199.432Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1077.28 213.378L1083.47 207.437L1076.5 200.464L1070.3 206.404L1077.28 213.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.08 219.319L1077.28 213.379L1070.3 206.405L1064.36 212.087L1071.08 219.319Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1066.43 222.935L1071.08 219.319L1064.36 212.087L1053.51 221.643L1066.43 222.935Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1044.48 220.093L1053.51 221.643L1057.91 217.769L1051.71 210.537L1044.22 216.994C1043.39 218.234 1044.04 219.577 1044.48 220.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1057.91 205.113L1051.71 210.537L1057.91 217.769L1064.1 212.087L1057.91 205.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1057.91 205.114L1063.85 199.432L1070.3 206.405L1064.1 212.087L1057.91 205.114Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M889.767 174.894L881.244 169.729L879.178 178.51L889.767 181.609L890.8 177.219C890.8 175.979 890.111 175.152 889.767 174.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M874.012 165.596L881.244 169.729L879.694 176.186L869.363 173.345L870.655 167.404C871.275 164.925 873.151 165.166 874.012 165.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.217 188.841L889.767 181.609L879.178 178.51L877.111 185.742L888.217 188.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M867.814 181.351L869.364 173.345L879.695 176.186L877.629 183.934L867.814 181.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M886.667 196.073L888.217 188.842L877.111 185.742L875.303 192.974L886.667 196.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M884.858 203.305L886.666 196.073L875.302 192.974L873.494 199.947L884.858 203.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M883.31 208.729L884.86 203.305L873.496 199.947L871.43 207.696L880.986 210.02C882.432 210.227 883.138 209.245 883.31 208.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M863.164 205.63L871.429 207.696L873.495 199.689L863.939 196.59L862.131 203.305C862.131 204.958 862.82 205.543 863.164 205.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M865.745 188.842L863.938 196.59L873.494 199.689L875.56 191.683L865.745 188.842Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M867.814 181.351L865.748 188.841L875.563 191.682L877.629 183.933L867.814 181.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M887.703 209.503L888.736 204.338L901.392 207.437L900.359 212.603L898.034 213.636L888.736 211.311C887.703 210.692 887.617 209.848 887.703 209.503Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M906.816 210.537L900.359 212.603L903.975 196.59L909.657 197.881L906.816 210.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M915.34 208.213L906.816 210.537L909.657 197.882L917.148 199.69L915.34 208.213Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.06 205.888L915.338 208.213L917.146 199.689L933.159 203.564C932.746 204.597 930.921 205.63 930.06 205.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M932.903 199.431C933.523 201.291 933.334 202.961 933.161 203.563L919.473 200.206L921.797 192.716L932.903 199.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M913.272 187.809L921.795 192.716L919.471 200.206L910.689 198.14L913.272 187.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M906.816 184.192L913.273 187.808L910.69 198.139L903.975 196.59L906.816 184.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M898.552 179.544L906.817 184.193L905.526 189.1L893.387 186.001L894.678 179.802C895.711 178.769 897.691 179.199 898.552 179.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M892.094 191.941L893.385 186.001L905.524 189.1L904.233 195.041L892.094 191.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M890.543 198.14L892.093 191.941L904.232 195.041L902.94 201.498L890.543 198.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.736 204.338L890.544 198.14L902.942 201.497L901.392 207.438L888.736 204.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1102.33 145.968H1091.74L1089.16 149.067L1097.68 156.041L1103.36 149.067C1103.77 147.001 1102.84 146.14 1102.33 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1092.77 161.981L1097.68 156.041L1089.16 149.067L1084.51 155.008L1092.77 161.981Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1079.6 145.968H1091.74L1083.73 156.041L1076.5 149.584L1079.6 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1087.61 167.922L1092.77 161.981L1084.51 155.008L1079.86 160.69L1087.61 167.922Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1070.82 155.783L1076.5 149.584L1083.73 156.041L1078.05 162.756L1070.82 155.783Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1082.44 173.603L1087.61 167.921L1079.86 160.689L1074.44 166.63L1082.44 173.603Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1064.88 162.239L1070.82 155.782L1078.05 162.756L1072.11 168.954L1064.88 162.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1077.02 179.285L1082.44 173.603L1074.44 166.63L1069.27 172.054L1077.02 179.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.94 168.696L1064.88 162.239L1072.11 168.954L1065.91 175.67L1058.94 168.696Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1071.85 184.709L1077.02 179.285L1069.27 172.054L1064.36 177.219L1071.85 184.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1053 174.637L1058.94 168.696L1065.91 175.67L1059.71 181.868L1053 174.637Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1066.17 190.134L1071.85 184.71L1064.36 177.22L1058.94 182.644L1066.17 190.134Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1060.75 195.298L1066.17 190.133L1058.94 182.643L1053.26 187.808L1060.75 195.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1046.8 180.835L1053 174.637L1059.71 181.868L1053.26 187.809L1046.8 180.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1039.31 187.55L1046.8 180.835L1051.71 186.259L1044.22 192.974L1039.57 191.166C1037.92 189.926 1038.71 188.239 1039.31 187.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1057.13 197.623L1044.22 192.974L1051.71 186.259L1060.75 195.299L1058.68 197.623C1058.47 197.83 1057.56 197.709 1057.13 197.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1069.27 145.968H1059.97L1057.13 148.809L1063.85 156.041L1070.3 148.809C1070.72 147.156 1069.79 146.226 1069.27 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1058.16 162.239L1063.85 156.04L1057.13 148.809L1051.19 154.491L1058.16 162.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1053 167.663L1058.17 162.24L1051.19 154.491L1045.51 159.398L1053 167.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1044.99 145.968H1059.97L1051.19 154.491L1049.9 155.524L1043.44 147.776L1044.99 145.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1037.24 153.199L1043.44 147.775L1049.9 155.524L1043.7 160.948L1037.24 153.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.79 158.365L1037.24 153.199L1043.7 160.948L1037.5 166.371L1030.79 158.365Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1024.33 163.273L1030.79 158.365L1037.5 166.372L1031.3 171.537L1024.33 163.273Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1047.58 173.087L1053 167.663L1045.51 159.398L1039.83 164.306L1047.58 173.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1042.41 177.994L1047.57 173.087L1039.83 164.306L1034.4 168.955L1042.41 177.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1037.5 182.901L1042.41 177.994L1034.4 168.954L1029.24 173.603L1037.5 182.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1032.59 187.551L1037.5 182.902L1029.24 173.604L1024.33 177.994L1032.59 187.551Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1030.53 189.358L1032.6 187.55L1024.33 177.994L1015.03 186.259L1030.53 189.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M999.794 184.193L1015.03 186.259L1016.07 185.226L1006.77 175.411L997.986 181.093C997.78 183.366 999.106 184.106 999.794 184.193Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1018.39 167.921L1024.33 163.272L1031.3 171.537L1025.88 176.703L1018.39 167.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.45 171.796L1018.39 167.922L1025.88 176.703L1020.71 181.352L1012.45 171.796Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1006.77 175.412L1012.45 171.796L1020.71 181.352L1016.07 185.226L1006.77 175.412Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1051.97 203.305L1045.25 209.245L1040.09 207.695L1044.22 197.881L1051.71 200.205C1052.54 201.445 1052.23 202.788 1051.97 203.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1035.96 217.51L1045.25 209.245L1033.11 205.888L1030.27 216.219L1035.96 217.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1036.73 195.557L1044.22 197.881L1040.09 207.696L1032.86 205.888L1036.73 195.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1028.98 193.49L1036.73 195.556L1032.86 206.146L1025.37 203.821L1028.98 193.49Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1021.75 213.895L1030.27 216.219L1032.86 206.146L1024.85 203.563L1021.75 213.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1013.48 211.312L1021.75 213.895L1024.85 203.564L1016.84 201.239L1013.48 211.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1005.48 208.987L1013.49 211.312L1016.84 201.239L1008.06 199.173L1005.48 208.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.213 207.179L1005.48 208.987L1008.06 199.173L999.796 197.106L997.213 207.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M988.949 205.629L997.214 207.179L999.797 197.106L990.757 195.557L988.949 205.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M980.684 204.855L988.948 205.63L990.756 195.557L981.717 194.266L980.684 204.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M972.418 204.08L980.683 204.855L981.716 194.266L972.935 193.749L972.418 204.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.346 203.564L972.419 204.08L972.935 193.749L961.313 198.398C959.866 201.497 961.399 203.133 962.346 203.564Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M984.558 187.809L972.936 193.749L981.717 194.266L990.757 195.557L992.306 188.067L984.558 187.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1002.9 188.841L992.307 188.066L990.758 195.556L999.539 197.106L1000.83 197.364L1002.9 188.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1012.71 190.133L1002.9 188.842L1000.83 197.365L1008.06 199.173L1010.13 199.689L1012.71 190.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1021.23 191.941L1012.71 190.133L1010.13 199.689L1016.84 201.239L1018.13 201.497L1021.23 191.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1028.98 193.491L1021.23 191.941L1018.13 201.498L1025.36 203.822L1028.98 193.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M952.27 226.55L960.794 222.676L955.886 212.087L952.27 213.637C951.754 217.425 950.721 225.052 950.721 225.259C950.927 226.292 951.84 226.55 952.27 226.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M967.768 219.577L960.794 222.676L955.887 212.087L957.953 211.054H963.893L967.768 219.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M979.389 211.829L963.893 211.054L967.767 219.577L980.164 214.153C980.784 212.5 979.906 211.915 979.389 211.829Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1032.6 146.226H1021.23L1019.94 147.517L1026.4 155.524L1033.89 148.808C1034.1 146.949 1033.11 146.312 1032.6 146.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1019.94 160.69C1019.94 160.896 1024.25 157.332 1026.4 155.524L1019.94 147.518L1013.48 152.425C1015.64 155.094 1019.94 160.483 1019.94 160.69Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1004.96 145.451L1021.23 146.226L1019.94 147.517L1013.48 152.425L1009.87 155.007L1003.67 146.484L1004.96 145.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M997.471 150.875L1003.67 146.484L1009.87 155.008L1003.15 159.657L997.471 150.875Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1013.23 165.597L1019.94 160.69L1013.49 152.425L1007.29 156.816L1013.23 165.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1006.25 170.246L1013.23 165.597L1007.29 156.815L1000.57 161.464L1006.25 170.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M999.279 174.637L1006.25 170.246L1000.57 161.465L993.855 165.339L999.279 174.637Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M990.756 155.266L997.471 150.875L1003.15 159.656L1000.57 161.464L996.18 164.047L990.756 155.266Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M984.299 159.14L990.756 155.266L996.18 164.047L989.206 167.921L984.299 159.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M992.048 178.769L999.28 174.637L993.856 165.339L987.141 169.213L992.048 178.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M984.816 182.643L992.048 178.769L987.14 169.213L979.65 173.345L984.816 182.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.327 186.259L984.817 182.643L979.651 173.345L972.678 176.702L977.327 186.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.836 189.617L977.326 186.259L972.677 176.703L965.445 180.061L969.836 189.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.345 192.974L969.835 189.617L965.445 180.061L958.213 183.16L962.345 192.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M958.471 194.783L962.346 192.975L958.213 183.16L950.465 186.001L950.723 191.425C954.597 190.65 956.922 194.266 957.18 194.783C957.387 195.196 958.127 194.955 958.471 194.783Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.326 163.014L984.3 159.14L989.207 167.921L981.975 172.054L977.326 163.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.094 166.63L977.326 163.014L981.975 172.053L979.65 173.345L974.743 175.669L970.094 166.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M963.121 169.987L970.095 166.63L974.744 175.67L966.995 179.285L963.121 169.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M955.889 172.828L963.12 169.987L966.995 179.285L959.763 182.643L955.889 172.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M950.465 175.153L955.889 172.828L959.763 182.384L950.465 186V175.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M991.785 144.159L982.229 143.643L979.904 145.192L984.812 153.457L993.335 148.292C993.955 145.399 992.56 144.331 991.785 144.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.807 158.106L984.814 153.457L979.907 145.192L972.158 149.841L976.807 158.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.059 162.239L976.807 158.107L972.158 149.842L964.668 153.716L969.059 162.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M960.535 166.113L969.058 162.239L964.667 153.716L956.402 157.59L960.535 166.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M953.303 169.987L960.535 166.113L956.402 157.59L949.945 160.689V168.696C950.978 169.936 952.614 170.073 953.303 169.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M967.508 142.609L982.23 143.642L979.905 145.192L972.157 149.841L966.475 152.682L967.508 142.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M959.76 141.835L967.508 142.61L966.475 152.683L964.667 153.716L959.76 156.04V141.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M952.27 141.06L959.76 141.835V149.842H949.945V142.868C950.152 141.215 951.581 140.974 952.27 141.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M949.945 160.689V149.842H959.76V155.782L956.402 157.59L949.945 160.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.038 142.351V154.49L937.031 152.166L941.164 140.285C944.521 140.543 945.038 141.49 945.038 142.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.038 168.437V154.49L943.23 153.974L935.74 166.629L942.455 170.245C944.315 170.452 944.952 169.126 945.038 168.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.574 163.53L935.74 166.63L943.23 153.974L937.031 152.166L930.574 163.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M933.674 139.769L941.164 140.285L937.032 152.166L930.316 150.1L933.674 139.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M924.375 159.914L930.574 163.53L937.031 152.166L930.315 150.1L924.375 159.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M917.143 156.04L924.374 159.914L930.315 150.099L922.308 147.517L917.143 156.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.666 138.735L922.566 147.517L930.315 150.1L933.672 139.768L925.666 138.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M916.112 137.96L925.668 138.735L922.568 147.516L912.754 144.417L916.112 137.96Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M908.619 151.132L917.142 156.039L922.308 147.516L912.752 144.417L908.619 151.132Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M902.939 147.774L908.622 151.132L912.754 144.417L916.112 137.96L908.88 137.443L902.939 147.774Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M900.613 136.152L908.878 137.444L902.938 147.775L896.223 143.642L900.613 136.152Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M889.508 134.086L900.614 136.152L896.223 143.643L889.438 139.467C887.436 138.235 885.842 135.214 887.978 134.23C888.544 133.97 889.116 133.979 889.508 134.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.296 176.444V187.808L935.998 182.901L940.905 173.861L945.296 176.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.296 190.132V187.808L937.806 183.934L932.641 193.49L937.548 196.073C938.581 196.486 939.528 196.073 939.872 195.814C941.525 192.508 943.66 191.51 944.521 191.424C945.141 191.217 945.296 190.477 945.296 190.132Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.666 189.616L932.64 193.491L937.805 183.934L931.09 180.318L925.666 189.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M918.951 185.742L925.666 189.617L931.09 180.319L924.375 176.444L918.951 185.742Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M934.191 169.987L940.906 173.861L935.999 182.901L929.025 179.027L934.191 169.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M927.216 166.113L934.19 169.987L929.024 179.027L922.051 175.153L927.216 166.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M911.979 181.868L918.952 185.742L924.376 176.444L917.402 172.57L911.979 181.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M905.004 177.993L911.977 181.867L917.401 172.569L910.686 168.695L905.004 177.993Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M898.289 173.861L905.004 177.993L910.686 168.695L903.713 164.821L898.289 173.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M891.316 169.987L898.29 173.861L903.714 164.821L896.74 160.947L891.316 169.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M884.602 166.113L891.317 169.987L896.741 160.947L890.025 157.073L884.602 166.113Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M877.885 162.497L884.6 166.113L890.024 157.073L883.05 153.199L877.885 162.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M920.242 161.98L927.215 166.113L922.05 175.153L915.076 171.278L920.242 161.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M913.269 158.106L920.243 161.981L915.077 171.279L908.104 167.146L913.269 158.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M906.555 154.232L913.27 158.107L907.846 167.146L901.131 163.272L906.555 154.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M899.58 150.358L906.554 154.233L901.13 163.272L894.156 159.398L899.58 150.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M892.349 146.226L899.581 150.358L893.899 159.398L887.184 155.265L892.349 146.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.632 142.352L892.348 146.226L886.924 155.524L880.467 151.65L885.632 142.352Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M879.952 139.252L885.634 142.351L880.469 151.649L875.045 148.55L876.853 140.802C877.679 138.942 879.263 138.994 879.952 139.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M873.237 156.815L875.045 148.55L883.051 153.199L877.885 162.497L873.495 159.656C872.669 159.036 872.979 157.503 873.237 156.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1138.49 133.667L1134.73 121.947H1126.19V138.994H1134.73C1137.74 138.354 1138.49 135.176 1138.49 133.667Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1115.95 138.994H1126.19V121.947H1115.95V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1105.7 138.994H1115.95V121.947H1105.7V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1095.45 138.994H1105.7V121.947H1095.45V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1085.21 138.994H1095.45V121.947H1085.21V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1074.96 138.994H1085.21V121.947H1074.96V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1064.71 138.994H1074.96V121.947H1064.71V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1054.47 138.994H1064.71V121.947H1054.47V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1044.22 138.994H1054.47V121.947H1044.22V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1033.98 138.994H1044.22V121.947H1033.98V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1023.73 138.994H1033.97V121.947H1023.73V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1013.48 138.994H1023.73V121.947H1013.48V138.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M801.178 233.007L806.085 231.457L808.926 241.272L799.887 244.113L801.178 233.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M813.318 228.874L806.086 231.457L808.927 241.271L816.675 238.689L813.318 228.874Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M820.292 226.291L813.318 228.874L816.676 238.688L824.166 236.364L820.292 226.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M831.655 233.265L824.165 236.364L820.291 226.291L827.523 223.45L831.655 233.265Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M834.237 220.351L827.521 223.45L831.654 233.264L838.886 229.907L834.237 220.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M841.212 217.252L834.238 220.351L838.887 229.908L845.861 226.808L841.212 217.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.629 247.986L799.887 244.112L807.894 241.529L811.51 251.344L805.569 253.152L799.629 247.986Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M819.775 248.762L811.51 251.345L807.895 241.53L815.901 238.947L819.775 248.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M827.781 245.662L819.775 248.762L815.9 238.947L823.907 236.364L827.781 245.662Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M835.789 242.563L827.782 245.662L823.908 236.364L831.657 233.265L835.789 242.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M844.31 238.689L835.787 242.563L831.654 233.265L839.144 229.649L844.31 238.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.8 234.814L844.31 238.688L839.145 229.649L847.151 226.291L851.8 234.814Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M847.926 213.894L841.211 217.251L845.86 226.807L852.833 222.933L847.926 213.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M854.901 210.02L847.928 213.894L852.835 222.933L859.809 219.318L854.901 210.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.45 209.245L854.9 210.02L859.808 219.318L872.722 212.861L856.45 209.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M883.053 214.927L872.721 212.86L870.139 214.152L874.529 222.675L883.311 218.284C884.344 216.425 883.655 215.357 883.053 214.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M859.55 230.682L851.801 234.814L847.152 226.291L854.901 221.9L859.55 230.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M867.039 226.808L859.549 230.682L854.9 221.901L862.39 218.026L867.039 226.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M874.53 222.676L867.04 226.808L862.391 218.027L870.139 214.152L874.53 222.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1017.1 219.835L1008.06 217.252L1005.22 218.802L1009.61 227.841L1017.87 223.709C1018.49 221.849 1017.61 220.351 1017.1 219.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M992.562 213.636L1008.06 217.252L995.145 223.709L990.754 214.411L992.562 213.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M983.521 217.768L990.753 214.41L995.144 223.708L987.654 227.324L983.521 217.768Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1001.86 231.715L1009.61 227.841L1005.22 218.801L997.469 222.675L1001.86 231.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M994.111 235.331L1001.86 231.715L997.469 222.417L989.979 226.291L994.111 235.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M986.363 238.948L994.111 235.332L989.979 226.292L982.23 229.908L986.363 238.948Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M976.031 221.126L983.521 217.769L987.654 227.325L980.164 230.941L976.031 221.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M978.873 242.563L986.363 238.947L982.231 229.907L974.482 233.523L978.873 242.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.867 246.179L978.873 242.563L974.483 233.523L966.734 236.881L970.867 246.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M968.799 224.484L976.031 221.126L980.163 230.941L972.673 234.298L968.799 224.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M961.309 227.841L968.799 224.483L972.673 234.298L965.183 237.656L961.309 227.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M963.117 249.795L970.865 246.179L966.733 236.881L958.984 240.497L963.117 249.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M953.818 231.198L961.308 227.841L965.183 237.655L957.951 241.013L953.818 231.198Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M949.688 233.006L953.821 231.198L957.953 241.013L947.105 245.404L949.688 233.006Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M944.914 253.068L947.102 245.404L951.492 243.596L955.366 253.152L948.305 256.06C947.196 256.516 945.625 256.504 944.919 255.534C944.359 254.764 944.653 253.984 944.914 253.068Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M963.119 249.795L955.37 253.153L951.496 243.596L958.986 240.497L963.119 249.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M989.722 265.292L984.04 267.874L979.391 257.801L986.364 254.702C987.483 257.027 989.825 261.934 990.238 262.967C990.652 264 990.066 264.947 989.722 265.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M982.489 246.696L986.363 254.702L978.614 258.06L974.74 249.02C975.946 248.418 978.571 247.151 979.801 246.696C981.197 246.179 982.074 246.437 982.489 246.696Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M966.994 252.636L974.742 249.021L978.617 258.06L970.868 261.676L966.994 252.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.067 271.232L984.04 267.875L979.391 257.802L972.418 260.901L977.067 271.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.576 274.589L977.066 271.232L972.417 260.9L965.443 264L969.576 274.589Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.603 277.689L969.577 274.589L965.444 264L958.471 267.099L962.603 277.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M959.244 255.993L966.992 252.636L970.867 261.675L963.118 265.033L959.244 255.993Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M951.754 259.352L959.244 255.994L963.118 265.034L955.37 268.391L951.754 259.352Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M955.886 280.53L962.602 277.689L958.469 267.1L951.754 269.941L955.886 280.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M948.914 283.371L955.888 280.53L951.755 269.94L944.523 273.04L948.914 283.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.681 286.47L948.913 283.371L944.522 273.04L937.549 276.139L941.681 286.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M944.008 262.709L951.756 259.352L955.372 268.391L947.365 271.749L944.008 262.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M940.649 264L944.007 262.709L947.364 271.749L937.55 276.139L936 276.398L940.649 264Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M930.834 286.212L936 276.398L937.55 276.14L941.682 286.471L932.384 289.828C930.524 289.415 930.576 287.246 930.834 286.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M914.303 313.073L924.634 298.093L928.766 307.132L914.303 313.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.946 317.98L914.304 313.073L918.694 311.265L922.31 320.821L913.529 323.92C910.223 322.267 910.43 319.271 910.946 317.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M929.801 317.981L922.311 320.822L918.695 311.265L926.185 308.166L929.801 317.981Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M938.066 314.623L929.801 317.98L926.186 308.166L934.45 305.066L938.066 314.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.815 311.524L938.067 314.623L934.709 305.067L942.199 302.226L945.815 311.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M953.82 308.166L945.813 311.524L942.197 302.226L949.946 298.868L953.82 308.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M961.826 304.809L953.819 308.166L949.945 298.868L957.952 295.511L961.826 304.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M969.315 301.709L961.825 304.808L957.951 295.51L965.441 292.411L969.315 301.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M932.641 294.994L924.635 298.093L928.767 307.133L936.516 304.292L932.641 294.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M940.133 291.895L932.643 294.994L936.517 304.292L944.007 301.451L940.133 291.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M947.621 288.795L940.131 291.894L944.005 301.451L951.495 298.351L947.621 288.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M954.853 285.695L947.621 288.795L951.495 298.351L958.985 294.993L954.853 285.695Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.602 282.338L954.854 285.696L958.986 294.994L966.476 291.894L962.602 282.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M970.092 278.98L962.602 282.338L966.476 291.894L973.966 288.537L970.092 278.98Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.582 275.623L970.092 278.981L973.966 288.537L981.714 285.179L977.582 275.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M984.814 272.266L977.582 275.623L981.714 285.18L988.946 281.822L984.814 272.266Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M989.98 269.941L984.814 272.265L988.947 281.822L996.437 278.206C995.662 276.484 994.164 272.885 993.338 271.232C992.511 269.579 990.755 269.683 989.98 269.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M977.582 298.093L969.318 301.709L965.443 292.411L973.45 288.795L977.582 298.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M985.33 294.736L977.582 298.093L973.449 288.795L981.198 285.438L985.33 294.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M993.078 291.119L985.33 294.735L981.197 285.437L988.946 281.821L993.078 291.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M998.504 288.795L993.08 291.12L988.947 281.822L996.437 278.206L998.941 283.983C999.507 285.291 1000.14 286.826 999.35 288.009C999.076 288.416 998.741 288.677 998.504 288.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M694.768 339.418L700.192 340.968L696.834 351.557L688.646 349.278C687.571 348.268 688.198 347.006 688.646 346.501L694.768 339.418Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M707.682 343.034L700.192 340.968L696.834 351.557L704.582 353.623L707.682 343.034Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M715.43 345.1L707.681 343.034L704.582 353.624L712.33 355.948L715.43 345.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.405 346.908L715.242 345.1L712.332 355.947L719.306 358.014L722.405 346.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M730.411 349.233L722.404 346.908L719.305 358.014L727.311 360.339L730.411 349.233Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M736.142 362.617L727.311 360.338L730.41 349.232L733.251 350.782L736.689 357.419C737.649 359.271 738.597 362.595 736.513 362.662C736.375 362.667 736.248 362.648 736.142 362.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M946.846 213.894V219.835L937.548 220.61L936.773 212.086L942.714 211.312L946.846 213.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M945.814 226.292L946.847 219.835L935.482 220.868L935.999 229.391C937.721 229.305 941.836 229.081 943.489 228.875C945.142 228.668 945.727 227.067 945.814 226.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M926.184 230.94L935.999 229.39L935.482 220.867L928.25 221.9L924.893 222.675L926.184 230.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M927.219 213.377L936.775 212.086L937.55 220.609L928.252 221.9L927.219 213.377Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M917.402 215.444L927.217 213.378L928.25 221.901L919.21 223.967L917.402 215.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M916.629 233.007L926.185 230.941L924.894 222.676L914.562 225.259L916.629 233.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M908.105 218.027L917.403 215.444L919.211 223.968L910.172 226.292L908.105 218.027Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M907.073 236.106L916.629 233.007L914.563 225.259L904.49 228.1L907.073 236.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M898.807 220.867L908.105 218.026L910.171 226.291L901.389 229.132L898.807 220.867Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M897.515 239.464L907.072 236.106L904.489 228.1L894.416 231.715L897.515 239.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M889.768 224.225L898.807 220.867L901.39 229.132L892.609 232.49L889.768 224.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.475 243.597L897.515 239.464L894.416 231.716L884.859 235.848L888.475 243.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M880.727 228.358L889.766 224.226L892.607 232.49L884.342 236.106L880.727 228.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M879.695 247.987L888.476 243.596L884.861 235.848L875.562 240.497L879.695 247.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M872.205 232.749L880.728 228.358L884.344 236.107L876.079 240.239L872.205 232.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M863.939 236.881L872.204 232.749L876.079 240.239L867.814 244.63L863.939 236.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M870.396 253.153L879.694 247.987L875.561 240.497L866.521 245.404L870.396 253.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M861.615 257.802L870.396 253.153L866.522 245.404L857.482 250.053L861.615 257.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M855.418 241.272L863.941 236.881L867.815 244.629L859.292 249.02L855.418 241.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M848.701 244.629L855.416 241.271L859.291 249.02L849.476 253.927L848.701 244.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M852.834 262.451L861.616 257.802L857.483 250.054L849.477 253.928L849.993 261.16C850.82 262.399 852.232 262.537 852.834 262.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M829.072 252.895L843.536 246.696L844.052 252.895L831.138 258.061L829.072 252.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.158 257.544L829.072 252.895L831.138 258.06L818.999 262.967L816.158 257.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M844.569 259.093L844.053 252.895L831.139 258.06L833.98 263.742L844.569 259.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M822.874 268.65L819 262.968L831.139 258.061L833.98 263.743L822.874 268.65Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M845.345 267.1L844.57 259.094L833.98 263.743L836.822 270.458L845.345 267.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M827.266 275.107L822.875 268.65L833.981 263.743L836.822 270.458L827.266 275.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M846.376 277.173L845.343 267.101L836.045 270.716L840.177 279.756L846.376 277.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M833.204 282.855L827.264 275.107L836.045 270.716L840.178 279.756L833.204 282.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M837.596 288.279L833.205 282.855L846.377 277.173L847.152 284.146L837.596 288.279Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M848.185 295.252L847.152 284.146L837.596 288.279L845.344 297.06C847.617 298.093 848.185 296.286 848.185 295.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M710.265 321.08L706.133 326.246L722.921 330.895L718.014 321.597L716.98 321.338L710.265 321.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M728.085 339.934L722.92 330.894L719.562 329.861L716.463 340.192L725.244 342.775C728.344 343.188 728.43 341.053 728.085 339.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M708.715 337.868L716.463 340.192L719.563 329.861L711.556 327.795L708.715 337.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M700.966 331.927L706.132 326.245L711.556 327.795L708.715 337.868L701.225 335.543C699.572 334.51 700.364 332.702 700.966 331.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M759.854 276.655L766.569 287.503L742.291 285.437L749.006 278.721L759.854 276.655Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M770.443 293.443L766.569 287.503L759.337 286.986L758.82 294.993C761.403 295.251 766.517 295.819 768.376 296.026L768.377 296.026C770.236 296.233 770.529 294.39 770.443 293.443Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M748.49 293.96L758.821 294.993L759.338 286.986L749.265 285.953L748.49 293.96Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M738.675 292.927L748.49 293.96L749.264 285.954L742.549 285.179L737.642 290.086C737.229 291.946 738.159 292.755 738.675 292.927Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M857.741 345.617L857.225 337.352L866.523 336.577L866.781 338.127C866.161 339.78 866.178 343.292 866.264 344.842L860.582 347.425C858.929 348.045 857.999 346.478 857.741 345.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M877.112 329.862C872.566 330.482 868.33 335.458 866.781 337.869L866.006 327.021L874.529 323.405L877.112 329.862Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.735 333.736C885.635 329.397 879.695 329.345 877.112 329.862L874.529 323.405L882.278 319.789L888.735 333.736Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M892.867 330.636L888.993 333.994L882.277 319.788L887.185 317.464L892.867 330.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M897.775 325.212L892.868 330.636L887.186 317.464L892.351 314.623L897.775 325.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M903.458 318.498L897.775 325.213L892.352 314.624L899.325 311.008L903.458 318.498Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M914.821 303.001L903.457 318.498L899.324 311.008L914.821 303.001Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.709 330.12L857.226 337.352L866.524 336.577L866.007 327.021L856.709 330.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M855.676 320.047L856.709 330.119L865.232 327.278L861.1 317.464L855.676 320.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M868.073 314.365L861.1 317.465L865.232 327.279L872.464 324.18L868.073 314.365Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M875.304 311.008L868.072 314.365L872.463 324.18L879.695 320.822L875.304 311.008Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M882.278 307.908L875.305 311.008L879.695 321.08L886.927 317.464L882.278 307.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M888.993 304.551L882.277 307.908L886.926 317.465L893.9 313.849L888.993 304.551Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M896.226 300.677L888.994 304.551L893.901 313.849L901.133 309.975L896.226 300.677Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M902.94 297.318L896.225 300.676L901.132 309.974L907.847 306.616L902.94 297.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M910.173 293.703L902.941 297.319L907.849 306.617L914.564 303.001L910.173 293.703Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M918.695 289.828L910.172 293.703L914.563 303.259L921.536 292.411C921.743 289.932 919.728 289.656 918.695 289.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M943.748 236.107L941.424 243.597L935.225 244.372L933.934 234.299C935.483 233.954 939.099 233.266 941.165 233.266C943.232 233.266 943.748 235.16 943.748 236.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M939.358 252.636L941.424 243.597L930.576 245.146L932.384 254.961C933.676 254.875 936.517 254.651 937.55 254.444C938.583 254.238 939.185 253.153 939.358 252.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M925.668 236.107L933.933 234.299L935.224 244.372L927.476 245.663L925.668 236.107Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M924.378 256.769L932.384 254.961L930.576 245.146L921.795 247.213L924.378 256.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M917.402 238.173L925.667 236.106L927.475 245.921L919.727 247.729L917.402 238.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M916.371 258.835L924.377 256.769L921.795 247.213L913.271 249.537L916.371 258.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M909.396 240.497L917.403 238.173L919.728 247.729L911.979 249.795L909.396 240.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M908.622 261.676L916.37 258.835L913.271 249.537L905.006 252.378L908.622 261.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M901.133 243.338L909.398 240.497L911.98 249.795L904.49 252.636L901.133 243.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M900.875 265.035L908.623 261.677L905.007 252.379L896.742 255.737L900.875 265.035Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M893.383 246.438L901.131 243.339L904.489 252.637L897.257 255.478L893.383 246.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.893 250.054L893.383 246.438L897.257 255.478L889.767 259.094L885.893 250.054Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M893.125 268.65L900.873 265.034L896.741 255.736L888.734 259.61L893.125 268.65Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M878.404 253.928L885.894 250.054L889.769 259.093L882.795 262.709L878.404 253.928Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.635 272.524L893.125 268.65L888.735 259.61L880.986 263.743L885.635 272.524Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M871.172 257.802L878.404 253.928L882.794 262.709L875.563 266.583L871.172 257.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M877.887 276.656L885.635 272.524L880.986 263.742L873.496 267.616L877.887 276.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M870.139 280.53L877.887 276.656L873.496 267.616L865.748 271.749L870.139 280.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M863.939 261.418L871.171 257.802L875.562 266.583L868.33 270.457L863.939 261.418Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.707 265.292L863.939 261.418L868.33 270.458L860.839 274.332L856.707 265.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M862.39 284.405L870.139 280.53L865.748 271.749L858.258 275.623L862.39 284.405Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M850.768 268.133L856.708 265.292L860.84 274.332L852.059 278.722L850.768 268.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M852.575 285.954L852.059 278.722L858.257 275.623L862.39 284.404L854.9 288.02C853.453 288.434 852.747 286.815 852.575 285.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M934.701 265.329L932.385 270.457L927.994 271.232L925.67 261.417L932.902 259.609C933.657 259.493 934.24 259.578 934.685 259.786C936.579 260.669 935.561 263.424 934.701 265.329Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M927.219 282.08L932.385 270.457C928.872 271.077 923.001 272.609 920.504 273.298L923.603 283.113L927.219 282.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M917.662 263.741L925.669 261.417L927.993 271.232L920.503 273.298L917.662 263.741Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M909.914 266.582L917.662 263.741L920.503 273.297L913.013 276.139L909.914 266.582Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M916.37 285.953L923.602 283.112L920.503 273.298L912.496 276.397L916.37 285.953Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M909.141 289.053L916.373 285.954L912.498 276.397L904.75 279.497L909.141 289.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M902.166 269.682L909.914 266.583L913.014 276.139L906.04 278.98L902.166 269.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M894.676 273.298L902.166 269.682L906.04 278.98L899.067 282.337L894.676 273.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M901.907 292.668L909.139 289.052L904.748 279.496L897 283.37L901.907 292.668Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M887.443 276.914L894.675 273.298L899.066 282.338L892.092 285.953L887.443 276.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M894.675 296.542L901.907 292.668L896.999 283.37L889.768 287.244L894.675 296.542Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M880.213 280.788L887.445 276.914L892.094 285.954L884.604 290.086L880.213 280.788Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M887.185 300.417L894.675 296.543L889.767 287.245L882.277 291.378L887.185 300.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M879.696 304.291L887.186 300.417L882.279 291.377L875.047 294.993L879.696 304.291Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M873.238 284.404L880.212 280.788L884.603 290.086L877.629 293.702L873.238 284.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M866.266 287.761L873.239 284.403L877.63 293.701L870.398 297.317L866.266 287.761Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M872.205 307.907L879.695 304.291L875.046 294.993L867.814 298.609L872.205 307.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M864.458 311.265L872.206 307.907L867.816 298.609L860.584 301.709L864.458 311.265Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M859.291 291.119L866.265 287.762L870.397 297.318L863.165 300.676L859.291 291.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M853.352 293.702L859.292 291.119L863.166 300.675L854.126 304.291L853.352 293.702Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M854.902 313.331L854.127 304.291L860.584 301.708L864.458 311.264L856.968 314.364C855.935 314.57 855.16 313.761 854.902 313.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M885.932 127.308L891.059 128.145L892.868 111.357L882.279 110.075L880.197 118.674C879.232 122.657 881.882 126.647 885.932 127.308Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M900.617 129.953L891.061 128.145L892.868 111.357L902.941 112.907L900.617 129.953Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M912.496 114.198L902.939 113.165L900.873 129.953L911.204 131.244L912.496 114.198Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M921.794 132.019L911.205 131.245L912.496 114.198L922.569 114.973L921.794 132.019Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M931.868 132.794L921.795 132.019L922.57 114.973L932.643 115.747L931.868 132.794Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M941.94 133.827L931.867 132.794L932.642 115.748L942.973 116.523L941.94 133.827Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M952.272 134.344L942.199 133.827L942.974 116.522L953.047 117.039L952.272 134.344Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M962.344 135.119L952.271 134.344L953.046 117.039L963.377 117.814L962.344 135.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M972.419 136.152L962.346 135.119L963.379 117.814L973.452 118.589L972.419 136.152Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M982.749 137.185L972.418 136.152L973.451 118.589L983.782 119.622L982.749 137.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M992.821 137.96L982.748 137.185L983.781 119.622L994.112 120.655L992.821 137.96Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1003.15 138.993L992.82 137.96L994.112 120.655L1004.18 121.947L1003.15 138.993Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M1013.23 139.251L1003.15 138.993L1004.19 121.946H1013.74L1013.23 139.251Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M691.67 355.689L689.346 362.662L677.465 359.305L681.597 354.139C682.424 353.106 684.008 353.364 684.697 353.623L691.67 355.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M673.332 363.954L677.465 359.305L685.472 361.629L682.889 369.378C680.478 368.775 675.295 367.415 673.849 366.795C672.402 366.175 672.902 364.642 673.332 363.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M692.703 371.96L682.889 369.377L685.471 361.629L694.769 364.47L692.703 371.96Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.26 358.531L691.67 355.689L689.346 362.663L700.193 366.021L702.26 358.531Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.518 374.802L692.703 371.961L694.769 364.471L704.842 367.312L702.518 374.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.332 377.384L702.518 374.802L704.842 367.312L714.915 369.894L712.332 377.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M717.756 378.934L712.332 377.385L714.915 369.895L728.862 374.285L717.756 378.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M735.576 371.186L728.861 374.285L721.371 371.961L723.696 364.471L734.802 367.57C737.074 368.81 736.265 370.497 735.576 371.186Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.849 361.371L723.697 364.47L721.373 371.96L710.783 368.861L712.849 361.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.26 358.53L712.849 361.371L710.783 368.861L700.193 366.02L702.26 358.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M731.186 297.835L734.802 298.093L734.027 308.941L722.404 307.65L731.186 297.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M717.497 313.59L722.403 307.649L727.827 308.424L727.052 317.981L718.529 316.947C716.669 316.328 717.066 314.365 717.497 313.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M735.832 318.755L727.051 317.98L727.826 308.424L736.607 309.199L735.832 318.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M742.549 298.868L734.801 298.093L733.768 308.94L741.774 309.715L742.549 298.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M750.297 299.385L742.548 298.868L741.773 309.716L749.522 310.232L750.297 299.385Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M744.874 319.53L735.834 318.755L736.609 309.199L745.39 309.974L744.874 319.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M753.396 320.306L744.873 319.531L745.39 309.975L753.913 310.491L753.396 320.306Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M757.788 299.901L750.298 299.385L749.523 310.232L757.013 310.749L757.788 299.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M765.279 300.676L757.789 299.901L757.014 310.749L764.504 311.266L765.279 300.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M773.027 301.192L765.279 300.676L764.504 311.265L771.994 312.04L773.027 301.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M775.608 301.192H773.025L771.992 312.04L784.39 312.815L775.608 301.192Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M762.178 321.081L753.396 320.306L753.913 310.491L762.694 311.266L762.178 321.081Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M770.959 321.855L762.178 321.08L762.694 311.266L771.734 312.04L770.959 321.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.482 322.629L770.959 321.855L771.734 312.04L780.257 312.557L779.482 322.629Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M790.588 320.305L784.39 312.815L780.257 312.557L779.482 322.629L788.522 323.404C791.002 323.198 790.933 321.252 790.588 320.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M810.476 259.093L815.383 266.066L805.827 272.781L803.244 269.166C805.93 268.132 807.118 262.709 807.377 260.126L810.476 259.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M795.237 272.264C798.75 272.884 802.038 270.456 803.244 269.165L807.118 274.847L798.078 280.788L793.688 274.847L795.237 272.264Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M819.257 271.749L815.382 266.066L805.826 272.782L809.959 278.722L819.257 271.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M802.469 287.245L798.078 280.788L807.118 274.848L811.25 280.788L802.469 287.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M807.118 293.444L802.469 287.245L811.25 280.788L815.899 286.728L807.118 293.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M823.389 277.431L819.257 271.749L809.959 278.981L814.091 284.405L823.389 277.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M827.52 282.854L823.388 277.431L814.09 284.404L818.481 290.086L827.52 282.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M811.766 299.642L807.117 293.444L815.899 286.729L820.548 292.669L811.766 299.642Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M831.913 288.02L827.522 282.854L818.482 290.086L823.131 295.768L831.913 288.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.675 305.583L811.768 299.642L820.549 292.669L825.198 298.609L816.675 305.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M836.561 293.443L831.912 288.02L823.131 295.768L827.522 301.192L836.561 293.443Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M821.581 311.523L816.674 305.583L825.197 298.609L829.846 304.291L821.581 311.523Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M840.952 298.609L836.562 293.443L827.264 301.192L832.171 306.616L840.952 298.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M826.748 317.205L821.582 311.523L829.847 304.291L835.012 309.715L826.748 317.205Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M845.6 303.775L840.951 298.609L832.17 306.616L837.077 312.04L845.6 303.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M832.17 322.887L826.746 317.205L835.011 309.715L839.918 315.139L832.17 322.887Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M850.25 308.682L845.601 303.774L837.078 312.039L841.985 316.947L850.25 308.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.543 326.761L850.251 308.682L841.986 316.947L851.543 326.761Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M837.335 328.311L832.17 322.887L840.177 315.139L845.342 320.304L837.335 328.311Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M843.018 333.735L837.336 328.311L845.343 320.305L850.766 325.987L843.018 333.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M849.476 339.933L843.02 333.735L850.768 325.986L851.543 326.503L853.092 338.642C852.266 341.121 850.337 340.536 849.476 339.933Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M729.119 331.411L739.708 326.762L738.675 323.662L727.828 322.371C725.761 322.784 725.589 324.437 725.761 325.212L729.119 331.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M732.218 337.868L729.119 331.411L739.709 326.762L742.55 333.219L732.218 337.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M734.802 343.292L732.219 337.868L742.55 333.219L746.166 341.225C744.1 342.172 739.347 344.221 737.901 344.841C736.455 345.461 735.146 343.894 734.802 343.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M750.557 324.953L738.676 323.662L742.55 333.477L752.365 329.344L750.557 324.953Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M755.721 336.835L752.363 329.345L742.549 333.477L746.165 341.226L755.721 336.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M759.338 325.471L750.557 324.954L755.722 336.835L763.212 333.477L759.338 325.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M774.835 326.762L759.338 325.471L763.212 333.477L775.609 328.828C776.229 327.382 775.351 326.848 774.835 326.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M784.39 269.166L787.489 274.073L779.224 279.497L774.059 271.232C775.264 270.716 778.243 269.476 780.516 268.649C782.788 267.823 784.045 268.649 784.39 269.166Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M768.076 273.162L774.059 271.232L777.675 277.173L769.41 282.597C768.291 280.789 765.898 276.915 765.278 275.881C765.205 275.761 765.153 275.644 765.119 275.531C764.706 274.177 766.729 273.597 768.076 273.162Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M773.801 289.57L769.41 282.597L777.675 277.173L782.066 283.888L773.801 289.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M791.88 280.788L787.49 274.073L779.225 279.497L783.874 286.471L791.88 280.788Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M778.708 296.543L773.801 289.57L782.066 283.888L786.715 290.861L778.708 296.543Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M796.529 287.504L791.88 280.789L783.873 286.471L788.78 293.445L796.529 287.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M783.616 303.517L778.709 296.543L786.974 290.861L791.623 297.577L783.616 303.517Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M801.437 294.219L796.53 287.504L788.781 293.444L793.689 300.16L801.437 294.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M788.523 310.232L783.615 303.517L791.622 297.576L796.271 304.033L788.523 310.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M806.344 300.676L801.436 294.219L793.43 300.159L798.595 306.874L806.344 300.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M793.687 316.948L788.521 310.233L796.27 304.034L801.435 310.491L793.687 316.948Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M811.51 307.133L806.344 300.676L798.596 306.874L804.02 313.59L811.51 307.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.37 323.404L793.688 316.947L801.436 310.49L806.86 316.947L799.37 323.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.931 313.331L811.508 307.133L804.018 313.59L809.441 319.788L816.931 313.331Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M804.795 329.861L799.371 323.404L806.861 316.947L812.285 323.146L804.795 329.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M822.357 319.272L816.933 313.332L809.443 319.789L815.125 326.246L822.357 319.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M810.477 336.06L804.795 329.862L812.285 323.146L817.709 329.345L810.477 336.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M828.039 325.47L822.357 319.271L815.125 326.245L820.807 332.444L828.039 325.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M816.159 342.259L810.477 336.06L817.967 329.345L823.39 335.285L816.159 342.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M833.721 331.153L828.038 325.471L820.807 332.444L826.489 338.385L833.721 331.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M822.099 348.199L816.158 342.259L823.39 335.285L829.33 340.967L822.099 348.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M839.662 336.835L833.722 331.153L826.49 338.385L832.689 344.325L839.662 336.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M828.555 354.14L822.098 348.2L829.329 340.968L835.27 346.908L828.555 354.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M845.601 342.259L839.661 336.835L832.688 344.325L838.886 350.007L845.601 342.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M851.542 348.199L845.602 342.259L838.887 350.007L843.019 354.14L849.993 351.557C852.266 350.524 851.973 348.888 851.542 348.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M833.204 358.531L843.018 354.14L835.27 346.908L828.555 354.14L833.204 358.531Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M746.681 345.616L750.813 354.656L743.065 358.014C742.29 356.636 740.482 353.416 739.449 351.557C738.416 349.697 739.88 348.543 740.74 348.199L746.681 345.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M758.821 351.299L750.814 354.656L746.682 345.616L754.947 342.259L758.821 351.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M762.952 338.901L754.945 342.259L758.819 351.299L766.826 347.941L762.952 338.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M771.216 335.544L762.951 338.902L766.825 347.941L775.09 344.584L771.216 335.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M745.906 364.212L743.064 358.014L752.362 354.14L755.978 362.921L748.747 366.02C747.507 366.64 746.336 365.073 745.906 364.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M764.761 359.304L755.979 362.92L752.363 354.139L761.145 350.265L764.761 359.304Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M773.542 355.689L764.76 359.305L761.145 350.265L769.926 346.649L773.542 355.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M782.323 352.332L773.542 355.689L769.926 346.65L778.707 343.292L782.323 352.332Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.74 332.186L771.217 335.543L775.091 344.583L783.356 341.484L779.74 332.186Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M791.104 348.974L782.323 352.332L778.707 343.292L787.488 339.935L791.104 348.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.369 345.874L791.104 348.974L787.488 339.934L795.495 336.576L799.369 345.874Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M788.005 329.086L779.74 332.185L783.356 341.483L791.879 338.126L788.005 329.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M793.428 327.02L788.004 329.086L791.878 338.126L801.693 334.252C800.315 332.53 797.302 328.828 796.269 327.795C795.236 326.762 793.944 326.848 793.428 327.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M806.344 343.292L799.37 345.874L795.496 336.576L801.695 334.252L807.377 340.192C807.79 341.845 806.86 342.947 806.344 343.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M746.685 153.715L757.016 151.39L753.4 135.377L742.811 137.96L746.685 153.715Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M767.089 148.808C763.818 149.669 757.223 151.39 757.016 151.39L753.4 135.377L763.215 133.053L767.089 148.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.405 125.305L763.213 133.053L742.809 137.96L741.26 130.212L761.405 125.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M739.969 121.947L741.26 130.212L761.406 125.305L759.34 117.04L739.969 121.947Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M738.42 113.682L739.97 121.947L759.34 117.039L757.532 108.774L738.42 113.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M737.127 105.159L738.418 113.682L757.531 108.775L755.206 100.252L737.127 105.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M735.578 96.3775L737.128 105.159L755.207 100.252L753.399 91.7285L735.578 96.3775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M733.254 87.338C734.287 88.3711 735.234 93.7949 735.578 96.3777L753.141 91.7287L750.817 82.9473L733.254 87.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M729.121 83.7223C731.601 84.3422 733.081 86.3912 733.512 87.3382L750.816 82.9475L748.75 74.6826L729.121 79.3316V83.7223Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M729.896 69.258L729.121 79.3309L748.75 74.6819L746.684 66.417L729.896 69.258Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M731.704 49.8877L746.685 66.4175L729.896 69.2585L731.188 51.9539L731.704 49.8877Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.282 26.3848L711.01 43.9477L726.526 44.4642V43.4311L712.282 26.3848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.018 53.5035L726.527 44.4638L711.011 43.9473L710.502 52.7287L726.018 53.5035Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M709.992 61.7692L710.501 52.7295L726.017 53.5043L725.508 62.8023L709.992 61.7692Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M725.253 72.3579L725.508 62.8017L709.992 61.7686L709.229 71.0666L725.253 72.3579Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M723.727 86.5631L725.254 72.3578L709.229 71.0664L708.975 75.1989L723.727 86.5631Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.329 280.53L708.713 284.663L715.428 290.861L723.951 280.53H712.329Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M737.384 280.014L723.953 280.53L722.662 282.08L731.702 289.828L737.901 282.596C738.727 280.943 737.901 280.186 737.384 280.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.793 295.511L731.7 289.828L722.661 282.08L718.012 287.762L726.793 295.511Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M721.884 300.934L726.792 295.51L718.01 287.762L713.361 293.444L721.884 300.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.516 291.637L708.714 284.663L715.43 290.862L709.231 297.835L702.516 291.637Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M716.978 306.617L721.886 300.934L713.362 293.444L708.455 298.868L716.978 306.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.33 312.04L716.979 306.616L708.456 298.868L703.549 304.292L712.33 312.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M696.316 298.868L702.515 291.636L709.23 297.834L703.032 304.808L696.316 298.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M708.714 315.914L712.33 312.04L703.548 304.292L697.35 311.265L708.714 315.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.893 305.067L696.316 298.868L703.032 304.809L697.35 311.266L690.893 306.358V305.067Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M875.044 118.59L877.627 108L862.388 106.192L860.322 114.974L875.044 118.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M872.72 128.662L875.044 118.59L860.323 114.974L857.998 124.272L872.72 128.662Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M870.138 138.735L872.721 128.662L857.999 124.271L855.158 134.344L870.138 138.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M867.813 148.55L870.137 138.735L855.157 134.345L852.574 144.159L867.813 148.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M849.732 154.232L852.573 144.159L867.812 148.55L864.971 158.364L849.732 154.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M846.893 164.305L849.734 154.232L864.972 158.365L862.648 168.179L846.893 164.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M844.568 174.119L846.893 164.305L862.648 168.179L860.323 177.993L844.568 174.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M857.997 188.066L860.322 177.993L844.567 174.119L842.242 184.192L857.997 188.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M856.449 196.073L857.998 188.067L842.243 184.192L839.402 196.331C842.502 197.106 849.165 198.553 852.058 199.172C854.951 199.792 856.19 197.365 856.449 196.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M762.695 169.213L760.887 179.027C758.993 178.683 754.895 176.548 753.656 170.762C752.416 164.977 751.245 159.915 750.814 158.107L759.338 155.782L762.695 169.213Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M768.119 153.716L759.338 155.782L762.696 169.212L760.888 179.027L769.927 180.835L773.543 164.305L770.702 163.789L768.119 153.716Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.742 182.901L769.928 180.834L773.544 164.305L783.616 166.629L779.742 182.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M789.813 184.968L779.74 182.901L783.614 166.63L793.687 168.696L789.813 184.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.887 187.034L789.814 184.968L793.689 168.696L803.503 171.021L799.887 187.034Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M809.701 189.358L799.887 187.034L803.503 171.021L813.317 173.345L809.701 189.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M819.518 191.682L809.703 189.358L813.319 173.345L823.392 175.411L819.518 191.682Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M829.588 194.007L819.516 191.683L823.39 175.411L833.463 177.477L829.588 194.007Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M843.279 179.802L833.464 177.478L829.59 194.007L839.404 196.332L843.279 179.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M743.841 171.795L745.132 177.478L735.576 180.319L733.51 172.312C734.543 171.968 737.281 171.124 739.967 170.504C742.653 169.884 743.669 171.107 743.841 171.795Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M725.503 174.119L733.51 172.312L735.576 180.318L726.02 182.901C725.675 181.696 724.883 178.872 724.47 177.219C724.057 175.566 724.987 174.464 725.503 174.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M747.457 185.484L745.132 177.478L735.576 180.319L737.901 188.325L747.457 185.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M728.086 190.908L726.02 182.901L735.576 180.318L737.642 188.067L728.086 190.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M730.669 198.915L728.086 190.908L737.9 188.067L740.225 195.816L730.669 198.915Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M749.781 193.233L747.457 185.484L737.9 188.325L740.483 196.59L749.781 193.233Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M733.251 206.921L730.668 198.915L740.224 195.815L742.807 203.822L733.251 206.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.365 201.239L749.782 193.232L740.484 196.59L743.067 204.338L752.365 201.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M736.093 215.186L733.252 206.921L742.808 203.821L745.391 211.57L736.093 215.186Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M754.947 208.988L752.364 201.239L743.066 204.339L745.649 212.603L754.947 208.988Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M738.933 223.193L736.092 215.186L745.39 211.57L748.489 219.319L738.933 223.193Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M758.047 216.477L754.948 208.987L745.908 212.603L748.749 220.093L758.047 216.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M742.033 230.941L738.934 223.193L748.49 219.318L751.331 226.808L742.033 230.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.145 223.968L758.046 216.478L748.748 220.093L751.847 228.1L761.145 223.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M745.391 238.689L742.033 230.941L751.331 226.809L754.689 234.299L745.391 238.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M764.245 231.458L761.146 223.968L751.848 228.1L755.205 235.59L764.245 231.458Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M749.007 246.18L745.391 238.69L754.689 234.299L758.046 241.789L749.007 246.18Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M767.602 238.689L764.245 231.457L755.205 235.589L758.821 243.08L767.602 238.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.882 253.928L749.008 246.18L758.048 241.789L761.922 249.279L752.882 253.928Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M771.476 246.18L767.602 238.689L758.82 243.08L762.694 250.829L771.476 246.18Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M756.755 261.417L752.881 253.927L761.921 249.278L765.795 256.51L756.755 261.417Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M775.351 253.411L771.477 246.18L762.695 250.829L766.569 258.06L775.351 253.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M778.193 258.577L775.352 253.411L766.57 258.06L770.186 264.775L776.385 262.709C778.658 262.089 778.537 259.696 778.193 258.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M757.428 262.555L756.754 261.418L765.794 256.511L770.184 264.776L767.21 265.933C763.562 267.351 759.423 265.922 757.428 262.555Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M719.306 177.219L720.855 183.417L711.041 186L708.975 177.994C709.749 177.735 712.022 177.012 714.915 176.186C717.808 175.359 719.047 176.53 719.306 177.219Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M701.226 180.059L708.974 177.993L710.782 185.483L700.968 188.066C700.71 186.947 700.09 184.76 699.676 182.9C699.263 181.041 700.537 180.232 701.226 180.059Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M703.033 196.073L700.967 188.066L710.781 185.483L712.848 193.232L703.033 196.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.922 191.165L720.856 183.417L711.041 186L713.107 194.006L722.922 191.165Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M725.246 198.656L722.922 191.166L713.107 194.007L715.432 201.755L725.246 198.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M705.358 204.08L703.033 196.073L712.848 193.232L715.172 200.722L705.358 204.08Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M707.942 211.828L705.359 204.079L715.174 200.722L717.757 208.47L707.942 211.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M727.829 206.663C726.968 204.08 725.246 198.863 725.246 198.656L715.432 201.756L718.273 209.762L727.829 206.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M730.671 213.894L727.83 206.662L718.273 209.761L721.114 217.51L730.671 213.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M710.524 219.577L707.941 211.828L717.756 208.471L720.339 215.702L710.524 219.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M733.252 221.385L730.67 213.895L721.113 217.51L723.696 225.259L733.252 221.385Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M713.106 227.066L710.523 219.576L720.338 215.702L722.921 223.192L713.106 227.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M715.948 234.815L713.107 227.067L722.922 223.192L725.763 230.941L715.948 234.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M736.351 229.133L733.252 221.385L723.695 225.259L726.795 233.007L736.351 229.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M719.047 242.305L715.947 234.815L726.02 230.94L728.861 237.914L719.047 242.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M739.451 236.365L736.351 229.133L726.795 233.007L729.894 240.497L739.451 236.365Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.404 250.053L719.047 242.305L728.861 237.914L732.219 245.404L722.404 250.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M725.764 257.285L722.406 250.053L732.221 245.404L735.578 252.378L725.764 257.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.537 258.835L725.762 257.285L735.576 252.378L741.517 265.034L726.537 258.835Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M751.074 269.424L741.517 265.034L740.484 262.709L749.266 257.802L754.431 267.1C754.225 269.992 752.107 269.855 751.074 269.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M742.55 243.596L739.451 236.364L729.895 240.497L733.51 247.987L742.55 243.596Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M746.167 250.828L742.551 243.597L733.512 247.987L737.128 255.477L746.167 250.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M749.266 257.802L746.167 250.828L737.127 255.477L740.485 262.709L749.266 257.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M564.853 264.517L573.117 269.683L570.276 275.106L558.912 269.683L561.495 264.775C562.728 263.337 564.063 264.079 564.84 264.51L564.853 264.517Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M584.225 276.914L573.119 269.683L566.662 282.08L584.225 276.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M555.814 275.881L558.914 269.683L570.278 275.106L566.92 281.305L555.814 275.881Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M550.133 287.762L555.815 275.881L566.921 281.305L566.663 282.08L550.133 287.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M546.258 294.994L550.132 287.762L554.265 286.471L557.364 295.769L548.324 298.868C545.431 298.455 545.741 296.113 546.258 294.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M565.888 292.669L557.365 295.768L554.266 286.47L562.789 283.371L565.888 292.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M574.412 289.828L565.888 292.669L562.789 283.371L571.571 280.53L574.412 289.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M582.674 287.246L574.409 289.829L571.568 280.531L580.092 278.206L582.674 287.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M591.456 285.179L582.675 287.245L580.092 278.205L584.224 276.914L592.747 282.08C593.161 283.939 592.059 284.921 591.456 285.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M823.982 356.185L820.293 352.848L813.578 355.172L816.419 363.695L824.168 361.113C824.902 360.949 825.338 360.539 825.581 360.045C826.255 358.674 825.115 357.21 823.982 356.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M813.319 346.133L820.292 352.848L809.186 356.464L806.604 348.457L813.319 346.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M807.894 366.537L816.417 363.696L813.576 355.173L804.795 358.014L807.894 366.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M797.307 351.815L806.605 348.457L809.187 356.464L799.889 359.821L797.307 351.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M799.115 369.894L807.896 366.537L804.797 358.014L796.016 361.371L799.115 369.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M788.525 354.914L797.307 351.814L799.89 359.821L791.366 363.179L788.525 354.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M790.592 373.252L799.115 369.894L796.015 361.371L787.492 364.729L790.592 373.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M779.484 358.53L788.524 354.914L791.365 363.179L782.842 366.537L779.484 358.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M782.068 376.609L790.591 373.252L787.492 364.729L778.969 368.086L782.068 376.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M770.703 361.888L779.485 358.53L782.842 366.537L773.802 370.153L770.703 361.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M773.545 379.968L782.068 376.61L778.969 368.087L770.188 371.703L773.545 379.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M761.664 365.504L770.704 361.888L773.803 369.894L764.763 373.768L761.664 365.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M765.022 383.325L773.545 379.968L770.187 371.444L761.664 375.06L765.022 383.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M752.883 369.12L761.664 365.504L764.764 373.511L756.499 377.126L752.883 369.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M756.498 386.94L765.021 383.324L761.664 375.06L753.141 378.675L756.498 386.94Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M744.102 372.993L752.883 369.119L756.241 377.126L747.459 380.742L744.102 372.993Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M747.975 390.556L756.498 386.94L753.141 378.417L744.359 382.033L747.975 390.556Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M735.318 376.61L744.1 372.994L747.457 380.742L738.418 384.617L735.318 376.61Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M739.452 394.431L747.975 390.556L744.359 382.033L735.836 385.649L739.452 394.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M731.187 398.047L739.452 394.431L735.836 385.649L727.312 389.524L731.187 398.047Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.922 401.921L731.186 398.047L727.312 389.523L718.789 393.398L722.922 401.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M726.797 380.484L735.32 376.609L738.419 384.616L729.896 388.232L726.797 380.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M717.498 384.358L726.796 380.483L729.895 388.232L721.114 392.364L717.498 384.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M556.332 330.378L565.63 327.021L567.954 328.57L562.014 338.385L555.557 334.252C554.317 332.393 555.557 330.895 556.332 330.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M568.212 342.258L562.014 338.384L567.954 328.569L574.153 332.444L568.212 342.258Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M574.412 346.133L568.213 342.259L574.153 332.444L580.352 336.06L574.412 346.133Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M580.611 349.491L574.412 346.133L580.353 336.061L586.293 339.676L580.611 349.491Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M586.55 353.106L580.609 349.49L586.291 339.676L592.49 343.292L586.55 353.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M593.006 356.464L586.549 353.107L592.489 343.292L598.688 346.908L593.006 356.464Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.882 358.53L593.008 356.464L598.69 346.907L606.438 351.815C605.061 353.536 601.944 357.238 600.498 358.271C599.052 359.305 597.485 358.874 596.882 358.53Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M611.861 345.617L606.437 351.815L598.947 347.166L604.113 338.901C605.921 339.934 609.847 342.207 611.086 343.034C612.326 343.86 612.119 345.1 611.861 345.617Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.623 334.51L604.113 338.9L598.947 347.165L591.457 342.775L596.623 334.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M589.132 330.119L596.622 334.51L591.457 342.775L583.967 338.384L589.132 330.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M581.642 325.471L589.132 330.12L583.967 338.126L576.477 333.736L581.642 325.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M577.51 322.888L581.642 325.47L576.477 333.735L565.629 327.02L577.51 322.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M694.77 183.418L696.061 188.842L685.988 191.683L683.922 183.676C685.385 183.332 688.881 182.488 691.154 181.868C693.427 181.248 694.511 182.643 694.77 183.418Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M675.916 185.485L683.922 183.677L685.73 191.167L675.657 194.008L674.366 188.842C673.953 186.569 675.227 185.657 675.916 185.485Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M698.127 196.848L696.061 188.842L685.988 191.683L688.055 199.689L698.127 196.848Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M677.464 201.755L675.656 194.007L685.729 191.166L687.795 198.656L677.464 201.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M700.194 204.339L698.128 196.849L688.055 199.69L690.379 207.18L700.194 204.339Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M679.533 209.246L677.467 201.756L687.798 198.656L689.864 205.888L679.533 209.246Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M682.114 216.735L679.531 209.245L689.862 205.888L692.187 213.378L682.114 216.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.518 211.828L700.193 204.338L690.379 207.179L692.703 215.186L702.518 211.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M705.1 219.576L702.518 211.828L692.703 215.186L695.544 222.676L705.1 219.576Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M684.696 224.484L682.113 216.736L692.186 213.378L694.769 220.61L684.696 224.484Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M687.28 231.716L684.697 224.485L694.77 220.61L697.353 227.842L687.28 231.716Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M707.684 226.809L705.101 219.577L695.545 222.935L698.386 230.425L707.684 226.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.12 239.206L687.279 231.716L697.352 227.842L700.193 235.074L690.12 239.206Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M710.782 234.299L707.683 226.809L698.385 230.424L701.226 238.173L710.782 234.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.638 240.497L690.121 239.206L700.194 235.073L705.101 247.471L690.638 240.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M713.625 241.531L710.784 234.299L701.486 238.173L704.327 245.405L713.625 241.531Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M717.24 249.279L713.624 241.53L704.326 245.404L705.101 247.471L714.141 252.378C717.653 253.204 717.671 250.656 717.24 249.279Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M720.338 403.211L722.921 402.178L718.788 393.397L712.59 392.105L710.523 400.887L720.338 403.211Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M711.297 382.808L717.495 384.357L721.111 392.364L718.787 393.397L709.23 391.331L711.297 382.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M701.998 380.482L711.296 382.807L709.23 391.33L699.674 389.006L701.998 380.482Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M701.223 398.821L710.521 400.887L712.587 392.105L703.547 390.039L701.223 398.821Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M692.184 396.238L701.223 398.821L703.548 390.039L694.766 387.715L692.184 396.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M692.959 377.9L701.999 380.483L699.674 389.006L690.635 386.682L692.959 377.9Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M683.919 375.317L692.959 377.9L690.634 386.682L681.078 383.841L683.919 375.317Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.88 372.734L683.92 375.317L681.079 383.84L672.039 380.741L674.88 372.734Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M683.402 393.656L692.184 396.238L694.767 387.715L685.985 385.391L683.402 393.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.363 390.815L683.403 393.656L685.986 385.391L677.204 382.55L674.363 390.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M665.582 387.973L674.363 390.814L677.205 382.549L668.681 379.708L665.582 387.973Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M667.647 370.41L674.879 372.735L672.038 380.741L661.707 377.125L667.647 370.41Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M657.575 385.132L665.582 387.973L668.681 379.708L661.708 377.125L657.058 382.291C656.439 383.944 657.145 384.873 657.575 385.132Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M622.707 179.285C624.257 179.543 629.078 180.921 631.747 181.609L626.84 189.099L615.992 182.643C618.833 179.285 621.179 179.03 622.707 179.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.536 190.907L615.993 182.643L621.158 185.742L614.185 196.331C613.238 195.729 611.085 194.317 610.052 193.49C609.019 192.664 609.277 191.424 609.536 190.907Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.351 199.689L614.186 196.332L621.159 185.742L626.325 188.842L619.351 199.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M625.807 203.822L619.35 199.689L626.323 188.842L632.522 192.974L625.807 203.822Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M640.529 183.676L631.747 181.609L626.84 189.099L634.072 194.007L640.529 183.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M647.244 185.225L640.529 183.676L634.072 194.007L639.496 197.623L647.244 185.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M631.23 207.179L625.807 203.821L632.522 192.974L637.687 196.331L631.23 207.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M636.915 210.536L631.232 207.179L637.689 196.331L643.371 199.947L636.915 210.536Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M653.185 186.775L647.244 185.226L639.496 197.623L644.662 200.722L653.185 186.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M657.059 187.809L653.185 186.775L644.662 200.722L650.861 204.597L653.96 202.53L657.059 187.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M642.853 214.153L636.912 210.537L643.369 199.947L649.309 203.563L642.853 214.153Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M648.536 217.769L642.854 214.153L649.31 203.563L654.993 206.921L648.536 217.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M661.191 189.1L657.058 187.809L653.959 202.53L663.774 199.173L661.191 189.1Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M666.357 187.808L661.191 189.1L663.774 199.172L672.039 197.106C671.781 195.987 671.058 193.077 670.231 190.391C669.405 187.705 667.304 187.55 666.357 187.808Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M673.073 202.014L672.04 197.106L663.775 199.173L653.96 202.53L651.119 204.597L655.51 207.179L673.073 202.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.362 207.438L673.071 202.014L655.508 207.179L662.223 211.053L674.362 207.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M654.476 221.126L648.535 217.769L654.992 206.921L660.674 210.279L654.476 221.126Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M660.415 224.225L654.475 221.126L660.673 210.278L666.355 213.378L660.415 224.225Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M678.238 220.093L674.364 207.438L662.225 211.053L678.238 220.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M666.356 227.325L660.416 224.226L666.356 213.378L672.297 216.736L666.356 227.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M672.298 230.424L666.357 227.325L672.298 216.735L677.98 219.835L672.298 230.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M683.145 233.781L677.979 219.576L672.297 230.424L681.337 235.848C683.403 236.261 683.403 234.642 683.145 233.781Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.847 264.594L716.822 261.935L711.299 273.299H719.583C720.42 271.767 722.244 268.366 722.847 267.012C723.449 265.658 723.098 264.836 722.847 264.594Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M709.491 258.318L716.723 261.934L712.332 271.232L704.842 267.358L709.491 258.318Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M692.703 273.298H711.299L712.332 271.232L697.869 263.742L692.703 273.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702 254.703L709.49 258.319L704.841 267.359L697.609 263.743L702 254.703Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M694.768 251.087L702 254.703L697.609 263.743L690.119 260.127L694.768 251.087Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M685.729 269.424L692.702 273.299L697.868 263.742L690.636 260.385L685.729 269.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M678.238 265.55L685.728 269.425L690.636 260.385L683.146 256.511L678.238 265.55Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M687.536 247.471L694.768 251.087L690.118 260.126L682.887 256.252L687.536 247.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M671.006 261.676L678.238 265.551L683.145 256.511L675.913 252.637L671.006 261.676Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M680.305 243.597L687.537 247.471L682.888 256.252L675.656 252.378L680.305 243.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M673.073 239.723L680.305 243.597L675.656 252.378L668.424 248.504L673.073 239.723Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M663.518 257.544L671.008 261.676L675.915 252.636L668.683 248.504L663.518 257.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M666.099 235.849L673.072 239.723L668.423 248.504L661.191 244.63L666.099 235.849Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M656.285 253.67L663.517 257.544L668.424 248.505L661.451 244.889L656.285 253.67Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M648.795 249.537L656.285 253.67L661.451 244.888L653.96 240.756L648.795 249.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M658.868 231.716L666.1 235.848L661.193 244.63L653.961 240.756L658.868 231.716Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.564 245.404L648.796 249.537L653.962 240.755L646.73 236.623L641.564 245.404Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M651.636 227.842L658.868 231.716L653.96 240.756L646.729 236.623L651.636 227.842Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M644.664 223.71L651.637 227.842L646.73 236.624L639.498 232.233L644.664 223.71Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M634.59 241.531L641.563 245.405L646.729 236.624L640.014 232.491L634.59 241.531Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M626.842 237.14L634.59 241.531L639.756 232.491L632.524 228.101L626.842 237.14Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.867 232.749L626.841 237.14L632.523 228.1L625.549 223.968L619.867 232.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M637.689 219.577L644.662 223.71L639.496 232.233L632.781 228.1L637.689 219.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M630.973 215.444L637.688 219.577L632.523 228.1L625.291 223.968L630.973 215.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M624 211.312L630.974 215.445L625.292 223.968L618.318 219.836L624 211.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M612.895 228.358L619.868 232.749L625.292 223.967L618.318 219.835L612.895 228.358Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M617.025 206.921L623.999 211.312L618.317 219.835L611.602 215.444L617.025 206.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.922 224.226L612.895 228.358L618.319 219.835L611.604 215.444L605.922 224.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M610.311 202.789L617.026 206.922L611.602 215.445L604.629 210.796L610.311 202.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M598.432 219.319L605.922 224.226L611.604 215.444L604.372 210.537L598.432 219.319Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.404 199.431L610.311 202.789L604.629 210.796L597.914 206.663C599.033 205.027 601.478 201.446 602.305 200.206C603.131 198.966 604.715 199.173 605.404 199.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M593.523 212.345L597.914 206.663L604.371 210.537L598.431 219.319C597.225 218.458 594.505 216.529 593.265 215.703C592.025 214.876 592.92 213.12 593.523 212.345Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M741.774 162.755L739.191 146.483L728.602 149.066L732.476 164.563L741.774 162.755Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M722.403 166.888L732.476 164.563L728.602 149.066L718.787 151.391L722.403 166.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M712.331 169.47L722.404 166.887L718.788 151.391L708.715 153.715L712.331 169.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M702.516 171.794L712.331 169.47L708.715 153.715L698.9 156.039L702.516 171.794Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M692.442 174.119L702.515 171.794L698.899 156.039L688.826 158.105L692.442 174.119Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M682.628 176.444L692.442 174.12L688.826 158.106L679.012 160.431L682.628 176.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M672.557 178.768L682.63 176.444L679.014 160.431L669.199 162.755L672.557 178.768Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M663.516 181.609L672.556 178.768L669.198 162.755L661.45 164.563L659.9 181.093L663.516 181.609Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M648.793 178.252L659.899 181.093L661.449 164.563L652.925 162.755L648.793 178.252Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M638.98 175.669L648.795 178.251L652.927 162.755L643.113 159.655L638.98 175.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.164 173.086L638.979 175.669L643.111 159.656L633.297 157.331L629.164 173.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.35 170.245L629.164 173.086L633.297 157.331L623.224 155.265L619.35 170.245Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M615.734 169.47L619.35 170.245L623.224 155.265L609.277 151.907L614.443 171.02L615.734 169.47Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M560.723 248.503L565.114 239.722L550.908 232.49L546.518 241.53L560.723 248.503Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M569.762 231.974L565.113 239.722L550.908 232.49L556.849 222.159L569.762 231.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M575.96 223.967L569.762 231.974L556.848 222.159L562.788 213.895L575.96 223.967Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M581.902 215.443L575.961 223.967L562.789 213.894L568.729 205.629L581.902 215.443Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M588.101 207.437L581.903 215.444L568.73 205.629L574.929 197.364L588.101 207.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M594.04 199.173L588.1 207.438L574.928 197.365L580.868 189.358L594.04 199.173Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M600.24 190.908L594.041 199.173L580.869 189.358L587.068 180.835L600.24 190.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.921 182.643L600.239 190.908L587.066 180.835L593.265 172.828L605.921 182.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M611.862 174.636L605.921 182.643L593.266 172.828L599.206 164.563L611.862 174.636Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M614.445 171.02L611.863 174.636L599.207 164.563L609.022 151.649L614.445 171.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M604.111 282.338L619.608 279.239L607.727 271.749L602.045 281.564L604.111 282.338Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.941 277.689L619.61 279.238L617.285 277.689L622.451 268.907L632.007 274.589C632.42 276.656 630.802 277.516 629.941 277.689Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M615.476 264.775L622.449 268.908L617.284 277.689L610.568 273.557L615.476 264.775Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M608.503 260.643L615.476 264.775L610.569 273.556L603.596 269.166L608.503 260.643Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M595.33 277.69L602.045 281.564L607.727 271.749L601.529 267.875L595.33 277.69Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M601.53 256.511L608.504 260.643L603.597 269.166L596.623 264.776L601.53 256.511Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M589.133 273.815L595.331 277.689L601.53 267.874L595.331 264L589.133 273.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M594.814 252.378L601.529 256.51L596.621 264.775L589.906 260.643L594.814 252.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M582.674 269.941L589.131 273.815L595.329 264L588.872 260.126L582.674 269.941Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M588.099 247.987L594.814 252.378L589.907 260.643L582.934 256.252L588.099 247.987Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M576.217 265.809L582.674 269.941L588.872 260.127L582.674 255.994L576.217 265.809Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M581.383 243.597L588.098 247.987L582.932 256.252L575.959 251.862L581.383 243.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M570.02 261.675L576.218 265.808L582.417 255.993L576.476 252.119L570.02 261.675Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M576.217 240.497L581.382 243.596L575.7 252.12L569.76 248.245C570.621 246.351 572.498 242.253 573.117 241.014C573.737 239.774 575.442 240.153 576.217 240.497Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M566.145 255.477L569.761 248.245L576.218 252.378L570.019 261.676L565.887 258.835C565.06 257.801 565.715 256.166 566.145 255.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M485.562 351.298L469.549 342.775L480.655 335.285L489.436 348.457L485.562 351.298Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M488.919 329.861L480.654 335.285L489.436 348.457L497.701 343.033L488.919 329.861Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M506.225 337.351L497.701 343.033L488.92 329.861L497.701 323.921L506.225 337.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M514.748 331.669L506.224 337.351L497.701 323.92L505.966 318.238L514.748 331.669Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M521.203 327.537L514.746 331.669L505.965 318.239L510.356 314.623L524.303 321.855L521.203 327.537Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M528.953 312.557L524.304 321.855L510.357 314.623L514.748 305.325L528.953 312.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M533.602 303.516L528.953 312.556L514.748 305.324L519.139 296.543L533.602 303.516Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M537.993 294.477L533.602 303.517L519.139 296.543L523.529 287.245L537.993 294.477Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M542.9 285.437L537.993 294.477L523.529 287.245L528.178 277.947L542.9 285.437Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M547.29 276.139L542.9 285.437L528.178 277.947L532.827 268.649L547.29 276.139Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M551.68 266.841L547.29 276.139L532.826 268.649L537.217 259.609L551.68 266.841Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M556.329 257.802L551.68 266.842L537.217 259.352L541.866 250.054L556.329 257.802Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M560.721 248.762L556.331 257.802L541.867 250.053L546.258 241.53L560.721 248.762Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M661.451 273.815L643.113 274.848L647.504 266.066L661.451 273.815Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.623 273.556L661.451 273.815L660.418 273.04L665.584 264.517L676.431 270.715C676.638 272.575 675.312 273.384 674.623 273.556Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M658.351 260.384L665.583 264.516L660.417 273.298L653.186 269.424L658.351 260.384Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M651.12 256.51L658.352 260.384L653.186 269.424L646.213 265.291L651.12 256.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M635.105 270.457L643.112 274.848L647.503 266.067L640.013 261.676L635.105 270.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.875 266.325L635.107 270.457L640.014 261.676L633.041 257.802L627.875 266.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M639.238 261.159L644.146 252.636L651.075 256.485L646.212 265.291L639.238 261.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
        />
        <path
          d="M651.119 256.51L651.075 256.485M651.075 256.485L644.146 252.636L639.238 261.159L646.212 265.291L651.075 256.485Z"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M636.915 248.504L644.147 252.636L639.24 261.16L632.008 257.027L636.915 248.504Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.941 244.371L636.914 248.504L632.007 257.027L624.775 252.894L629.941 244.371Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M622.968 240.238L629.942 244.371L624.776 252.894L617.803 248.761L622.968 240.238Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M615.996 236.106L622.969 240.239L617.804 248.762L610.83 244.371L615.996 236.106Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.02 231.716L615.993 236.107L610.827 244.371L603.596 240.239L609.02 231.716Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M620.385 261.934L627.875 266.325L633.04 257.544L625.55 253.411L620.385 261.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M613.152 257.285L620.384 261.934L625.55 253.411L618.318 249.021L613.152 257.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.922 252.895L613.154 257.285L618.319 249.021L611.087 244.63L605.922 252.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M598.432 248.503L605.922 252.894L610.829 244.371L603.597 240.238L598.432 248.503Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M591.457 243.854L598.431 248.503L603.596 240.238L596.623 235.848L591.457 243.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M583.967 239.206L591.457 243.855L596.622 235.848L589.391 231.199L583.967 239.206Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M578.544 235.59L583.968 239.206L589.392 231.199L582.935 226.809L578.544 232.491C577.718 234.144 578.2 235.246 578.544 235.59Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M602.305 227.325L609.02 231.716L603.597 240.239L596.623 235.848L602.305 227.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M595.333 222.935L602.306 227.325L596.624 235.848L589.65 231.199L595.333 222.935Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M590.94 220.093L595.331 222.934L589.391 231.199L582.934 226.808L587.841 220.093C588.874 219.06 590.165 219.662 590.94 220.093Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M640.012 312.299L633.814 319.272L624.516 311.524L637.688 309.199C640.374 309.612 640.357 311.438 640.012 312.299Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M628.907 324.954L633.815 319.272L624.258 311.523L619.609 316.689L628.907 324.954Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M624.257 330.12L628.906 324.954L619.608 316.689L614.959 321.855L624.257 330.12Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.145 315.656L624.257 311.523L613.668 323.146L605.145 315.656Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.536 328.054L613.668 323.146L605.145 315.656L597.396 317.464L609.536 328.054Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.35 335.544L624.258 330.12L614.96 321.855L610.311 327.279L619.35 335.544Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M616.509 339.159L619.35 335.543L610.311 327.278L604.887 333.477C607.297 334.941 612.48 338.074 613.926 338.901C615.373 339.727 616.251 339.417 616.509 339.159Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.105 328.054L604.887 333.477L609.536 328.054L600.754 320.563L596.105 328.054Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M588.873 319.788L597.396 317.464L600.754 320.563L596.105 328.053L587.84 322.888C587.22 321.235 588.27 320.133 588.873 319.788Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M700.451 320.305C699.004 320.099 695.199 318.153 693.477 317.206L688.828 322.372L696.835 329.087L702.775 322.113C702.603 321.597 701.897 320.512 700.451 320.305Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M686.502 312.557C687.155 313.21 691.323 316.001 693.475 317.206L687.277 323.921L680.045 317.722L684.694 312.299C685.124 312.04 685.985 312.04 686.502 312.557Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M691.153 335.285L696.835 329.086L688.828 322.371L683.404 328.57L691.153 335.285Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M685.987 341.226L691.152 335.286L683.404 328.57L678.238 334.511L685.987 341.226Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.881 323.663L680.046 317.723L687.278 323.921L682.113 329.862L674.881 323.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M669.455 329.862L674.879 323.663L682.111 329.862L676.687 336.319L669.455 329.862Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M680.821 347.425L685.987 341.226L678.238 334.511L672.814 340.709L680.821 347.425Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M675.655 353.623L680.821 347.424L672.814 340.709L667.648 346.391L675.655 353.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M663.775 336.06L669.458 329.861L676.689 336.318L671.007 342.517L663.775 336.06Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M658.35 342.259L663.773 336.061L671.005 342.517L665.323 348.716L658.35 342.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M669.973 359.822L675.655 353.623L667.648 346.392L662.225 352.849L669.973 359.822Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M653.186 348.457L658.351 342.259L665.583 348.974L660.159 355.173L653.186 348.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M664.55 366.021L669.973 359.822L662.225 352.849L656.543 359.306L664.55 366.021Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M659.383 371.703L664.549 366.021L656.542 359.306L651.635 364.988L659.383 371.703Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M647.762 354.915L653.186 348.458L660.159 355.173L654.993 361.114L647.762 354.915Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M642.336 361.114L647.76 354.915L654.992 361.114L649.568 367.571L642.336 361.114Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M653.959 377.901L659.383 371.702L651.635 365.245L646.211 371.186L653.959 377.901Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M650.085 382.551L653.96 377.902L646.211 371.187L639.496 378.418L650.085 382.551Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M636.656 367.312L642.338 361.113L649.312 367.57L643.888 373.769L636.656 367.312Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M630.973 373.768L636.655 367.312L643.887 373.768L639.496 378.417L631.231 374.802L630.973 373.768Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M700.449 280.271H688.31L686.502 282.596L694.25 289.569L700.707 282.338C701.12 281.098 700.707 280.444 700.449 280.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.881 280.271H688.311L680.305 289.569L672.814 282.854L674.881 280.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M689.085 295.51L694.25 289.569L686.502 282.596L681.078 288.536L689.085 295.51Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M683.92 301.45L689.086 295.51L681.079 288.536L676.172 294.477L683.92 301.45Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M667.391 289.053L672.814 282.854L680.305 289.57L675.139 295.51L667.391 289.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M678.755 307.39L683.92 301.45L676.172 294.477L670.748 300.675L678.755 307.39Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M662.227 294.735L667.392 289.053L675.14 295.51L669.717 301.708L662.227 294.735Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M673.59 313.073L678.756 307.391L670.749 300.676L665.842 306.616L673.59 313.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M657.059 300.934L662.224 294.735L669.714 301.709L664.807 307.908L657.059 300.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M668.423 319.271L673.588 313.072L665.84 306.615L660.416 312.297L668.423 319.271Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M663 325.212L668.424 319.271L660.418 312.298L655.252 318.497L663 325.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M651.893 306.874L657.058 300.934L664.548 307.907L659.124 313.589L651.893 306.874Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M646.471 313.073L651.895 306.874L659.126 313.848L654.219 319.788L646.471 313.073Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M658.091 331.411L662.998 325.212L655.25 318.497L649.826 324.437L658.091 331.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M652.927 337.35L658.093 331.41L649.828 324.437L644.662 330.119L652.927 337.35Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M641.305 319.013L646.47 313.072L653.96 319.787L648.536 325.728L641.305 319.013Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M635.881 325.212L641.305 319.014L648.536 325.729L643.371 331.669L635.881 325.212Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M647.761 343.033L652.927 337.351L644.662 330.119L639.496 336.06L647.761 343.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M630.715 330.894L635.88 325.212L643.37 331.669L637.947 337.609L630.715 330.894Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M642.595 348.973L647.761 343.033L639.496 336.06L634.33 342L642.595 348.973Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M625.551 336.834L630.716 330.894L637.948 337.609L632.783 343.549L625.551 336.834Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M637.431 354.914L642.596 348.974L634.332 342L629.166 347.94L637.431 354.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M620.127 343.033L625.551 336.834L632.783 343.807L627.359 350.006L620.127 343.033Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M632.007 360.854L637.43 354.914L629.166 347.94L624 353.881L632.007 360.854Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.1 366.536L632.008 360.854L624.001 353.881L619.094 359.563L627.1 366.536Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M614.961 348.974L620.126 343.033L627.358 350.007L622.193 355.947L614.961 348.974Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M609.537 354.914L614.961 348.974L622.193 355.947L617.285 361.888L609.537 354.914Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M622.967 371.185L627.099 366.536L619.093 359.562L613.152 367.053L622.967 371.185Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M604.629 362.921L613.152 367.053L617.285 361.888L609.536 354.914L604.371 360.854C603.957 361.888 604.371 362.662 604.629 362.921Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M648.537 303L657.835 291.895L644.404 292.928L645.437 303.259L648.537 303Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M664.292 284.663L657.835 291.895L654.735 292.153L654.219 282.08L662.742 281.047C665.015 281.667 664.722 283.716 664.292 284.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M645.695 282.855L654.218 282.08L654.735 292.153L646.47 292.669L645.695 282.855Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M637.432 283.888L645.697 282.854L646.471 292.669L638.465 293.702L637.432 283.888Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.166 285.179L637.431 283.888L638.464 293.702L630.457 294.994L629.166 285.179Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M637.43 304.292L645.437 303.259L644.404 292.928L636.139 293.961L637.43 304.292Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.683 305.583L637.431 304.292L636.14 293.961L627.875 295.511L629.683 305.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M621.158 286.471L629.165 285.18L630.456 294.994L622.708 296.544L621.158 286.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M621.417 307.132L629.682 305.583L627.874 295.51L619.609 297.059L621.417 307.132Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M613.152 288.02L621.159 286.471L622.709 296.544L614.702 297.835L613.152 288.02Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M613.67 308.424L621.418 307.132L619.61 297.06L611.604 298.609L613.67 308.424Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M604.889 289.57L613.154 288.021L614.703 298.093L606.955 299.643L604.889 289.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M605.922 310.232L613.67 308.424L611.604 298.609L603.855 300.417L605.922 310.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.881 291.378L604.887 289.57L606.954 299.643L599.205 301.451L596.881 291.378Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M598.43 312.04L605.92 310.233L603.854 300.418L595.848 302.226L598.43 312.04Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M588.617 293.444L596.882 291.378L599.207 301.451L591.2 303.259L588.617 293.444Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M580.867 295.769L588.616 293.444L591.198 303.259L583.45 305.583L580.867 295.769Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M589.909 314.365L598.432 312.04L595.849 302.226L587.326 304.292L589.909 314.365Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M582.676 316.431L589.907 314.365L587.325 304.292L579.576 306.616L582.676 316.431Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M572.861 298.351L580.868 295.769L583.451 305.583L575.702 307.908L572.861 298.351Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M574.928 319.014L582.676 316.431L579.577 306.616L571.57 309.199L574.928 319.014Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M567.178 321.597L574.926 319.014L571.569 309.199L563.82 311.782L567.178 321.597Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M565.113 300.934L572.862 298.352L575.703 307.908L568.213 310.232L565.113 300.934Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M557.363 303.776L565.112 300.935L568.211 310.233L560.463 313.074L557.363 303.776Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M559.69 324.438L567.18 321.597L563.823 311.782L556.074 314.623L559.69 324.438Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M549.617 306.616L557.366 303.775L560.465 313.073L552.975 315.914L549.617 306.616Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M552.458 327.279L559.69 324.438L556.074 314.623L548.584 317.722L552.458 327.279Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M541.867 309.457L549.616 306.616L552.973 315.914L545.483 319.014L541.867 309.457Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M548.325 329.086L552.457 327.278L548.583 317.722L538.252 322.112L548.325 329.086Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M538.769 310.49L541.868 309.457L545.484 319.013L538.252 322.113L534.895 319.272L535.153 317.205L538.769 310.49Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M684.955 420.517L697.611 413.544L684.439 409.928L681.598 419.484L684.955 420.517Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M707.682 408.637L697.61 413.544L695.285 412.769L697.868 402.696L707.941 405.279C708.974 406.725 708.199 408.12 707.682 408.637Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M690.12 400.63L697.868 402.696L695.285 412.769L687.537 410.703L690.12 400.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M682.63 398.563L690.12 400.63L687.537 410.703L679.789 408.378L682.63 398.563Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M673.59 417.16L681.596 419.484L684.438 409.928L676.689 407.604L673.59 417.16Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M674.881 396.239L682.629 398.564L679.788 408.378L671.781 406.054L674.881 396.239Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M665.584 414.577L673.591 417.16L676.69 407.603L668.942 405.021L665.584 414.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M667.133 393.915L674.881 396.24L671.782 406.054L664.033 403.471L667.133 393.915Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M657.834 411.994L665.582 414.577L668.94 405.02L661.192 402.438L657.834 411.994Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M659.384 391.332L667.133 393.915L664.033 403.471L656.285 400.63L659.384 391.332Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M650.088 409.411L657.836 411.994L661.194 402.437L653.704 399.854L650.088 409.411Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M652.153 388.749L659.384 391.332L656.285 400.63L648.795 398.047L652.153 388.749Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M642.08 406.57L650.087 409.411L653.703 399.855L645.954 397.014L642.08 406.57Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M644.663 385.908L652.153 388.749L648.795 398.047L641.047 395.206L644.663 385.908Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M634.59 403.729L642.08 406.57L645.954 397.014L638.464 394.173L634.59 403.729Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M627.1 400.63L634.59 403.729L638.464 394.173L631.232 391.332L627.1 400.63Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M637.173 383.066L644.663 385.907L641.047 395.205L633.299 392.106L637.173 383.066Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M629.683 379.968L637.173 383.067L633.299 392.107L625.809 389.007L629.683 379.968Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M619.352 397.272L627.1 400.63L631.232 391.332L623.742 388.232L619.352 397.272Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M622.193 376.868L629.683 379.967L625.808 389.007L618.318 385.908L622.193 376.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M611.861 393.915L619.351 397.272L623.742 388.233L615.994 384.875L611.861 393.915Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M615.219 373.511L622.192 376.868L618.318 385.908L610.828 382.292L615.219 373.511Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M604.629 390.816L611.861 393.915L615.993 384.875L609.02 381.518L604.629 390.816Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M607.728 369.895L615.218 373.51L610.827 382.292L603.596 378.676L607.728 369.895Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M596.883 387.199L604.631 390.815L609.022 381.517L601.79 377.901L596.883 387.199Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M600.496 366.278L607.728 369.894L603.596 378.676L596.105 375.06L600.496 366.278Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M589.393 383.583L596.883 387.199L601.79 377.901L594.558 374.285L589.393 383.583Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M582.16 379.709L589.392 383.583L594.557 374.285L587.326 370.411L582.16 379.709Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M593.524 362.663L600.497 366.279L596.106 375.06L589.133 371.186L593.524 362.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M586.293 358.789L593.525 362.663L589.134 371.186L581.902 367.312L586.293 358.789Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M579.577 354.915L586.292 358.789L581.902 367.312L574.67 363.18L579.577 354.915Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M567.697 371.186L574.929 375.576L580.353 366.537L573.121 362.404L567.697 371.186Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M574.928 375.577L582.16 379.709L587.325 370.153L580.352 366.537L574.928 375.577Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M560.98 367.053L567.696 371.186L573.12 362.404L566.146 358.53L560.98 367.053Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M572.603 350.782L579.577 354.915L574.669 363.18L567.438 359.047L572.603 350.782Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M565.63 346.392L572.604 350.782L567.18 359.047L560.465 355.173L565.63 346.392Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M553.75 362.663L560.982 367.054L566.147 358.531L559.174 354.398L553.75 362.663Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M546.775 358.273L553.749 362.663L559.173 354.399L552.199 350.008L546.775 358.273Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M558.656 342.259L565.629 346.391L560.464 355.173L553.49 350.782L558.656 342.259Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M552.199 337.868L558.656 342.259L553.491 350.782L546.775 346.391L552.199 337.868Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M540.061 353.623L546.776 358.272L552.2 350.007L545.484 345.616L540.061 353.623Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M545.484 333.478L552.2 337.868L546.776 346.391L540.061 341.742L545.484 333.478Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M533.604 349.232L540.06 353.623L545.484 345.616L539.027 341.226L533.604 349.232Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M539.028 328.828L545.485 333.477L540.061 341.742L533.088 337.093L539.028 328.828Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M526.371 344.325L533.603 349.233L539.027 341.226L532.311 336.577L526.371 344.325Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M534.637 325.471L539.027 328.828L533.087 337.093L527.146 332.703C527.663 332.186 529.471 329.087 530.504 326.504C531.331 324.438 533.603 324.954 534.637 325.471Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <path
          d="M520.432 340.451L526.372 344.326L532.312 336.577L527.146 332.703C525.855 334.511 522.239 336.061 520.69 337.352C519.45 338.385 520.001 339.849 520.432 340.451Z"
          fill="#0096B3"
          fill-opacity="0.64"
          stroke="#6D6859"
          stroke-opacity="0.6"
        />
        <defs>
          <pattern
            id="pattern0_481_5034"
            patternContentUnits="objectBoundingBox"
            width="1"
            height="1"
          >
            <use
              href="#image0_481_5034"
              transform="matrix(0.000244141 0 0 0.000434302 0 -0.000316114)"
            />
          </pattern>
          <image
            id="image0_481_5034"
            width="4096"
            height="2304"
            href="/background-cluster2.png"
          />
        </defs>
      </svg> */}
    </div>
  );
};

export default Cluster2;
/*
<image
          id="image0_1462_13825"
          width="4096"
          height="2304"
          href="/background-cluster2.png"
        />
*/
